(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["health-signal-quiz-cro"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll("[data-health-signal-quiz]");
    if (!roots.length) {
      return;
    }

    var questions = [
      {
        id: "goal",
        label: "Goal",
        title: "What made you curious about this quiz?",
        context: "Choose the answer that sounds most like you right now.",
        options: [
          { text: "I wake up tired even when I sleep enough", scores: { sleep: 2 } },
          { text: "Stress has been harder to shake lately", scores: { stress: 2 } },
          { text: "My recovery feels slower than it used to", scores: { recovery: 2 } },
          { text: "I want to keep an eye on long-term health", scores: { aging: 2 } },
          { text: "I already track data but do not know what it means", scores: { data: 2 } },
          { text: "I am trying to build a better routine", scores: { habit: 2 } }
        ]
      },
      {
        id: "routine",
        label: "Routine",
        title: "What would be most useful to know tomorrow morning?",
        context: "Hume is designed to connect signals, not just show isolated numbers.",
        options: [
          { text: "Whether my sleep actually helped me recover", scores: { sleep: 2 } },
          { text: "Whether stress is building up", scores: { stress: 2 } },
          { text: "Whether I should push or take it easier", scores: { recovery: 2 } },
          { text: "Which habit affected me most yesterday", scores: { habit: 2 } },
          { text: "Whether my long-term health trends are improving", scores: { aging: 2 } },
          { text: "Whether my current tracker is giving me enough context", scores: { data: 2 } }
        ]
      },
      {
        id: "sleep",
        label: "Sleep",
        title: "How consistent has your sleep felt recently?",
        context: "Sleep quality and consistency can shape how ready you feel the next day.",
        options: [
          { text: "Pretty consistent", scores: {} },
          { text: "Enough hours, but I still feel tired", scores: { sleep: 3 } },
          { text: "Good some nights, poor other nights", scores: { sleep: 2, stress: 1 } },
          { text: "I rarely know because I do not track it closely", scores: { sleep: 2, data: 1 } }
        ]
      },
      {
        id: "stress",
        label: "Stress",
        title: "How does stress usually show up for you?",
        context: "Stress patterns can show up before they feel obvious.",
        options: [
          { text: "I feel wired at night", scores: { stress: 3, sleep: 1 } },
          { text: "I feel tired but restless", scores: { stress: 2, recovery: 1 } },
          { text: "I do not notice until I crash", scores: { stress: 3, recovery: 1 } },
          { text: "I mostly feel fine", scores: { aging: 1 } },
          { text: "I am not sure", scores: { data: 2 } }
        ]
      },
      {
        id: "recovery",
        label: "Recovery",
        title: "When your body feels off, what do you usually do?",
        context: "This helps identify whether your result should focus on push-versus-rest guidance.",
        options: [
          { text: "Push through anyway", scores: { recovery: 3 } },
          { text: "Take an easier day", scores: { recovery: 1, habit: 1 } },
          { text: "Check my wearable", scores: { data: 2 } },
          { text: "Guess based on mood", scores: { data: 2, recovery: 1 } },
          { text: "Ignore it unless it gets worse", scores: { aging: 2, stress: 1 } }
        ]
      },
      {
        id: "heart_trends",
        label: "Heart trends",
        title: "Which signal do you currently pay the least attention to?",
        context: "This quiz is about wellness trends over time, not medical diagnosis.",
        options: [
          { text: "Sleep quality", scores: { sleep: 3 } },
          { text: "Stress load", scores: { stress: 3 } },
          { text: "Recovery", scores: { recovery: 3 } },
          { text: "Blood pressure trends", scores: { heart: 3 } },
          { text: "Long-term health trends", scores: { aging: 3 } },
          { text: "I do not know which one matters", scores: { data: 3 } }
        ]
      },
      {
        id: "wearable",
        label: "Wearable",
        title: "Do you currently use a wearable?",
        context: "This helps us understand whether your biggest gap is measurement or interpretation.",
        options: [
          { text: "Apple Watch", scores: { data: 2 }, wearable: "Apple Watch" },
          { text: "Oura", scores: { data: 2 }, wearable: "Oura" },
          { text: "WHOOP", scores: { data: 2 }, wearable: "WHOOP" },
          { text: "Garmin or Fitbit", scores: { data: 2 }, wearable: "Garmin or Fitbit" },
          { text: "Another tracker", scores: { data: 2 }, wearable: "another tracker" },
          { text: "Nothing consistently", scores: { habit: 2 }, wearable: "no consistent tracker" }
        ]
      },
      {
        id: "guidance",
        label: "Guidance",
        title: "What frustrates you most about health tracking?",
        context: "Your answer helps shape the Hume Band 2.0 recommendation on the result page.",
        options: [
          { text: "Too many numbers", scores: { data: 3 }, objection: "too many numbers" },
          { text: "Not enough guidance", scores: { data: 3 }, objection: "not enough guidance" },
          { text: "Battery or charging", scores: { habit: 1 }, objection: "battery or charging" },
          { text: "Subscription costs", scores: { data: 1 }, objection: "subscription costs" },
          { text: "I do not trust one-off readings", scores: { data: 1 }, objection: "accuracy" },
          { text: "I have not found one I stick with", scores: { habit: 3 }, objection: "consistency" }
        ]
      },
      {
        id: "feedback",
        label: "Result",
        title: "What kind of feedback would help you act?",
        context: "Last question. We will connect your answers into a focus signal next.",
        options: [
          { text: "A simple daily summary", scores: { habit: 2 } },
          { text: "A weekly trend report", scores: { aging: 2 } },
          { text: "Plain-English coaching", scores: { data: 2 } },
          { text: "Deeper metrics I can explore", scores: { data: 1, heart: 1 } },
          { text: "A reminder of what to focus on first", scores: { habit: 2 } }
        ]
      }
    ];

    var results = {
      sleep: {
        title: "Sleep Consistency Gap",
        signal: "Sleep consistency",
        summary: "Your answers suggest your sleep may be affecting recovery, energy, or readiness more than total hours alone can explain.",
        missing: ["Sleep quality", "Night-to-night consistency", "How sleep affects next-day recovery"],
        features: ["Sleep stages and sleep quality", "Recovery trends", "HRV context", "Weekly reports"],
        insight: "Your sleep duration looked normal, but recovery trended lower after two inconsistent nights. Watch the pattern before changing everything.",
        bridgeTitle: "Track the sleep pattern behind your energy.",
        bridgeCopy: "Hume Band 2.0 connects sleep quality, HRV, recovery, and daily habits so you can see whether inconsistent nights may be affecting how you feel over time."
      },
      stress: {
        title: "Stress Load Builder",
        signal: "Stress load",
        summary: "Your answers suggest stress may be showing up through sleep, energy, or recovery before it feels obvious.",
        missing: ["HRV changes", "Resting heart trends", "Recovery dips after demanding days"],
        features: ["HRV and recovery tracking", "Resting heart trend context", "Stress pattern summaries", "Plain-English app insights"],
        insight: "Your recovery dipped on high-demand days even when activity was normal. Stress load may be the signal to watch first.",
        bridgeTitle: "See stress as a pattern, not a guess.",
        bridgeCopy: "Hume Band 2.0 brings sleep, HRV, resting heart trends, and recovery together so you can understand when stress may be affecting your daily readiness."
      },
      recovery: {
        title: "Recovery Blind Spot",
        signal: "Recovery",
        summary: "Your answers suggest you may not always know when your body is ready to push and when it needs an easier day.",
        missing: ["Recovery status", "HRV and strain context", "Sleep debt", "Push-versus-rest signals"],
        features: ["Recovery trend tracking", "HRV", "Strain and activity context", "Sleep connection"],
        insight: "Your activity was steady, but recovery lagged after poor sleep. An easier day may protect consistency better than pushing through.",
        bridgeTitle: "Turn recovery data into daily direction.",
        bridgeCopy: "Hume Band 2.0 helps connect recovery, sleep, strain, and heart-rate trends so you can make more informed decisions about when to push and when to ease up."
      },
      heart: {
        title: "Heart Trend Awareness",
        signal: "Heart trends",
        summary: "Your answers suggest you want more visibility into heart-related wellness trends between check-ins.",
        missing: ["Blood pressure trends", "HRV patterns", "Resting heart changes over time"],
        features: ["Blood pressure insights", "HRV and resting heart rate", "Recovery changes", "Long-term trend summaries"],
        insight: "One reading is not the full story. Hume helps you watch wellness trends over time so you can notice patterns worth paying attention to.",
        bridgeTitle: "Follow heart-related wellness trends over time.",
        bridgeCopy: "Hume Band 2.0 helps you monitor heart-rate, HRV, recovery, and blood-pressure wellness insights together so unusual patterns are easier to discuss and understand."
      },
      aging: {
        title: "Aging Momentum Gap",
        signal: "Long-term health trends",
        summary: "Your answers suggest you care less about today's step count and more about whether your habits are supporting long-term wellness direction.",
        missing: ["Long-term trend direction", "How habits affect recovery and aging momentum", "Weekly progress context"],
        features: ["Pace of Aging", "Metabolic Momentum", "Health Score", "Weekly reports"],
        insight: "Your daily choices become easier to understand when you can see the trend, not just a single day of data.",
        bridgeTitle: "Watch whether your habits are moving the trend.",
        bridgeCopy: "Hume Band 2.0 is built to connect daily behavior with longer-term wellness signals like Health Score, metabolic momentum, recovery, and weekly trend direction."
      },
      data: {
        title: "Data Without Direction",
        signal: "Metric connection",
        summary: "Your answers suggest you may already have data, but not enough interpretation about what to focus on next.",
        missing: ["How sleep, stress, recovery, and activity connect", "Plain-English summaries", "A daily focus point"],
        features: ["AI insights", "Health Score", "Weekly reports", "Sleep, stress, and recovery connection"],
        insight: "Your tracker can show what happened. Hume is built to help explain which signal deserves attention next.",
        bridgeTitle: "Move from metrics to meaning.",
        bridgeCopy: "Hume Band 2.0 connects sleep, stress, recovery, activity, and heart trends so your wearable data can become clearer daily direction."
      },
      habit: {
        title: "Habit Feedback Gap",
        signal: "Habit feedback",
        summary: "Your answers suggest you want to build a healthier routine, but need clearer feedback on which habits are actually helping.",
        missing: ["Which habits move your trends", "Simple daily feedback", "Weekly accountability"],
        features: ["Health Score", "Activity and sleep trends", "Weekly reports", "Optional AI coaching"],
        insight: "Small habits are easier to keep when you can see which ones are moving your wellness trends in the right direction.",
        bridgeTitle: "See which habits may be helping.",
        bridgeCopy: "Hume Band 2.0 brings activity, sleep, recovery, and Health Score into one app so habit changes are easier to connect with your wellness trends."
      }
    };

    function setupQuiz(root) {
      var state = {
        step: -1,
        scores: { sleep: 0, stress: 0, recovery: 0, heart: 0, aging: 0, data: 0, habit: 0 },
        answers: [],
        answerIds: [],
        wearable: "",
        objection: "",
        startedAt: 0,
        completedAt: 0,
        isTransitioning: false
      };

      var startPanel = root.querySelector("[data-hsq-start]");
      var questionPanel = root.querySelector("[data-hsq-question]");
      var analyzingPanel = root.querySelector("[data-hsq-analyzing]");
      var resultPanel = root.querySelector("[data-hsq-result]");
      var progress = root.querySelector("[data-hsq-progress]");
      var progressBar = root.querySelector("[data-hsq-progress-bar]");
      var progressCount = root.querySelector("[data-hsq-progress-count]");
      var stepLabel = root.querySelector("[data-hsq-step-label]");
      var questionIndex = root.querySelector("[data-hsq-question-index]");
      var questionTitle = root.querySelector("[data-hsq-question-title]");
      var questionContext = root.querySelector("[data-hsq-question-context]");
      var optionsWrap = root.querySelector("[data-hsq-options]");
      var backButton = root.querySelector("[data-hsq-back]");

      function publish(eventName, detail) {
        var payload = Object.assign({
          quiz_id: "hume_band_health_signal_quiz",
          quiz_version: root.getAttribute("data-quiz-version") || "unknown",
          page_path: window.location.pathname,
          device_type: window.matchMedia("(max-width: 820px)").matches ? "mobile" : "desktop"
        }, detail || {});
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: eventName, health_signal_quiz: payload });
        root.dispatchEvent(new CustomEvent(eventName, { detail: payload, bubbles: true }));
      }

      function updateProgress() {
        var complete = state.step < 0 ? 0 : Math.min(questions.length, state.step + 1);
        var percent = state.step < 0 ? 0 : ((state.step + 1) / questions.length) * 100;
        progressBar.style.width = Math.min(100, percent) + "%";
        progress.setAttribute("aria-valuenow", String(Math.round(Math.min(100, percent))));
        progressCount.textContent = state.step < 0 ? "9 questions · about 60 seconds" : "Question " + complete + " of " + questions.length;
        stepLabel.textContent = state.step >= 0 && questions[state.step] ? questions[state.step].label : "Start";
        backButton.hidden = state.step <= 0;
      }

      function resetScoreState() {
        state.scores = { sleep: 0, stress: 0, recovery: 0, heart: 0, aging: 0, data: 0, habit: 0 };
        state.wearable = "";
        state.objection = "";
        state.answers.forEach(function (answerText, index) {
          var question = questions[index];
          if (!question) {
            return;
          }
          var option = question.options.find(function (candidate) {
            return candidate.text === answerText;
          });
          if (!option) {
            return;
          }
          Object.keys(option.scores).forEach(function (key) {
            state.scores[key] += option.scores[key];
          });
          if (option.wearable) {
            state.wearable = option.wearable;
          }
          if (option.objection) {
            state.objection = option.objection;
          }
        });
      }

      function recordAnswer(question, option, optionIndex) {
        state.answers[state.step] = option.text;
        state.answerIds[state.step] = question.id + "_" + (optionIndex + 1);
        state.answers = state.answers.slice(0, state.step + 1);
        state.answerIds = state.answerIds.slice(0, state.step + 1);
        resetScoreState();
      }

      function showQuestion(index) {
        if (state.isTransitioning) {
          return;
        }
        state.step = index;
        updateProgress();
        startPanel.hidden = true;
        analyzingPanel.hidden = true;
        resultPanel.hidden = true;
        questionPanel.hidden = false;
        var question = questions[index];
        questionIndex.textContent = "Question " + (index + 1) + " of " + questions.length;
        questionTitle.textContent = question.title;
        questionContext.textContent = question.context || "";
        optionsWrap.innerHTML = "";
        question.options.forEach(function (option, optionIndex) {
          var button = document.createElement("button");
          button.type = "button";
          button.className = "hsq-option";
          button.textContent = option.text;
          button.setAttribute("aria-pressed", state.answers[index] === option.text ? "true" : "false");
          if (state.answers[index] === option.text) {
            button.classList.add("is-selected");
          }
          button.addEventListener("click", function () {
            if (state.isTransitioning) {
              return;
            }
            state.isTransitioning = true;
            Array.prototype.forEach.call(optionsWrap.querySelectorAll(".hsq-option"), function (optionButton) {
              optionButton.disabled = true;
              optionButton.setAttribute("aria-pressed", "false");
            });
            button.classList.add("is-selected");
            button.setAttribute("aria-pressed", "true");
            recordAnswer(question, option, optionIndex);
            publish("band_signal_quiz_question_answered", {
              question_id: question.id,
              answer_id: state.answerIds[index],
              question_number: index + 1,
              funnel_step: "question"
            });
            window.setTimeout(function () {
              state.isTransitioning = false;
              if (index + 1 < questions.length) {
                showQuestion(index + 1);
              } else {
                showAnalyzing();
              }
            }, 180);
          });
          optionsWrap.appendChild(button);
        });
        publish("band_signal_quiz_question_viewed", {
          question_id: question.id,
          question_number: index + 1,
          funnel_step: "question"
        });
      }

      function getWinner() {
        var winner = "sleep";
        Object.keys(state.scores).forEach(function (key) {
          if (state.scores[key] > state.scores[winner]) {
            winner = key;
          }
        });
        if (state.wearable && state.wearable !== "no consistent tracker") {
          var dataScore = state.scores.data;
          if (dataScore >= state.scores[winner] - 1) {
            winner = "data";
          }
        }
        return winner;
      }

      function fillList(selector, items) {
        var target = root.querySelector(selector);
        target.innerHTML = "";
        items.forEach(function (item) {
          var li = document.createElement("li");
          li.textContent = item;
          target.appendChild(li);
        });
      }

      function slug(value) {
        return String(value || "unknown").toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
      }

      function getCtaUrl(result) {
        var base = root.getAttribute("data-cta-url") || "https://humehealth.com/pages/hume-bandv2";
        var separator = base.indexOf("?") === -1 ? "?" : "&";
        var params = [
          ["utm_source", "thewearabletech"],
          ["utm_medium", "quiz"],
          ["utm_campaign", "health_signal_quiz"],
          ["utm_content", slug(result.title)],
          ["utm_term", slug(result.signal)],
          ["quiz_result", slug(result.title)],
          ["quiz_signal", slug(result.signal)],
          ["quiz_wearable", slug(state.wearable)],
          ["quiz_objection", slug(state.objection)]
        ];
        return base + separator + params.map(function (pair) {
          return encodeURIComponent(pair[0]) + "=" + encodeURIComponent(pair[1]);
        }).join("&");
      }

      function showAnalyzing() {
        questionPanel.hidden = true;
        resultPanel.hidden = true;
        analyzingPanel.hidden = false;
        progressBar.style.width = "96%";
        progress.setAttribute("aria-valuenow", "96");
        progressCount.textContent = "Preparing result";
        stepLabel.textContent = "Analyzing";
        window.setTimeout(showResult, 520);
      }

      function showResult() {
        var winner = getWinner();
        var result = results[winner];
        state.completedAt = Date.now();
        analyzingPanel.hidden = true;
        questionPanel.hidden = true;
        resultPanel.hidden = false;
        progressBar.style.width = "100%";
        progress.setAttribute("aria-valuenow", "100");
        progressCount.textContent = questions.length + " of " + questions.length;
        stepLabel.textContent = "Result";

        root.querySelector("[data-hsq-result-title]").textContent = result.title;
        root.querySelector("[data-hsq-result-signal]").textContent = result.signal;
        root.querySelector("[data-hsq-result-summary]").textContent = result.summary;
        root.querySelector("[data-hsq-insight]").textContent = result.insight;
        root.querySelector("[data-hsq-result-cta]").setAttribute("href", getCtaUrl(result));
        root.querySelector("[data-hsq-bridge-title]").textContent = result.bridgeTitle;
        root.querySelector("[data-hsq-bridge-copy]").textContent = result.bridgeCopy;
        fillList("[data-hsq-missing]", result.missing);
        fillList("[data-hsq-features]", result.features);

        var recap = root.querySelector("[data-hsq-recap]");
        recap.innerHTML = "";
        state.answers.slice(0, 3).forEach(function (answer) {
          var span = document.createElement("span");
          span.textContent = answer;
          recap.appendChild(span);
        });

        publish("band_signal_quiz_completed", {
          result_type: winner,
          result: result.title,
          signal: result.signal,
          wearable: state.wearable,
          objection: state.objection,
          cta_url: getCtaUrl(result),
          completion_seconds: state.startedAt ? Math.round((state.completedAt - state.startedAt) / 1000) : null,
          scores: state.scores,
          funnel_step: "result"
        });
      }

      function goBack() {
        if (state.isTransitioning || state.step <= 0) {
          return;
        }
        publish("band_signal_quiz_back_clicked", {
          from_question_number: state.step + 1,
          to_question_number: state.step,
          funnel_step: "question"
        });
        showQuestion(state.step - 1);
      }

      root.querySelector("[data-hsq-result-cta]").addEventListener("click", function () {
        var winner = getWinner();
        publish("band_signal_quiz_product_cta_clicked", {
          result_type: winner,
          cta_location: "result",
          cta_url: getCtaUrl(results[winner]),
          funnel_step: "pdp_handoff"
        });
      });

      root.querySelector("[data-hsq-start-button]").addEventListener("click", function () {
        state.startedAt = Date.now();
        publish("band_signal_quiz_started", {
          funnel_step: "start"
        });
        showQuestion(0);
      });

      backButton.addEventListener("click", goBack);

      updateProgress();
    }

    roots.forEach(setupQuiz);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["health-signal-quiz-final"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll("[data-health-signal-quiz]");
    if (!roots.length) {
      return;
    }

    var questions = [
      {
        id: "goal",
        label: "Goal",
        title: "What made you curious about this quiz?",
        context: "Choose the answer that sounds most like you right now.",
        options: [
          { text: "I wake up tired even when I sleep enough", scores: { sleep: 2 } },
          { text: "Stress has been harder to shake lately", scores: { stress: 2 } },
          { text: "My recovery feels slower than it used to", scores: { recovery: 2 } },
          { text: "I want to keep an eye on long-term health", scores: { aging: 2 } },
          { text: "I already track data but do not know what it means", scores: { data: 2 } },
          { text: "I am trying to build a better routine", scores: { habit: 2 } }
        ]
      },
      {
        id: "routine",
        label: "Routine",
        title: "What would be most useful to know tomorrow morning?",
        context: "Hume is designed to connect signals, not just show isolated numbers.",
        options: [
          { text: "Whether my sleep actually helped me recover", scores: { sleep: 2 } },
          { text: "Whether stress is building up", scores: { stress: 2 } },
          { text: "Whether I should push or take it easier", scores: { recovery: 2 } },
          { text: "Which habit affected me most yesterday", scores: { habit: 2 } },
          { text: "Whether my long-term health trends are improving", scores: { aging: 2 } },
          { text: "Whether my current tracker is giving me enough context", scores: { data: 2 } }
        ]
      },
      {
        id: "sleep",
        label: "Sleep",
        title: "How consistent has your sleep felt recently?",
        context: "Sleep quality and consistency can shape how ready you feel the next day.",
        options: [
          { text: "Pretty consistent", scores: {} },
          { text: "Enough hours, but I still feel tired", scores: { sleep: 3 } },
          { text: "Good some nights, poor other nights", scores: { sleep: 2, stress: 1 } },
          { text: "I rarely know because I do not track it closely", scores: { sleep: 2, data: 1 } }
        ]
      },
      {
        id: "stress",
        label: "Stress",
        title: "How does stress usually show up for you?",
        context: "Stress patterns can show up before they feel obvious.",
        options: [
          { text: "I feel wired at night", scores: { stress: 3, sleep: 1 } },
          { text: "I feel tired but restless", scores: { stress: 2, recovery: 1 } },
          { text: "I do not notice until I crash", scores: { stress: 3, recovery: 1 } },
          { text: "I mostly feel fine", scores: { aging: 1 } },
          { text: "I am not sure", scores: { data: 2 } }
        ]
      },
      {
        id: "recovery",
        label: "Recovery",
        title: "When your body feels off, what do you usually do?",
        context: "This helps identify whether your result should focus on push-versus-rest guidance.",
        options: [
          { text: "Push through anyway", scores: { recovery: 3 } },
          { text: "Take an easier day", scores: { recovery: 1, habit: 1 } },
          { text: "Check my wearable", scores: { data: 2 } },
          { text: "Guess based on mood", scores: { data: 2, recovery: 1 } },
          { text: "Ignore it unless it gets worse", scores: { aging: 2, stress: 1 } }
        ]
      },
      {
        id: "heart_trends",
        label: "Heart trends",
        title: "Which signal do you currently pay the least attention to?",
        context: "This quiz is about wellness trends over time, not medical diagnosis.",
        options: [
          { text: "Sleep quality", scores: { sleep: 3 } },
          { text: "Stress load", scores: { stress: 3 } },
          { text: "Recovery", scores: { recovery: 3 } },
          { text: "Blood pressure trends", scores: { heart: 3 } },
          { text: "Long-term health trends", scores: { aging: 3 } },
          { text: "I do not know which one matters", scores: { data: 3 } }
        ]
      },
      {
        id: "wearable",
        label: "Wearable",
        title: "Do you currently use a wearable?",
        context: "This helps us understand whether your biggest gap is measurement or interpretation.",
        options: [
          { text: "Apple Watch", scores: { data: 2 }, wearable: "Apple Watch" },
          { text: "Oura", scores: { data: 2 }, wearable: "Oura" },
          { text: "WHOOP", scores: { data: 2 }, wearable: "WHOOP" },
          { text: "Garmin or Fitbit", scores: { data: 2 }, wearable: "Garmin or Fitbit" },
          { text: "Another tracker", scores: { data: 2 }, wearable: "another tracker" },
          { text: "Nothing consistently", scores: { habit: 2 }, wearable: "no consistent tracker" }
        ]
      },
      {
        id: "guidance",
        label: "Guidance",
        title: "What frustrates you most about health tracking?",
        context: "Your answer helps shape the Hume Band 2.0 recommendation on the result page.",
        options: [
          { text: "Too many numbers", scores: { data: 3 }, objection: "too many numbers" },
          { text: "Not enough guidance", scores: { data: 3 }, objection: "not enough guidance" },
          { text: "Battery or charging", scores: { habit: 1 }, objection: "battery or charging" },
          { text: "Subscription costs", scores: { data: 1 }, objection: "subscription costs" },
          { text: "I do not trust one-off readings", scores: { data: 1 }, objection: "accuracy" },
          { text: "I have not found one I stick with", scores: { habit: 3 }, objection: "consistency" }
        ]
      },
      {
        id: "feedback",
        label: "Result",
        title: "What kind of feedback would help you act?",
        context: "Last question. We will connect your answers into a focus signal next.",
        options: [
          { text: "A simple daily summary", scores: { habit: 2 } },
          { text: "A weekly trend report", scores: { aging: 2 } },
          { text: "Plain-English coaching", scores: { data: 2 } },
          { text: "Deeper metrics I can explore", scores: { data: 1, heart: 1 } },
          { text: "A reminder of what to focus on first", scores: { habit: 2 } }
        ]
      }
    ];

    var results = {
      sleep: {
        title: "Sleep Consistency Gap",
        signal: "Sleep consistency",
        summary: "Your answers suggest your sleep may be affecting recovery, energy, or readiness more than total hours alone can explain.",
        missing: ["Sleep quality", "Night-to-night consistency", "How sleep affects next-day recovery"],
        features: ["Sleep stages and sleep quality", "Recovery trends", "HRV context", "Weekly reports"],
        insight: "Your sleep duration looked normal, but recovery trended lower after two inconsistent nights. Watch the pattern before changing everything.",
        bridgeTitle: "Track the sleep pattern behind your energy.",
        bridgeCopy: "Hume Band 2.0 connects sleep quality, HRV, recovery, and daily habits so you can see whether inconsistent nights may be affecting how you feel over time."
      },
      stress: {
        title: "Stress Load Builder",
        signal: "Stress load",
        summary: "Your answers suggest stress may be showing up through sleep, energy, or recovery before it feels obvious.",
        missing: ["HRV changes", "Resting heart trends", "Recovery dips after demanding days"],
        features: ["HRV and recovery tracking", "Resting heart trend context", "Stress pattern summaries", "Plain-English app insights"],
        insight: "Your recovery dipped on high-demand days even when activity was normal. Stress load may be the signal to watch first.",
        bridgeTitle: "See stress as a pattern, not a guess.",
        bridgeCopy: "Hume Band 2.0 brings sleep, HRV, resting heart trends, and recovery together so you can understand when stress may be affecting your daily readiness."
      },
      recovery: {
        title: "Recovery Blind Spot",
        signal: "Recovery",
        summary: "Your answers suggest you may not always know when your body is ready to push and when it needs an easier day.",
        missing: ["Recovery status", "HRV and strain context", "Sleep debt", "Push-versus-rest signals"],
        features: ["Recovery trend tracking", "HRV", "Strain and activity context", "Sleep connection"],
        insight: "Your activity was steady, but recovery lagged after poor sleep. An easier day may protect consistency better than pushing through.",
        bridgeTitle: "Turn recovery data into daily direction.",
        bridgeCopy: "Hume Band 2.0 helps connect recovery, sleep, strain, and heart-rate trends so you can make more informed decisions about when to push and when to ease up."
      },
      heart: {
        title: "Heart Trend Awareness",
        signal: "Heart trends",
        summary: "Your answers suggest you want more visibility into heart-related wellness trends between check-ins.",
        missing: ["Blood pressure trends", "HRV patterns", "Resting heart changes over time"],
        features: ["Blood pressure insights", "HRV and resting heart rate", "Recovery changes", "Long-term trend summaries"],
        insight: "One reading is not the full story. Hume helps you watch wellness trends over time so you can notice patterns worth paying attention to.",
        bridgeTitle: "Follow heart-related wellness trends over time.",
        bridgeCopy: "Hume Band 2.0 helps you monitor heart-rate, HRV, recovery, and blood-pressure wellness insights together so unusual patterns are easier to discuss and understand."
      },
      aging: {
        title: "Aging Momentum Gap",
        signal: "Long-term health trends",
        summary: "Your answers suggest you care less about today's step count and more about whether your habits are supporting long-term wellness direction.",
        missing: ["Long-term trend direction", "How habits affect recovery and aging momentum", "Weekly progress context"],
        features: ["Pace of Aging", "Metabolic Momentum", "Health Score", "Weekly reports"],
        insight: "Your daily choices become easier to understand when you can see the trend, not just a single day of data.",
        bridgeTitle: "Watch whether your habits are moving the trend.",
        bridgeCopy: "Hume Band 2.0 is built to connect daily behavior with longer-term wellness signals like Health Score, metabolic momentum, recovery, and weekly trend direction."
      },
      data: {
        title: "Data Without Direction",
        signal: "Metric connection",
        summary: "Your answers suggest you may already have data, but not enough interpretation about what to focus on next.",
        missing: ["How sleep, stress, recovery, and activity connect", "Plain-English summaries", "A daily focus point"],
        features: ["AI insights", "Health Score", "Weekly reports", "Sleep, stress, and recovery connection"],
        insight: "Your tracker can show what happened. Hume is built to help explain which signal deserves attention next.",
        bridgeTitle: "Move from metrics to meaning.",
        bridgeCopy: "Hume Band 2.0 connects sleep, stress, recovery, activity, and heart trends so your wearable data can become clearer daily direction."
      },
      habit: {
        title: "Habit Feedback Gap",
        signal: "Habit feedback",
        summary: "Your answers suggest you want to build a healthier routine, but need clearer feedback on which habits are actually helping.",
        missing: ["Which habits move your trends", "Simple daily feedback", "Weekly accountability"],
        features: ["Health Score", "Activity and sleep trends", "Weekly reports", "Optional AI coaching"],
        insight: "Small habits are easier to keep when you can see which ones are moving your wellness trends in the right direction.",
        bridgeTitle: "See which habits may be helping.",
        bridgeCopy: "Hume Band 2.0 brings activity, sleep, recovery, and Health Score into one app so habit changes are easier to connect with your wellness trends."
      }
    };

    function setupQuiz(root) {
      var state = {
        step: -1,
        scores: { sleep: 0, stress: 0, recovery: 0, heart: 0, aging: 0, data: 0, habit: 0 },
        answers: [],
        answerIds: [],
        wearable: "",
        objection: "",
        startedAt: 0,
        completedAt: 0,
        isTransitioning: false
      };

      var startPanel = root.querySelector("[data-hsq-start]");
      var questionPanel = root.querySelector("[data-hsq-question]");
      var analyzingPanel = root.querySelector("[data-hsq-analyzing]");
      var resultPanel = root.querySelector("[data-hsq-result]");
      var progress = root.querySelector("[data-hsq-progress]");
      var progressBar = root.querySelector("[data-hsq-progress-bar]");
      var progressCount = root.querySelector("[data-hsq-progress-count]");
      var stepLabel = root.querySelector("[data-hsq-step-label]");
      var questionIndex = root.querySelector("[data-hsq-question-index]");
      var questionTitle = root.querySelector("[data-hsq-question-title]");
      var questionContext = root.querySelector("[data-hsq-question-context]");
      var optionsWrap = root.querySelector("[data-hsq-options]");
      var backButton = root.querySelector("[data-hsq-back]");

      function publish(eventName, detail) {
        var payload = Object.assign({
          quiz_id: "hume_band_health_signal_quiz",
          quiz_version: root.getAttribute("data-quiz-version") || "unknown",
          page_path: window.location.pathname,
          device_type: window.matchMedia("(max-width: 820px)").matches ? "mobile" : "desktop"
        }, detail || {});
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: eventName, health_signal_quiz: payload });
        root.dispatchEvent(new CustomEvent(eventName, { detail: payload, bubbles: true }));
      }

      function updateProgress() {
        var complete = state.step < 0 ? 0 : Math.min(questions.length, state.step + 1);
        var percent = state.step < 0 ? 0 : ((state.step + 1) / questions.length) * 100;
        progressBar.style.width = Math.min(100, percent) + "%";
        progress.setAttribute("aria-valuenow", String(Math.round(Math.min(100, percent))));
        progressCount.textContent = state.step < 0 ? "9 questions · about 60 seconds" : "Question " + complete + " of " + questions.length;
        stepLabel.textContent = state.step >= 0 && questions[state.step] ? questions[state.step].label : "Start";
        backButton.hidden = state.step <= 0;
      }

      function resetScoreState() {
        state.scores = { sleep: 0, stress: 0, recovery: 0, heart: 0, aging: 0, data: 0, habit: 0 };
        state.wearable = "";
        state.objection = "";
        state.answers.forEach(function (answerText, index) {
          var question = questions[index];
          if (!question) {
            return;
          }
          var option = question.options.find(function (candidate) {
            return candidate.text === answerText;
          });
          if (!option) {
            return;
          }
          Object.keys(option.scores).forEach(function (key) {
            state.scores[key] += option.scores[key];
          });
          if (option.wearable) {
            state.wearable = option.wearable;
          }
          if (option.objection) {
            state.objection = option.objection;
          }
        });
      }

      function recordAnswer(question, option, optionIndex) {
        state.answers[state.step] = option.text;
        state.answerIds[state.step] = question.id + "_" + (optionIndex + 1);
        state.answers = state.answers.slice(0, state.step + 1);
        state.answerIds = state.answerIds.slice(0, state.step + 1);
        resetScoreState();
      }

      function showQuestion(index) {
        if (state.isTransitioning) {
          return;
        }
        state.step = index;
        updateProgress();
        startPanel.hidden = true;
        analyzingPanel.hidden = true;
        resultPanel.hidden = true;
        questionPanel.hidden = false;
        var question = questions[index];
        questionIndex.textContent = "Question " + (index + 1) + " of " + questions.length;
        questionTitle.textContent = question.title;
        questionContext.textContent = question.context || "";
        optionsWrap.innerHTML = "";
        question.options.forEach(function (option, optionIndex) {
          var button = document.createElement("button");
          button.type = "button";
          button.className = "hsq-option";
          button.textContent = option.text;
          button.setAttribute("aria-pressed", state.answers[index] === option.text ? "true" : "false");
          if (state.answers[index] === option.text) {
            button.classList.add("is-selected");
          }
          button.addEventListener("click", function () {
            if (state.isTransitioning) {
              return;
            }
            state.isTransitioning = true;
            Array.prototype.forEach.call(optionsWrap.querySelectorAll(".hsq-option"), function (optionButton) {
              optionButton.disabled = true;
              optionButton.setAttribute("aria-pressed", "false");
            });
            button.classList.add("is-selected");
            button.setAttribute("aria-pressed", "true");
            recordAnswer(question, option, optionIndex);
            publish("band_signal_quiz_question_answered", {
              question_id: question.id,
              answer_id: state.answerIds[index],
              question_number: index + 1,
              funnel_step: "question"
            });
            window.setTimeout(function () {
              state.isTransitioning = false;
              if (index + 1 < questions.length) {
                showQuestion(index + 1);
              } else {
                showAnalyzing();
              }
            }, 180);
          });
          optionsWrap.appendChild(button);
        });
        publish("band_signal_quiz_question_viewed", {
          question_id: question.id,
          question_number: index + 1,
          funnel_step: "question"
        });
      }

      function getWinner() {
        var winner = "sleep";
        Object.keys(state.scores).forEach(function (key) {
          if (state.scores[key] > state.scores[winner]) {
            winner = key;
          }
        });
        if (state.wearable && state.wearable !== "no consistent tracker") {
          var dataScore = state.scores.data;
          if (dataScore >= state.scores[winner] - 1) {
            winner = "data";
          }
        }
        return winner;
      }

      function fillList(selector, items) {
        var target = root.querySelector(selector);
        target.innerHTML = "";
        items.forEach(function (item) {
          var li = document.createElement("li");
          li.textContent = item;
          target.appendChild(li);
        });
      }

      function slug(value) {
        return String(value || "unknown").toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
      }

      function getCtaUrl(result) {
        var base = root.getAttribute("data-cta-url") || "https://humehealth.com/pages/hume-bandv2";
        var separator = base.indexOf("?") === -1 ? "?" : "&";
        var params = [
          ["utm_source", "thewearabletech"],
          ["utm_medium", "quiz"],
          ["utm_campaign", "health_signal_quiz"],
          ["utm_content", slug(result.title)],
          ["utm_term", slug(result.signal)],
          ["quiz_result", slug(result.title)],
          ["quiz_signal", slug(result.signal)],
          ["quiz_wearable", slug(state.wearable)],
          ["quiz_objection", slug(state.objection)]
        ];
        return base + separator + params.map(function (pair) {
          return encodeURIComponent(pair[0]) + "=" + encodeURIComponent(pair[1]);
        }).join("&");
      }

      function showAnalyzing() {
        questionPanel.hidden = true;
        resultPanel.hidden = true;
        analyzingPanel.hidden = false;
        progressBar.style.width = "96%";
        progress.setAttribute("aria-valuenow", "96");
        progressCount.textContent = "Preparing result";
        stepLabel.textContent = "Analyzing";
        window.setTimeout(showResult, 520);
      }

      function showResult() {
        var winner = getWinner();
        var result = results[winner];
        state.completedAt = Date.now();
        analyzingPanel.hidden = true;
        questionPanel.hidden = true;
        resultPanel.hidden = false;
        progressBar.style.width = "100%";
        progress.setAttribute("aria-valuenow", "100");
        progressCount.textContent = questions.length + " of " + questions.length;
        stepLabel.textContent = "Result";

        root.querySelector("[data-hsq-result-title]").textContent = result.title;
        root.querySelector("[data-hsq-result-signal]").textContent = result.signal;
        root.querySelector("[data-hsq-result-summary]").textContent = result.summary;
        root.querySelector("[data-hsq-insight]").textContent = result.insight;
        root.querySelector("[data-hsq-result-cta]").setAttribute("href", getCtaUrl(result));
        root.querySelector("[data-hsq-bridge-title]").textContent = result.bridgeTitle;
        root.querySelector("[data-hsq-bridge-copy]").textContent = result.bridgeCopy;
        fillList("[data-hsq-missing]", result.missing);
        fillList("[data-hsq-features]", result.features);

        var recap = root.querySelector("[data-hsq-recap]");
        recap.innerHTML = "";
        state.answers.slice(0, 3).forEach(function (answer) {
          var span = document.createElement("span");
          span.textContent = answer;
          recap.appendChild(span);
        });

        publish("band_signal_quiz_completed", {
          result_type: winner,
          result: result.title,
          signal: result.signal,
          wearable: state.wearable,
          objection: state.objection,
          cta_url: getCtaUrl(result),
          completion_seconds: state.startedAt ? Math.round((state.completedAt - state.startedAt) / 1000) : null,
          scores: state.scores,
          funnel_step: "result"
        });
      }

      function goBack() {
        if (state.isTransitioning || state.step <= 0) {
          return;
        }
        publish("band_signal_quiz_back_clicked", {
          from_question_number: state.step + 1,
          to_question_number: state.step,
          funnel_step: "question"
        });
        showQuestion(state.step - 1);
      }

      root.querySelector("[data-hsq-result-cta]").addEventListener("click", function () {
        var winner = getWinner();
        publish("band_signal_quiz_product_cta_clicked", {
          result_type: winner,
          cta_location: "result",
          cta_url: getCtaUrl(results[winner]),
          funnel_step: "pdp_handoff"
        });
      });

      root.querySelector("[data-hsq-start-button]").addEventListener("click", function () {
        state.startedAt = Date.now();
        publish("band_signal_quiz_started", {
          funnel_step: "start"
        });
        showQuestion(0);
      });

      backButton.addEventListener("click", goBack);

      updateProgress();
    }

    roots.forEach(setupQuiz);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["health-signal-quiz"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll("[data-health-signal-quiz]");
    if (!roots.length) {
      return;
    }

    var questions = [
      {
        label: "Goal",
        title: "What made you curious about this quiz?",
        options: [
          { text: "I wake up tired even when I sleep enough", scores: { sleep: 2 } },
          { text: "Stress has been harder to shake lately", scores: { stress: 2 } },
          { text: "My recovery feels slower than it used to", scores: { recovery: 2 } },
          { text: "I want to keep an eye on long-term health", scores: { aging: 2 } },
          { text: "I already track data but do not know what it means", scores: { data: 2 } },
          { text: "I am trying to build a better routine", scores: { habit: 2 } }
        ]
      },
      {
        label: "Routine",
        title: "What would be most useful to know tomorrow morning?",
        options: [
          { text: "Whether my sleep actually helped me recover", scores: { sleep: 2 } },
          { text: "Whether stress is building up", scores: { stress: 2 } },
          { text: "Whether I should push or take it easier", scores: { recovery: 2 } },
          { text: "Which habit affected me most yesterday", scores: { habit: 2 } },
          { text: "Whether my long-term health trends are improving", scores: { aging: 2 } },
          { text: "Whether my current tracker is giving me enough context", scores: { data: 2 } }
        ]
      },
      {
        label: "Sleep",
        title: "How consistent has your sleep felt recently?",
        options: [
          { text: "Pretty consistent", scores: {} },
          { text: "Enough hours, but I still feel tired", scores: { sleep: 3 } },
          { text: "Good some nights, poor other nights", scores: { sleep: 2, stress: 1 } },
          { text: "I rarely know because I do not track it closely", scores: { sleep: 2, data: 1 } }
        ]
      },
      {
        label: "Stress",
        title: "How does stress usually show up for you?",
        options: [
          { text: "I feel wired at night", scores: { stress: 3, sleep: 1 } },
          { text: "I feel tired but restless", scores: { stress: 2, recovery: 1 } },
          { text: "I do not notice until I crash", scores: { stress: 3, recovery: 1 } },
          { text: "I mostly feel fine", scores: { aging: 1 } },
          { text: "I am not sure", scores: { data: 2 } }
        ]
      },
      {
        label: "Recovery",
        title: "When your body feels off, what do you usually do?",
        options: [
          { text: "Push through anyway", scores: { recovery: 3 } },
          { text: "Take an easier day", scores: { recovery: 1, habit: 1 } },
          { text: "Check my wearable", scores: { data: 2 } },
          { text: "Guess based on mood", scores: { data: 2, recovery: 1 } },
          { text: "Ignore it unless it gets worse", scores: { aging: 2, stress: 1 } }
        ]
      },
      {
        label: "Heart trends",
        title: "Which signal do you currently pay the least attention to?",
        options: [
          { text: "Sleep quality", scores: { sleep: 3 } },
          { text: "Stress load", scores: { stress: 3 } },
          { text: "Recovery", scores: { recovery: 3 } },
          { text: "Blood pressure trends", scores: { heart: 3 } },
          { text: "Long-term health trends", scores: { aging: 3 } },
          { text: "I do not know which one matters", scores: { data: 3 } }
        ]
      },
      {
        label: "Wearable",
        title: "Do you currently use a wearable?",
        options: [
          { text: "Apple Watch", scores: { data: 2 }, wearable: "Apple Watch" },
          { text: "Oura", scores: { data: 2 }, wearable: "Oura" },
          { text: "WHOOP", scores: { data: 2 }, wearable: "WHOOP" },
          { text: "Garmin or Fitbit", scores: { data: 2 }, wearable: "Garmin or Fitbit" },
          { text: "Another tracker", scores: { data: 2 }, wearable: "another tracker" },
          { text: "Nothing consistently", scores: { habit: 2 }, wearable: "no consistent tracker" }
        ]
      },
      {
        label: "Guidance",
        title: "What frustrates you most about health tracking?",
        options: [
          { text: "Too many numbers", scores: { data: 3 }, objection: "too many numbers" },
          { text: "Not enough guidance", scores: { data: 3 }, objection: "not enough guidance" },
          { text: "Battery or charging", scores: { habit: 1 }, objection: "battery or charging" },
          { text: "Subscription costs", scores: { data: 1 }, objection: "subscription costs" },
          { text: "I do not trust one-off readings", scores: { data: 1 }, objection: "accuracy" },
          { text: "I have not found one I stick with", scores: { habit: 3 }, objection: "consistency" }
        ]
      },
      {
        label: "Result",
        title: "What kind of feedback would help you act?",
        options: [
          { text: "A simple daily summary", scores: { habit: 2 } },
          { text: "A weekly trend report", scores: { aging: 2 } },
          { text: "Plain-English coaching", scores: { data: 2 } },
          { text: "Deeper metrics I can explore", scores: { data: 1, heart: 1 } },
          { text: "A reminder of what to focus on first", scores: { habit: 2 } }
        ]
      }
    ];

    var results = {
      sleep: {
        title: "Sleep Consistency Gap",
        signal: "Sleep consistency",
        summary: "Your answers suggest your sleep may be affecting recovery, energy, or readiness more than total hours alone can explain.",
        missing: ["Sleep quality", "Night-to-night consistency", "How sleep affects next-day recovery"],
        features: ["Sleep stages and sleep quality", "Recovery trends", "HRV context", "Weekly reports"],
        insight: "Your sleep duration looked normal, but recovery trended lower after two inconsistent nights. Watch the pattern before changing everything."
      },
      stress: {
        title: "Stress Load Builder",
        signal: "Stress load",
        summary: "Your answers suggest stress may be showing up through sleep, energy, or recovery before it feels obvious.",
        missing: ["HRV changes", "Resting heart trends", "Recovery dips after demanding days"],
        features: ["HRV and recovery tracking", "Resting heart trend context", "Stress pattern summaries", "Plain-English app insights"],
        insight: "Your recovery dipped on high-demand days even when activity was normal. Stress load may be the signal to watch first."
      },
      recovery: {
        title: "Recovery Blind Spot",
        signal: "Recovery",
        summary: "Your answers suggest you may not always know when your body is ready to push and when it needs an easier day.",
        missing: ["Recovery status", "HRV and strain context", "Sleep debt", "Push-versus-rest signals"],
        features: ["Recovery trend tracking", "HRV", "Strain and activity context", "Sleep connection"],
        insight: "Your activity was steady, but recovery lagged after poor sleep. An easier day may protect consistency better than pushing through."
      },
      heart: {
        title: "Heart Trend Awareness",
        signal: "Heart trends",
        summary: "Your answers suggest you want more visibility into heart-related wellness trends between check-ins.",
        missing: ["Blood pressure trends", "HRV patterns", "Resting heart changes over time"],
        features: ["Blood pressure insights", "HRV and resting heart rate", "Recovery changes", "Long-term trend summaries"],
        insight: "One reading is not the full story. Hume helps you watch wellness trends over time so you can notice patterns worth paying attention to."
      },
      aging: {
        title: "Aging Momentum Gap",
        signal: "Long-term health trends",
        summary: "Your answers suggest you care less about today's step count and more about whether your habits are supporting long-term wellness direction.",
        missing: ["Long-term trend direction", "How habits affect recovery and aging momentum", "Weekly progress context"],
        features: ["Pace of Aging", "Metabolic Momentum", "Health Score", "Weekly reports"],
        insight: "Your daily choices become easier to understand when you can see the trend, not just a single day of data."
      },
      data: {
        title: "Data Without Direction",
        signal: "Metric connection",
        summary: "Your answers suggest you may already have data, but not enough interpretation about what to focus on next.",
        missing: ["How sleep, stress, recovery, and activity connect", "Plain-English summaries", "A daily focus point"],
        features: ["AI insights", "Health Score", "Weekly reports", "Sleep, stress, and recovery connection"],
        insight: "Your tracker can show what happened. Hume is built to help explain which signal deserves attention next."
      },
      habit: {
        title: "Habit Feedback Gap",
        signal: "Habit feedback",
        summary: "Your answers suggest you want to build a healthier routine, but need clearer feedback on which habits are actually helping.",
        missing: ["Which habits move your trends", "Simple daily feedback", "Weekly accountability"],
        features: ["Health Score", "Activity and sleep trends", "Weekly reports", "Optional AI coaching"],
        insight: "Small habits are easier to keep when you can see which ones are moving your wellness trends in the right direction."
      }
    };

    function setupQuiz(root) {
      var state = {
        step: -1,
        scores: { sleep: 0, stress: 0, recovery: 0, heart: 0, aging: 0, data: 0, habit: 0 },
        answers: [],
        wearable: "",
        objection: ""
      };

      var startPanel = root.querySelector("[data-hsq-start]");
      var questionPanel = root.querySelector("[data-hsq-question]");
      var resultPanel = root.querySelector("[data-hsq-result]");
      var progressBar = root.querySelector("[data-hsq-progress-bar]");
      var progressCount = root.querySelector("[data-hsq-progress-count]");
      var stepLabel = root.querySelector("[data-hsq-step-label]");
      var questionIndex = root.querySelector("[data-hsq-question-index]");
      var questionTitle = root.querySelector("[data-hsq-question-title]");
      var optionsWrap = root.querySelector("[data-hsq-options]");

      function publish(eventName, detail) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: eventName, health_signal_quiz: detail });
        root.dispatchEvent(new CustomEvent(eventName, { detail: detail, bubbles: true }));
      }

      function updateProgress() {
        var complete = Math.max(0, state.step);
        var percent = state.step < 0 ? 0 : ((state.step + 1) / questions.length) * 100;
        progressBar.style.width = Math.min(100, percent) + "%";
        progressCount.textContent = complete + " of " + questions.length;
        stepLabel.textContent = state.step >= 0 && questions[state.step] ? questions[state.step].label : "Start";
      }

      function showQuestion(index) {
        state.step = index;
        updateProgress();
        startPanel.hidden = true;
        resultPanel.hidden = true;
        questionPanel.hidden = false;
        var question = questions[index];
        questionIndex.textContent = "Question " + (index + 1) + " of " + questions.length;
        questionTitle.textContent = question.title;
        optionsWrap.innerHTML = "";
        question.options.forEach(function (option) {
          var button = document.createElement("button");
          button.type = "button";
          button.className = "hsq-option";
          button.textContent = option.text;
          button.addEventListener("click", function () {
            Object.keys(option.scores).forEach(function (key) {
              state.scores[key] += option.scores[key];
            });
            if (option.wearable) {
              state.wearable = option.wearable;
            }
            if (option.objection) {
              state.objection = option.objection;
            }
            state.answers.push(option.text);
            publish("band_signal_quiz_question_answered", {
              question: question.title,
              answer: option.text,
              step: index + 1
            });
            if (index + 1 < questions.length) {
              showQuestion(index + 1);
            } else {
              showResult();
            }
          });
          optionsWrap.appendChild(button);
        });
      }

      function getWinner() {
        var winner = "sleep";
        Object.keys(state.scores).forEach(function (key) {
          if (state.scores[key] > state.scores[winner]) {
            winner = key;
          }
        });
        if (state.wearable && state.wearable !== "no consistent tracker") {
          var dataScore = state.scores.data;
          if (dataScore >= state.scores[winner] - 1) {
            winner = "data";
          }
        }
        return winner;
      }

      function fillList(selector, items) {
        var target = root.querySelector(selector);
        target.innerHTML = "";
        items.forEach(function (item) {
          var li = document.createElement("li");
          li.textContent = item;
          target.appendChild(li);
        });
      }

      function slug(value) {
        return String(value || "unknown").toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
      }

      function getCtaUrl(result) {
        var base = root.getAttribute("data-cta-url") || "https://humehealth.com/pages/hume-bandv2";
        var separator = base.indexOf("?") === -1 ? "?" : "&";
        var params = [
          ["utm_source", "thewearabletech"],
          ["utm_medium", "quiz"],
          ["utm_campaign", "health_signal_quiz"],
          ["utm_content", slug(result.title)],
          ["utm_term", slug(result.signal)],
          ["quiz_result", slug(result.title)],
          ["quiz_signal", slug(result.signal)],
          ["quiz_wearable", slug(state.wearable)],
          ["quiz_objection", slug(state.objection)]
        ];
        return base + separator + params.map(function (pair) {
          return encodeURIComponent(pair[0]) + "=" + encodeURIComponent(pair[1]);
        }).join("&");
      }

      function showResult() {
        var winner = getWinner();
        var result = results[winner];
        questionPanel.hidden = true;
        resultPanel.hidden = false;
        progressBar.style.width = "100%";
        progressCount.textContent = questions.length + " of " + questions.length;
        stepLabel.textContent = "Result";

        root.querySelector("[data-hsq-result-title]").textContent = result.title;
        root.querySelector("[data-hsq-result-signal]").textContent = result.signal;
        root.querySelector("[data-hsq-result-summary]").textContent = result.summary;
        root.querySelector("[data-hsq-insight]").textContent = result.insight;
        root.querySelector("[data-hsq-result-cta]").setAttribute("href", getCtaUrl(result));
        fillList("[data-hsq-missing]", result.missing);
        fillList("[data-hsq-features]", result.features);

        var recap = root.querySelector("[data-hsq-recap]");
        recap.innerHTML = "";
        state.answers.slice(0, 3).forEach(function (answer) {
          var span = document.createElement("span");
          span.textContent = answer;
          recap.appendChild(span);
        });

        publish("band_signal_quiz_completed", {
          result: result.title,
          signal: result.signal,
          wearable: state.wearable,
          objection: state.objection,
          cta_url: getCtaUrl(result),
          scores: state.scores
        });
      }

      root.querySelector("[data-hsq-start-button]").addEventListener("click", function () {
        publish("band_signal_quiz_started", {});
        showQuestion(0);
      });

      updateProgress();
    }

    roots.forEach(setupQuiz);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["health-signal-wearable-gap-quiz"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll("[data-health-signal-quiz]");
    if (!roots.length) {
      return;
    }

    var questions = [
      {
        id: "current_tracker",
        label: "Wearable",
        title: "What are you using to track your health right now?",
        context: "This quiz is built around the biggest wearable problem: data is easy to collect, but hard to interpret.",
        options: [
          { text: "Apple Watch", scores: { data: 3 }, wearable: "Apple Watch" },
          { text: "Oura Ring", scores: { data: 3 }, wearable: "Oura Ring" },
          { text: "WHOOP", scores: { data: 3 }, wearable: "WHOOP" },
          { text: "Garmin or Fitbit", scores: { data: 2, habit: 1 }, wearable: "Garmin or Fitbit" },
          { text: "Another tracker", scores: { data: 2 }, wearable: "another tracker" },
          { text: "Nothing consistently", scores: { habit: 3 }, wearable: "no consistent tracker" }
        ]
      },
      {
        id: "tracker_gap",
        label: "Gap",
        title: "What does your current wearable leave you wondering most?",
        context: "The enemy is not tracking. It is tracking without a clear next move.",
        options: [
          { text: "What all my scores actually mean", scores: { data: 3 }, objection: "too many numbers" },
          { text: "Why I wake up tired even after enough sleep", scores: { sleep: 3 }, objection: "sleep still feels unclear" },
          { text: "When to push, rest, or recover", scores: { recovery: 3 }, objection: "not enough recovery guidance" },
          { text: "How stress is affecting my body", scores: { stress: 3 }, objection: "stress is hard to read" },
          { text: "Which long-term trend matters", scores: { aging: 3 }, objection: "long-term trend confusion" },
          { text: "Whether heart-related trends are changing", scores: { heart: 3 }, objection: "heart trend visibility" }
        ]
      },
      {
        id: "false_confidence",
        label: "Scores",
        title: "Which score do you check, but still struggle to act on?",
	        context: "Most wearables are good at showing a number. The real unlock is understanding what that number means.",
        options: [
          { text: "Sleep score", scores: { sleep: 3, data: 1 } },
          { text: "Recovery or readiness", scores: { recovery: 3, data: 1 } },
          { text: "Stress or HRV", scores: { stress: 2, recovery: 1 } },
          { text: "Heart or blood pressure trends", scores: { heart: 3 } },
          { text: "Activity rings or strain", scores: { habit: 2, recovery: 1 } },
          { text: "I do not check because it feels overwhelming", scores: { data: 3 } }
        ]
      },
      {
        id: "daily_impact",
        label: "Impact",
        title: "Where do you feel the gap most in daily life?",
        context: "The missed signal usually shows up as a pattern before it feels like a clear problem.",
        options: [
          { text: "Waking up tired", scores: { sleep: 3 } },
          { text: "Afternoon crash or brain fog", scores: { recovery: 2, stress: 1 } },
          { text: "Feeling wired or tense", scores: { stress: 3 } },
          { text: "Guessing whether to work out", scores: { recovery: 3 } },
          { text: "Wanting better health direction", scores: { data: 2, aging: 1 } },
          { text: "Trying to stay consistent", scores: { habit: 3 } }
        ]
      },
      {
        id: "pattern_timing",
        label: "Timing",
        title: "When does your body feel hardest to read?",
        context: "Timing helps reveal whether your first signal is sleep, stress, recovery, heart trends, or consistency.",
        options: [
          { text: "Right after waking", scores: { sleep: 3 } },
          { text: "After stressful workdays", scores: { stress: 3, recovery: 1 } },
          { text: "After workouts or long days", scores: { recovery: 3 } },
          { text: "When my heart or BP numbers shift", scores: { heart: 3 } },
          { text: "Week to week, not day to day", scores: { aging: 3 } },
          { text: "Only after I open the app", scores: { data: 3 } }
        ]
      },
      {
        id: "sleep_recovery",
        label: "Recovery",
        title: "How connected do your sleep and recovery feel?",
        context: "Other wearables often split these into separate scores. The missed insight is how they influence each other.",
        options: [
          { text: "I sleep enough but still do not feel recovered", scores: { sleep: 2, recovery: 2 } },
          { text: "Poor sleep clearly affects me", scores: { sleep: 3 } },
          { text: "Recovery feels random", scores: { recovery: 3, data: 1 } },
          { text: "Stress seems to override both", scores: { stress: 3 } },
          { text: "I do not know how to connect them", scores: { data: 3 } }
        ]
      },
      {
        id: "heart_context",
        label: "Heart",
        title: "How do you think about heart-related wellness trends?",
        context: "This is wellness trend guidance, not diagnosis or medical prediction.",
        options: [
          { text: "I want to understand trends, not one-off readings", scores: { heart: 3, data: 1 } },
          { text: "Blood pressure insights interest me", scores: { heart: 3 } },
          { text: "HRV changes are hard to interpret", scores: { stress: 1, recovery: 1, data: 2 } },
          { text: "I mostly ignore heart trends", scores: { heart: 2, habit: 1 } },
          { text: "I would rather focus on sleep first", scores: { sleep: 2 } }
        ]
      },
      {
        id: "hero_need",
        label: "Hero",
        title: "What would make a wearable feel useful instead of noisy?",
	        context: "This shapes the kind of guidance your result should point toward.",
        options: [
          { text: "Plain-English direction", scores: { data: 3 }, objection: "needs interpretation" },
          { text: "A single daily focus point", scores: { habit: 2, data: 1 }, objection: "needs focus" },
          { text: "Longer battery so I do not miss nights", scores: { habit: 3 }, objection: "battery or charging" },
          { text: "Sleep, stress, and recovery in one view", scores: { recovery: 1, stress: 1, sleep: 1 }, objection: "signals feel disconnected" },
          { text: "More health context without another screen", scores: { data: 2, habit: 1 }, objection: "too much screen noise" }
        ]
      },
      {
        id: "action_style",
        label: "Result",
        title: "What kind of result would actually help you act?",
        context: "Last question. We will show the signal your current wearable may not be making clear enough.",
        options: [
          { text: "Tell me what to focus on today", scores: { data: 2, habit: 1 } },
          { text: "Show the trend I am missing", scores: { aging: 2, data: 1 } },
          { text: "Connect my scores into one explanation", scores: { data: 3 } },
          { text: "Help me protect recovery", scores: { recovery: 3 } },
          { text: "Help me stay consistent", scores: { habit: 3 } }
        ]
      }
    ];

    var results = {
      sleep: {
        title: "Your Wearable May Be Missing Your Sleep-Recovery Pattern",
        signal: "Sleep-recovery connection",
        summary: "Your answers suggest the issue may not be sleep hours alone. The missed insight is how sleep quality, HRV, and next-day recovery connect.",
        missing: ["Why enough sleep can still feel unrefreshing", "How inconsistent nights affect readiness", "Which sleep pattern deserves attention first"],
        features: ["Sleep quality and sleep-stage context", "Recovery and HRV trends", "Plain-English app summaries", "Weekly pattern reports"],
        insight: "Old wearable logic: check a sleep score. Hume logic: connect sleep, recovery, HRV, and habits so you can see why the score matters.",
        bridgeTitle: "Hume Band 2.0 turns sleep data into direction.",
        bridgeCopy: "It helps connect sleep quality, recovery, HRV, and daily habits so your result becomes a pattern you can actually follow."
      },
      stress: {
        title: "Your Wearable May Be Missing Your Stress Load",
        signal: "Stress-recovery pattern",
        summary: "Your answers suggest stress may be affecting your body before it feels obvious. The missed insight is how stress shows up through sleep, HRV, and recovery.",
        missing: ["Stress changes before you feel burnt out", "Recovery dips after demanding days", "How HRV and sleep shift together"],
        features: ["HRV and recovery context", "Stress trend summaries", "Resting heart-rate trends", "Daily health direction"],
        insight: "A tracker can show a low score. Hume Band 2.0 is built to help explain the pattern behind it.",
        bridgeTitle: "Hume Band 2.0 makes stress less invisible.",
        bridgeCopy: "It brings sleep, HRV, recovery, and heart trends together so stress load is easier to read as a pattern, not a guess."
      },
      recovery: {
        title: "Your Wearable May Be Missing Your Push-or-Rest Signal",
        signal: "Recovery direction",
        summary: "Your answers suggest you may not always know whether to push, rest, or adjust. The missed insight is readiness in context, not a score in isolation.",
        missing: ["When recovery is lagging behind activity", "Whether sleep debt is affecting readiness", "How to connect strain, HRV, and rest"],
        features: ["Recovery trend tracking", "HRV and activity context", "Sleep connection", "Simple daily focus points"],
        insight: "The old wearable gives you a recovery number. Hume Band 2.0 helps connect the signals behind that number.",
        bridgeTitle: "Hume Band 2.0 turns recovery into daily direction.",
        bridgeCopy: "It connects recovery, sleep, activity, and heart-rate trends so you have a clearer read on when to push and when to ease up."
      },
      heart: {
        title: "Your Wearable May Be Missing Your Heart-Trend Context",
        signal: "Heart trend context",
        summary: "Your answers suggest you want more than one-off readings. The missed insight is how heart-related wellness trends move over time and interact with recovery.",
        missing: ["Blood pressure wellness trends in context", "HRV and resting heart changes", "When a pattern may be worth discussing"],
        features: ["Blood pressure insights", "HRV and resting heart-rate trends", "Recovery connection", "Long-term summaries"],
        insight: "One number is not the full story. Hume Band 2.0 is built to help you watch wellness patterns over time.",
        bridgeTitle: "Hume Band 2.0 helps make heart trends easier to follow.",
        bridgeCopy: "It connects heart-rate, HRV, recovery, and blood-pressure wellness insights so patterns are easier to understand and discuss."
      },
      aging: {
        title: "Your Wearable May Be Missing Your Long-Term Direction",
        signal: "Long-term health direction",
        summary: "Your answers suggest step counts and daily scores are not enough. The missed insight is whether your habits are moving your long-term wellness trend.",
        missing: ["How daily habits compound over time", "Whether recovery and sleep are trending better", "The bigger direction behind daily scores"],
        features: ["Health Score", "Metabolic Momentum", "Pace of Aging", "Weekly trend reports"],
        insight: "The old promise was track everything. The better promise is understand what your habits are doing over time.",
        bridgeTitle: "Hume Band 2.0 makes the long-term trend visible.",
        bridgeCopy: "It connects daily behavior with longer-term wellness signals so you can see whether your routine is moving in the right direction."
      },
      data: {
        title: "Your Wearable May Be Giving You Data Without Direction",
        signal: "Metric connection",
        summary: "Your answers suggest your biggest gap is not measurement. It is interpretation. You may already have scores, but not a clear signal to act on.",
        missing: ["Which score matters first", "How sleep, stress, recovery, and activity connect", "What today's data means for your next move"],
        features: ["AI insights", "Health Score", "Sleep-stress-recovery connection", "Plain-English summaries"],
        insight: "Apple Watch, Oura, WHOOP, and Garmin made health data normal. Hume Band 2.0 is built for the next step: direction.",
        bridgeTitle: "Hume Band 2.0 is the hero for data overload.",
        bridgeCopy: "It connects your signals into clearer guidance so health tracking feels less like homework and more like a daily read on what matters."
      },
      habit: {
        title: "Your Wearable May Be Missing Your Consistency Signal",
        signal: "Habit feedback",
        summary: "Your answers suggest you do not just need more tracking. You need a system that helps you stay consistent and see which habits are moving your trend.",
        missing: ["Which habits are helping", "How charging gaps break the pattern", "Simple feedback that keeps you engaged"],
        features: ["Up to 14-day battery life", "Screen-free wearable design", "Health Score", "Weekly habit feedback"],
        insight: "A wearable only helps if you keep wearing it. Hume Band 2.0 is built to make consistency easier and insights clearer.",
        bridgeTitle: "Hume Band 2.0 helps turn habit tracking into feedback.",
        bridgeCopy: "It brings activity, sleep, recovery, and health trends into one app so consistency becomes easier to understand and maintain."
      }
    };

    function setupQuiz(root) {
      var state = {
        step: -1,
        scores: { sleep: 0, stress: 0, recovery: 0, heart: 0, aging: 0, data: 0, habit: 0 },
        answers: [],
        answerIds: [],
        wearable: "",
        objection: "",
        startedAt: 0,
        completedAt: 0,
        isTransitioning: false
      };

      var startPanel = root.querySelector("[data-hsq-start]");
      var questionPanel = root.querySelector("[data-hsq-question]");
      var analyzingPanel = root.querySelector("[data-hsq-analyzing]");
      var resultPanel = root.querySelector("[data-hsq-result]");
      var progress = root.querySelector("[data-hsq-progress]");
      var progressBar = root.querySelector("[data-hsq-progress-bar]");
      var progressCount = root.querySelector("[data-hsq-progress-count]");
      var stepLabel = root.querySelector("[data-hsq-step-label]");
      var questionIndex = root.querySelector("[data-hsq-question-index]");
      var questionTitle = root.querySelector("[data-hsq-question-title]");
      var questionContext = root.querySelector("[data-hsq-question-context]");
      var optionsWrap = root.querySelector("[data-hsq-options]");
      var backButton = root.querySelector("[data-hsq-back]");

      function publish(eventName, detail) {
        var payload = Object.assign({
          quiz_id: "hume_band_health_signal_quiz",
          quiz_version: root.getAttribute("data-quiz-version") || "unknown",
          page_path: window.location.pathname,
          device_type: window.matchMedia("(max-width: 820px)").matches ? "mobile" : "desktop"
        }, detail || {});
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: eventName, health_signal_quiz: payload });
        root.dispatchEvent(new CustomEvent(eventName, { detail: payload, bubbles: true }));
      }

      function updateProgress() {
        var complete = state.step < 0 ? 0 : Math.min(questions.length, state.step + 1);
        var percent = state.step < 0 ? 0 : ((state.step + 1) / questions.length) * 100;
        progressBar.style.width = Math.min(100, percent) + "%";
        progress.setAttribute("aria-valuenow", String(Math.round(Math.min(100, percent))));
        progressCount.textContent = state.step < 0 ? "9 questions · about 60 seconds" : "Question " + complete + " of " + questions.length;
        stepLabel.textContent = state.step >= 0 && questions[state.step] ? questions[state.step].label : "Start";
        backButton.hidden = state.step <= 0;
      }

      function resetScoreState() {
        state.scores = { sleep: 0, stress: 0, recovery: 0, heart: 0, aging: 0, data: 0, habit: 0 };
        state.wearable = "";
        state.objection = "";
        state.answers.forEach(function (answerText, index) {
          var question = questions[index];
          if (!question) {
            return;
          }
          var option = question.options.find(function (candidate) {
            return candidate.text === answerText;
          });
          if (!option) {
            return;
          }
          Object.keys(option.scores).forEach(function (key) {
            state.scores[key] += option.scores[key];
          });
          if (option.wearable) {
            state.wearable = option.wearable;
          }
          if (option.objection) {
            state.objection = option.objection;
          }
        });
      }

      function recordAnswer(question, option, optionIndex) {
        state.answers[state.step] = option.text;
        state.answerIds[state.step] = question.id + "_" + (optionIndex + 1);
        state.answers = state.answers.slice(0, state.step + 1);
        state.answerIds = state.answerIds.slice(0, state.step + 1);
        resetScoreState();
      }

      function showQuestion(index) {
        if (state.isTransitioning) {
          return;
        }
        state.step = index;
        updateProgress();
        startPanel.hidden = true;
        analyzingPanel.hidden = true;
        resultPanel.hidden = true;
        questionPanel.hidden = false;
        var question = questions[index];
        questionIndex.textContent = "Question " + (index + 1) + " of " + questions.length;
        questionTitle.textContent = question.title;
        questionContext.textContent = question.context || "";
        optionsWrap.innerHTML = "";
        question.options.forEach(function (option, optionIndex) {
          var button = document.createElement("button");
          button.type = "button";
          button.className = "hsq-option";
          button.textContent = option.text;
          button.setAttribute("aria-pressed", state.answers[index] === option.text ? "true" : "false");
          if (state.answers[index] === option.text) {
            button.classList.add("is-selected");
          }
          button.addEventListener("click", function () {
            if (state.isTransitioning) {
              return;
            }
            state.isTransitioning = true;
            Array.prototype.forEach.call(optionsWrap.querySelectorAll(".hsq-option"), function (optionButton) {
              optionButton.disabled = true;
              optionButton.setAttribute("aria-pressed", "false");
            });
            button.classList.add("is-selected");
            button.setAttribute("aria-pressed", "true");
            recordAnswer(question, option, optionIndex);
            publish("band_signal_quiz_question_answered", {
              question_id: question.id,
              answer_id: state.answerIds[index],
              question_number: index + 1,
              funnel_step: "question"
            });
            window.setTimeout(function () {
              state.isTransitioning = false;
              if (index + 1 < questions.length) {
                showQuestion(index + 1);
              } else {
                showAnalyzing();
              }
            }, 180);
          });
          optionsWrap.appendChild(button);
        });
        publish("band_signal_quiz_question_viewed", {
          question_id: question.id,
          question_number: index + 1,
          funnel_step: "question"
        });
      }

      function getWinner() {
        var winner = "sleep";
        Object.keys(state.scores).forEach(function (key) {
          if (state.scores[key] > state.scores[winner]) {
            winner = key;
          }
        });
        if (state.wearable && state.wearable !== "no consistent tracker") {
          var dataScore = state.scores.data;
          if (dataScore >= state.scores[winner] - 1) {
            winner = "data";
          }
        }
        return winner;
      }

      function fillList(selector, items) {
        var target = root.querySelector(selector);
        target.innerHTML = "";
        items.forEach(function (item) {
          var li = document.createElement("li");
          li.textContent = item;
          target.appendChild(li);
        });
      }

      function slug(value) {
        return String(value || "unknown").toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
      }

      function getCtaUrl(result) {
        var base = root.getAttribute("data-cta-url") || "https://humehealth.com/pages/hume-bandv2";
        var separator = base.indexOf("?") === -1 ? "?" : "&";
        var params = [
          ["utm_source", "thewearabletech"],
          ["utm_medium", "quiz"],
          ["utm_campaign", "wearable_gap_quiz"],
          ["utm_content", slug(result.title)],
          ["utm_term", slug(result.signal)],
          ["quiz_result", slug(result.title)],
          ["quiz_signal", slug(result.signal)],
          ["quiz_wearable", slug(state.wearable)],
          ["quiz_objection", slug(state.objection)]
        ];
        return base + separator + params.map(function (pair) {
          return encodeURIComponent(pair[0]) + "=" + encodeURIComponent(pair[1]);
        }).join("&");
      }

      function showAnalyzing() {
        questionPanel.hidden = true;
        resultPanel.hidden = true;
        analyzingPanel.hidden = false;
        progressBar.style.width = "96%";
        progress.setAttribute("aria-valuenow", "96");
        progressCount.textContent = "Preparing result";
        stepLabel.textContent = "Analyzing";
        window.setTimeout(showResult, 520);
      }

      function showResult() {
        var winner = getWinner();
        var result = results[winner];
        state.completedAt = Date.now();
        analyzingPanel.hidden = true;
        questionPanel.hidden = true;
        resultPanel.hidden = false;
        progressBar.style.width = "100%";
        progress.setAttribute("aria-valuenow", "100");
        progressCount.textContent = questions.length + " of " + questions.length;
        stepLabel.textContent = "Result";

        root.querySelector("[data-hsq-result-title]").textContent = result.title;
        root.querySelector("[data-hsq-result-signal]").textContent = result.signal;
        root.querySelector("[data-hsq-result-summary]").textContent = result.summary;
        root.querySelector("[data-hsq-insight]").textContent = result.insight;
        root.querySelector("[data-hsq-result-cta]").setAttribute("href", getCtaUrl(result));
        root.querySelector("[data-hsq-bridge-title]").textContent = result.bridgeTitle;
        root.querySelector("[data-hsq-bridge-copy]").textContent = result.bridgeCopy;
        fillList("[data-hsq-missing]", result.missing);
        fillList("[data-hsq-features]", result.features);

        var recap = root.querySelector("[data-hsq-recap]");
        recap.innerHTML = "";
        state.answers.slice(0, 3).forEach(function (answer) {
          var span = document.createElement("span");
          span.textContent = answer;
          recap.appendChild(span);
        });

        publish("band_signal_quiz_completed", {
          result_type: winner,
          result: result.title,
          signal: result.signal,
          wearable: state.wearable,
          objection: state.objection,
          cta_url: getCtaUrl(result),
          completion_seconds: state.startedAt ? Math.round((state.completedAt - state.startedAt) / 1000) : null,
          scores: state.scores,
          funnel_step: "result"
        });
      }

      function goBack() {
        if (state.isTransitioning || state.step <= 0) {
          return;
        }
        publish("band_signal_quiz_back_clicked", {
          from_question_number: state.step + 1,
          to_question_number: state.step,
          funnel_step: "question"
        });
        showQuestion(state.step - 1);
      }

      root.querySelector("[data-hsq-result-cta]").addEventListener("click", function () {
        var winner = getWinner();
        publish("band_signal_quiz_product_cta_clicked", {
          result_type: winner,
          cta_location: "result",
          cta_url: getCtaUrl(results[winner]),
          funnel_step: "pdp_handoff"
        });
      });

      root.querySelector("[data-hsq-start-button]").addEventListener("click", function () {
        state.startedAt = Date.now();
        publish("band_signal_quiz_started", {
          funnel_step: "start"
        });
        showQuestion(0);
      });

      backButton.addEventListener("click", goBack);

      updateProgress();
    }

    roots.forEach(setupQuiz);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hume-band-daily-vital-check-hume-design"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll("[data-hume-daily-check]");
    if (!roots.length) return;

    var steps = [
      {
        id: "age",
        label: "Question 1",
        type: "single",
        kicker: "Daily Vital Check",
        title: "Find which daily health signal may be making your data harder to act on.",
        subtitle: "Start with your age so we can calibrate your daily signal pattern. Takes about 2 minutes. No email required.",
        options: [
          { text: "Under 35", score: { resilience: 1 } },
          { text: "35-44", score: { resilience: 1, load: 1 } },
          { text: "45-54", score: { load: 2 } },
          { text: "55-64", score: { load: 3 } },
          { text: "65 or older", score: { load: 4 } }
        ]
      },
      {
        id: "signals",
        label: "Question 2",
        type: "multi",
        kicker: "Choose all that apply",
        title: "Which hidden body signals have you noticed lately?",
        subtitle: "Choose all that apply.",
        options: [
          { text: "Waking up tired even after enough sleep", score: { sleep: 3, load: 1 }, concern: "unrefreshing sleep" },
          { text: "Afternoon energy crash or brain fog", score: { recovery: 2, load: 1 }, concern: "energy dips" },
          { text: "Stress feels like it stays in my body", score: { stress: 3, load: 1 }, concern: "stress load" },
          { text: "I do not know when to push or rest", score: { recovery: 3 }, concern: "recovery confusion" },
          { text: "Heart, HRV, or BP trends feel hard to read", score: { heart: 3 }, concern: "heart trend clarity" },
          { text: "My wearable gives numbers, not next steps", score: { data: 3 }, concern: "data without direction" }
        ]
      },
      {
        id: "wearable",
        label: "Question 3",
        type: "single",
        kicker: "Current tracking",
        title: "What are you using to track your health right now?",
        subtitle: "This helps us understand whether your gap is measurement, interpretation, or consistency.",
        options: [
          { text: "Apple Watch", score: { data: 3 }, wearable: "Apple Watch" },
          { text: "Oura Ring", score: { data: 3 }, wearable: "Oura Ring" },
          { text: "WHOOP", score: { data: 3 }, wearable: "WHOOP" },
          { text: "Garmin or Fitbit", score: { data: 2, consistency: 1 }, wearable: "Garmin or Fitbit" },
          { text: "Another wearable", score: { data: 2 }, wearable: "another wearable" },
          { text: "Nothing consistently", score: { consistency: 3 }, wearable: "no consistent tracker" }
        ]
      },
      {
        id: "duration",
        label: "Question 4",
        type: "single",
        kicker: "Pattern length",
        title: "How long have these signals felt unclear?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "Just started recently", score: { resilience: 1 } },
          { text: "A few months", score: { load: 1 } },
          { text: "Around a year", score: { load: 2 } },
          { text: "Several years", score: { load: 3 } },
          { text: "I cannot remember when it started", score: { load: 4 } }
        ]
      },
      {
        id: "reassurance",
        label: "Checkpoint",
        type: "info",
        kicker: "You are in the right place",
        title: "Thousands of people are tracking health data but still missing the pattern.",
        subtitle: "If your biggest issue is @mainConcern, the next step is not more random numbers. It is seeing how sleep, stress, heart trends, recovery, and habits connect."
      },
      {
        id: "sleep",
        label: "Question 5",
        type: "single",
        kicker: "Sleep signal",
        title: "What best describes your sleep lately?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "I sleep enough but still wake up tired", score: { sleep: 3, load: 1 } },
          { text: "My sleep varies a lot night to night", score: { sleep: 2, consistency: 1 } },
          { text: "Stress clearly affects my sleep", score: { stress: 2, sleep: 1 } },
          { text: "I mostly sleep fine", score: { resilience: 1 } },
          { text: "I do not know what my sleep data means", score: { data: 3 } }
        ]
      },
      {
        id: "conditions",
        label: "Question 6",
        type: "multi",
        kicker: "Choose all that apply",
        title: "Which wellness areas do you want more context around?",
        subtitle: "Choose all that apply.",
        options: [
          { text: "Blood pressure wellness trends", score: { heart: 3 } },
          { text: "HRV and resting heart rate", score: { heart: 2, recovery: 1 } },
          { text: "Stress and nervous system load", score: { stress: 3 } },
          { text: "Sleep quality and sleep stages", score: { sleep: 3 } },
          { text: "Recovery after workouts or long days", score: { recovery: 3 } },
          { text: "Long-term health direction", score: { longevity: 3 } }
        ]
      },
      {
        id: "noise",
        label: "Question 7",
        type: "single",
        kicker: "Data overload",
        title: "How does your current wearable usually leave you feeling?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "I see scores but do not know what to do", score: { data: 4 } },
          { text: "I only check it when something feels off", score: { consistency: 2, data: 1 } },
          { text: "I like the data, but it feels disconnected", score: { data: 3 } },
          { text: "It helps, but I want a clearer daily focus", score: { recovery: 1, data: 2 } },
          { text: "I mostly ignore the app", score: { consistency: 3 } }
        ]
      },
      {
        id: "profile",
        label: "Profile",
        type: "profile",
        kicker: "Your Daily Vital Profile",
        title: "Your disconnected signal assessment",
        subtitle: "Based on your answers, your body signals may be creating more noise than direction."
      },
      {
        id: "doctor",
        label: "Question 8",
        type: "multi",
        kicker: "Choose all that apply",
        title: "What have you already tried to make sense of your health data?",
        subtitle: "Choose all that apply.",
        options: [
          { text: "Checking wearable scores every morning", score: { data: 2 } },
          { text: "Changing sleep or bedtime habits", score: { sleep: 1, consistency: 1 } },
          { text: "Adjusting workouts based on recovery", score: { recovery: 2 } },
          { text: "Meditation, breathwork, or stress tools", score: { stress: 2 } },
          { text: "Reading articles or watching health content", score: { data: 1 } },
          { text: "Nothing consistently yet", score: { consistency: 3 } }
        ]
      },
      {
        id: "education",
        label: "Why it happens",
        type: "education",
        kicker: "",
        title: "Here's Why Your Wearable Numbers Still Feel Confusing...",
        subtitle: ""
      },
      {
        id: "routine",
        label: "Question 9",
        type: "single",
        kicker: "Daily routine",
        title: "How much time can you spare for a health check each day?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "Under 30 seconds", score: { consistency: 3 } },
          { text: "About 1 minute", score: { consistency: 2 } },
          { text: "2-5 minutes", score: { resilience: 1 } },
          { text: "10+ minutes", score: { resilience: 1 } },
          { text: "I do not have a routine", score: { consistency: 3, load: 1 } }
        ]
      },
      {
        id: "worry",
        label: "Question 10",
        type: "single",
        kicker: "Motivation",
        title: "How concerned are you about missing important health signals?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "Very concerned - I think about it often", score: { load: 3 } },
          { text: "Concerned when my numbers look off", score: { load: 2, data: 1 } },
          { text: "Somewhat concerned", score: { load: 1 } },
          { text: "Not worried yet, but I want better direction", score: { longevity: 2 } }
        ]
      },
      {
        id: "meaning",
        label: "Question 11",
        type: "single",
        kicker: "Goal",
        title: "If your daily signals finally made sense, what would it mean to you?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "Wake up knowing what my body needs today", score: { sleep: 1, recovery: 2 }, goal: "daily direction" },
          { text: "Stop guessing when to push or recover", score: { recovery: 3 }, goal: "recovery clarity" },
          { text: "Understand stress before it runs me down", score: { stress: 3 }, goal: "stress clarity" },
          { text: "Feel confident my long-term habits are working", score: { longevity: 3 }, goal: "long-term direction" },
          { text: "Spend less time decoding my app", score: { data: 3 }, goal: "less data overload" }
        ]
      },
      {
        id: "event",
        label: "Question 12",
        type: "single",
        kicker: "Timeline",
        title: "When would you most want clearer health direction?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "This week", score: { consistency: 2 }, event: "this week" },
          { text: "Before my next busy work stretch", score: { stress: 2 }, event: "your next high-stress week" },
          { text: "Before my next training block", score: { recovery: 2 }, event: "your next training block" },
          { text: "Over the next 30 days", score: { longevity: 1 }, event: "the next 30 days" },
          { text: "I just want to start now", score: { data: 1 }, event: "today" }
        ]
      }
    ];

    var resultProfiles = {
      sleep: {
        title: "Your daily signal pattern: sleep-recovery clarity gap.",
        copy: "Your answers point to sleep quality and next-day recovery as the signal that deserves attention first.",
        recommendation: "Hume Band 2.0 is built to connect sleep, HRV, recovery, stress, and daily habits into a clearer morning read, so you can see what your body may be asking for next.",
        because: ["Sleep and recovery showed up as your strongest pattern.", "You want less guessing when your morning energy feels off.", "Your result is about connecting signals, not adding another isolated score."],
        now: [["Sleep signal", "Unclear"], ["Recovery", "Hard to predict"], ["Morning direction", "Low"], ["Pattern confidence", "Spotty"]],
        goal: [["Sleep signal", "Connected"], ["Recovery", "Easier to read"], ["Morning direction", "Clearer"], ["Pattern confidence", "Building"]],
        timelineOne: "First 7 days: start seeing how sleep, HRV, and recovery move together.",
        timelineTwo: "By @event: use your daily read to know whether to push, rest, or adjust."
      },
      stress: {
        title: "Your daily signal pattern: stress-load visibility gap.",
        copy: "Your answers suggest stress may be showing up in sleep, HRV, recovery, and energy before it feels obvious.",
        recommendation: "Hume Band 2.0 helps surface how stress, recovery, sleep, and heart trends move together, giving you a clearer daily read instead of scattered alerts.",
        because: ["Stress context was one of your strongest answer patterns.", "You want to notice the body-data pattern before the day feels derailed.", "The next step is a connected read across signals, not more one-off numbers."],
        now: [["Stress load", "Hard to see"], ["HRV context", "Disconnected"], ["Recovery", "Reactive"], ["Daily focus", "Unclear"]],
        goal: [["Stress load", "Visible"], ["HRV context", "Connected"], ["Recovery", "More proactive"], ["Daily focus", "Clearer"]],
        timelineOne: "First 7 days: watch how stressful days change sleep and recovery signals.",
        timelineTwo: "By @event: spot the days where your body may need a lighter plan."
      },
      recovery: {
        title: "Your daily signal pattern: push-or-rest uncertainty.",
        copy: "Your answers point to recovery direction as the main gap. The problem is not effort. It is knowing when effort is helping.",
        recommendation: "Hume Band 2.0 helps connect activity, sleep, HRV, stress, and recovery signals into a daily read you can use when deciding whether to push, rest, or adjust.",
        because: ["Recovery direction was your clearest signal gap.", "You want your effort matched to what your body data is showing.", "The useful output is daily context, not a pile of disconnected metrics."],
        now: [["Readiness", "Guesswork"], ["Activity", "Separate"], ["Sleep debt", "Easy to miss"], ["Training choices", "Reactive"]],
        goal: [["Readiness", "Contextual"], ["Activity", "Connected"], ["Sleep debt", "Visible"], ["Training choices", "More intentional"]],
        timelineOne: "First 7 days: connect activity, sleep, and HRV into a clearer recovery read.",
        timelineTwo: "By @event: make push-or-rest decisions with less second-guessing."
      },
      heart: {
        title: "Your daily signal pattern: heart-trend context gap.",
        copy: "Your answers suggest you want more than one-off numbers. You want to understand how heart-related wellness trends fit the bigger pattern.",
        recommendation: "Hume Band 2.0 helps track heart-related wellness trends in context with sleep, recovery, stress, and activity, so changes are easier to follow over time.",
        because: ["Heart-trend context showed up strongly in your answers.", "You want patterns you can follow, not isolated readings.", "A connected daily read gives your wearable data more practical context."],
        now: [["Heart trends", "One-off"], ["BP wellness", "Hard to contextualize"], ["HRV", "Isolated"], ["Confidence", "Low"]],
        goal: [["Heart trends", "Tracked over time"], ["BP wellness", "In context"], ["HRV", "Connected"], ["Confidence", "Improving"]],
        timelineOne: "First 7 days: start connecting heart, HRV, sleep, and recovery trends.",
        timelineTwo: "By @event: have a clearer wellness trend picture to follow or discuss."
      },
      longevity: {
        title: "Your daily signal pattern: long-term direction gap.",
        copy: "Your answers suggest daily scores are not enough. You want to know whether your routine is moving your bigger health direction.",
        recommendation: "Hume Band 2.0 helps turn recurring sleep, recovery, heart, stress, activity, and habit signals into trends you can actually follow over time.",
        because: ["Your answers point to long-term health direction, not just today's score.", "You want feedback that makes habits easier to judge.", "The recommendation is a signal system you can keep using daily."],
        now: [["Daily scores", "Short-term"], ["Health direction", "Fuzzy"], ["Habit feedback", "Delayed"], ["Momentum", "Unknown"]],
        goal: [["Daily scores", "Part of a trend"], ["Health direction", "Clearer"], ["Habit feedback", "Faster"], ["Momentum", "Visible"]],
        timelineOne: "First 7 days: create a baseline across sleep, recovery, activity, and heart trends.",
        timelineTwo: "By @event: start seeing whether your routine is moving in the right direction."
      },
      data: {
        title: "Your daily signal pattern: data overload.",
        copy: "Your answers suggest your biggest gap is interpretation. You may already have data, but not the daily direction it should create.",
        recommendation: "Hume Band 2.0 is built to connect the signals many wearables leave scattered, helping your body data become a clearer daily read instead of another dashboard to decode.",
        because: ["You already have or want data, but need it translated into direction.", "Your result points to interpretation as the bottleneck.", "The next step is a wearable that connects the pattern across signals."],
        now: [["Health data", "Scattered"], ["Next step", "Unclear"], ["App fatigue", "High"], ["Confidence", "Low"]],
        goal: [["Health data", "Connected"], ["Next step", "Clearer"], ["App fatigue", "Lower"], ["Confidence", "Building"]],
        timelineOne: "First 7 days: see which signal deserves attention first instead of chasing every metric.",
        timelineTwo: "By @event: use a simpler daily read instead of decoding another dashboard."
      },
      consistency: {
        title: "Your daily signal pattern: consistency gap.",
        copy: "Your answers suggest the issue may be missing data gaps, charging friction, or not having a simple reason to check in daily.",
        recommendation: "Hume Band 2.0 is designed for a simpler daily wearable routine, helping you build a steadier signal baseline across sleep, recovery, activity, and heart trends.",
        because: ["Your answers suggest consistency is blocking better signal quality.", "You need a routine that is easy to repeat, not another app you ignore.", "Better daily context starts with a cleaner wearable baseline."],
        now: [["Wear time", "Inconsistent"], ["Night data", "Easy to miss"], ["Daily habit", "Loose"], ["Signal quality", "Patchy"]],
        goal: [["Wear time", "More consistent"], ["Night data", "Captured"], ["Daily habit", "Simple"], ["Signal quality", "Cleaner"]],
        timelineOne: "First 7 days: build a steadier baseline with a wearable designed for longer, simpler use.",
        timelineTwo: "By @event: make daily tracking feel easier to maintain."
      }
    };

    function setup(root) {
      var state = {
        step: 0,
        scores: { sleep: 0, stress: 0, recovery: 0, heart: 0, longevity: 0, data: 0, consistency: 0, load: 0, resilience: 0 },
        answers: {},
        selected: [],
        mainConcern: "disconnected signals",
        wearable: "unknown",
        goal: "daily direction",
        event: "the next 30 days",
        startedAt: Date.now(),
        hasStarted: false,
        hasCompleted: false
      };

      var card = root.querySelector("[data-hdc-card]");
      var kicker = root.querySelector("[data-hdc-kicker]");
      var title = root.querySelector("[data-hdc-title]");
      var subtitle = root.querySelector("[data-hdc-subtitle]");
      var options = root.querySelector("[data-hdc-options]");
      var continueButton = root.querySelector("[data-hdc-continue]");
      var backButton = root.querySelector("[data-hdc-back]");
      var progress = root.querySelector("[data-hdc-progress]");
      var progressBar = root.querySelector("[data-hdc-progress-bar]");
      var stepLabel = root.querySelector("[data-hdc-step-label]");
      var stepCount = root.querySelector("[data-hdc-step-count]");
      var profile = root.querySelector("[data-hdc-profile]");
      var education = root.querySelector("[data-hdc-education]");
      var result = root.querySelector("[data-hdc-result]");
      var actions = root.querySelector("[data-hdc-actions]");
      var infoVisual = root.querySelector("[data-hdc-info-visual]");

      function slug(value) {
        return String(value || "unknown").toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
      }

      function publish(eventName, detail) {
        var payload = Object.assign({
          quiz_id: "hume_daily_vital_check",
          quiz_version: root.getAttribute("data-quiz-version") || "unknown",
          page_path: window.location.pathname,
          step_id: steps[state.step] ? steps[state.step].id : "result"
        }, detail || {});
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: eventName, hume_daily_vital_check: payload });
        document.dispatchEvent(new CustomEvent(eventName, { detail: payload }));
        if (typeof window.gtag === "function") {
          window.gtag("event", eventName, payload);
        }
      }

      function resetScores() {
        state.scores = { sleep: 0, stress: 0, recovery: 0, heart: 0, longevity: 0, data: 0, consistency: 0, load: 0, resilience: 0 };
        state.mainConcern = "disconnected signals";
        state.wearable = "unknown";
        state.goal = "daily direction";
        state.event = "the next 30 days";
        steps.forEach(function (step) {
          var saved = state.answers[step.id] || [];
          saved.forEach(function (index) {
            var option = step.options && step.options[index];
            if (!option) return;
            Object.keys(option.score || {}).forEach(function (key) {
              state.scores[key] += option.score[key];
            });
            if (option.concern) state.mainConcern = option.concern;
            if (option.wearable) state.wearable = option.wearable;
            if (option.goal) state.goal = option.goal;
            if (option.event) state.event = option.event;
          });
        });
      }

      function topSignal() {
        var keys = ["sleep", "stress", "recovery", "heart", "longevity", "data", "consistency"];
        var winner = keys[0];
        keys.forEach(function (key) {
          if (state.scores[key] > state.scores[winner]) winner = key;
        });
        if (state.scores.data >= state.scores[winner] - 1 && state.wearable !== "no consistent tracker") {
          winner = "data";
        }
        return winner;
      }

      function level() {
        var net = Math.max(0, state.scores.load - state.scores.resilience);
        if (net <= 1) return { label: "Low", marker: "12%", disconnect: "Low", recovery: "Clearer", direction: "Available", potential: "High" };
        if (net <= 3) return { label: "Moderate", marker: "50%", disconnect: "Moderate", recovery: "Mixed", direction: "Needs focus", potential: "Very high" };
        if (net <= 5) return { label: "High", marker: "73%", disconnect: "High", recovery: "Hard to read", direction: "Low", potential: "High" };
        return { label: "Very high", marker: "91%", disconnect: "Very high", recovery: "Reactive", direction: "Very low", potential: "High" };
      }

      function replaceTokens(text) {
        return String(text || "").replace(/@mainConcern/g, state.mainConcern).replace(/@event/g, state.event).replace(/@goal/g, state.goal);
      }

      function clearSpecialViews() {
        infoVisual.hidden = true;
        profile.hidden = true;
        education.hidden = true;
        result.hidden = true;
      }

      function updateProgress() {
        var percent = Math.round((state.step / Math.max(1, steps.length)) * 100);
        progressBar.style.width = percent + "%";
        progress.setAttribute("aria-valuenow", String(percent));
        stepLabel.textContent = steps[state.step] ? steps[state.step].label : "Result";
        stepCount.textContent = (state.step + 1) + " of " + steps.length;
        backButton.hidden = state.step === 0;
        actions.classList.toggle("has-back", !backButton.hidden);
      }

      function renderOptions(step) {
        options.innerHTML = "";
        if (!step.options) return;
        var selected = state.answers[step.id] || [];
        step.options.forEach(function (option, index) {
          var button = document.createElement("button");
          button.type = "button";
          button.className = "hdc-option";
          if (selected.indexOf(index) !== -1) button.classList.add("is-selected");
          button.setAttribute("aria-pressed", selected.indexOf(index) !== -1 ? "true" : "false");

          var number = document.createElement("span");
          number.className = "hdc-option-number";
          number.textContent = String(index + 1);
          var text = document.createElement("span");
          text.textContent = option.text;
          button.appendChild(number);
          button.appendChild(text);

          button.addEventListener("click", function () {
            if (step.type === "multi") {
              var current = state.answers[step.id] || [];
              var pos = current.indexOf(index);
              if (pos === -1) current.push(index);
              else current.splice(pos, 1);
              state.answers[step.id] = current;
              resetScores();
              renderOptions(step);
              continueButton.hidden = false;
              continueButton.disabled = current.length === 0;
              publish("question_answered", { question_id: step.id, answer: option.text, multi_select: true, step_number: state.step + 1 });
            } else {
              state.answers[step.id] = [index];
              resetScores();
              publish("question_answered", { question_id: step.id, answer: option.text, multi_select: false, step_number: state.step + 1 });
              window.setTimeout(next, 150);
            }
          });
          options.appendChild(button);
        });
      }

      function renderProfile() {
        var signalLevel = level();
        root.querySelector("[data-hdc-profile-level]").textContent = signalLevel.label;
        root.querySelector("[data-hdc-profile-disconnect]").textContent = signalLevel.disconnect;
        root.querySelector("[data-hdc-profile-recovery]").textContent = signalLevel.recovery;
        root.querySelector("[data-hdc-profile-direction]").textContent = signalLevel.direction;
        root.querySelector("[data-hdc-profile-potential]").textContent = signalLevel.potential;
        root.querySelector("[data-hdc-meter-marker]").style.setProperty("--marker", signalLevel.marker);
        profile.hidden = false;
      }

      function fillList(target, rows) {
        target.innerHTML = "";
        rows.forEach(function (row) {
          var li = document.createElement("li");
          var span = document.createElement("span");
          var strong = document.createElement("strong");
          span.textContent = row[0];
          strong.textContent = row[1];
          li.appendChild(span);
          li.appendChild(strong);
          target.appendChild(li);
        });
      }

      function fillBecause(profileData) {
        var list = root.querySelector("[data-hdc-because-list]");
        list.innerHTML = "";
        (profileData.because || []).forEach(function (item) {
          var li = document.createElement("li");
          li.textContent = replaceTokens(item);
          list.appendChild(li);
        });
      }

      function ctaUrl(profileData) {
        var base = root.getAttribute("data-cta-url") || "https://humehealth.com/pages/hume-bandv2";
        var separator = base.indexOf("?") === -1 ? "?" : "&";
        var params = [
          ["utm_source", "thewearabletech"],
          ["utm_medium", "quiz"],
          ["utm_campaign", "daily_vital_check"],
          ["utm_content", slug(profileData.title)],
          ["utm_term", slug(topSignal())],
          ["quiz_result", slug(profileData.title)],
          ["quiz_signal", slug(topSignal())],
          ["quiz_wearable", slug(state.wearable)],
          ["quiz_goal", slug(state.goal)]
        ];
        return base + separator + params.map(function (pair) {
          return encodeURIComponent(pair[0]) + "=" + encodeURIComponent(pair[1]);
        }).join("&");
      }

      function renderResult() {
        var profileData = resultProfiles[topSignal()] || resultProfiles.data;
        root.querySelector("[data-hdc-result-title]").textContent = replaceTokens(profileData.title);
        root.querySelector("[data-hdc-result-copy]").textContent = replaceTokens(profileData.copy);
        root.querySelector("[data-hdc-result-recommendation]").textContent = replaceTokens(profileData.recommendation);
        root.querySelector("[data-hdc-timeline-one]").textContent = replaceTokens(profileData.timelineOne);
        root.querySelector("[data-hdc-timeline-two]").textContent = replaceTokens(profileData.timelineTwo);
        fillBecause(profileData);
        fillList(root.querySelector("[data-hdc-now-list]"), profileData.now);
        fillList(root.querySelector("[data-hdc-goal-list]"), profileData.goal);
        root.querySelector("[data-hdc-cta]").setAttribute("href", ctaUrl(profileData));
        result.hidden = false;
        if (!state.hasCompleted) {
          state.hasCompleted = true;
          publish("quiz_completed", {
            result_type: topSignal(),
            completion_seconds: Math.round((Date.now() - state.startedAt) / 1000)
          });
        }
        publish("result_viewed", {
          result_type: topSignal(),
          cta_url: ctaUrl(profileData),
          completion_seconds: Math.round((Date.now() - state.startedAt) / 1000)
        });
      }

      function render() {
        var step = steps[state.step];
        root.setAttribute("data-step-type", step.type || "single");
        root.setAttribute("data-step-id", step.id || "");
        clearSpecialViews();
        options.innerHTML = "";
        continueButton.hidden = step.type === "single";
        continueButton.disabled = false;
        continueButton.textContent = step.cta || "Continue";
        actions.hidden = false;
        kicker.textContent = step.kicker || "";
        title.textContent = replaceTokens(step.title);
        subtitle.textContent = replaceTokens(step.subtitle);
        card.scrollTop = 0;

        if (step.type === "intro") {
          continueButton.hidden = false;
        }

        if (step.type === "single" || step.type === "multi") {
          renderOptions(step);
          if (step.type === "multi") {
            continueButton.hidden = false;
            continueButton.disabled = !(state.answers[step.id] || []).length;
          }
        }

        if (step.type === "info") {
          infoVisual.hidden = false;
          continueButton.hidden = false;
        }

        if (step.type === "profile") {
          renderProfile();
          continueButton.hidden = false;
        }

        if (step.type === "education") {
          education.hidden = false;
          continueButton.hidden = false;
        }

        updateProgress();
        if (!state.hasStarted) {
          state.hasStarted = true;
          publish("quiz_started", { step_id: step.id, step_type: step.type, step_number: state.step + 1 });
        }
        publish("question_viewed", { step_id: step.id, step_type: step.type, step_number: state.step + 1 });
      }

      function showResult() {
        root.setAttribute("data-step-type", "result");
        root.setAttribute("data-step-id", "result");
        clearSpecialViews();
        options.innerHTML = "";
        actions.hidden = true;
        actions.classList.remove("has-back");
        title.textContent = "";
        subtitle.textContent = "";
        kicker.textContent = "";
        progressBar.style.width = "100%";
        progress.setAttribute("aria-valuenow", "100");
        stepLabel.textContent = "Result";
        stepCount.textContent = "Complete";
        renderResult();
      }

      function next() {
        if (state.step + 1 >= steps.length) {
          showResult();
          return;
        }
        state.step += 1;
        render();
      }

      function back() {
        if (state.step <= 0) return;
        state.step -= 1;
        render();
      }

      continueButton.addEventListener("click", function () {
        if (continueButton.disabled) return;
        publish("quiz_continue_clicked", { step_id: steps[state.step].id, step_number: state.step + 1 });
        next();
      });

      backButton.addEventListener("click", function () {
        publish("quiz_back_clicked", { from_step: steps[state.step].id, step_number: state.step + 1 });
        back();
      });

      root.querySelector("[data-hdc-cta]").addEventListener("click", function () {
        publish("quiz_cta_clicked", { result_type: topSignal(), funnel_step: "pdp_handoff" });
      });

      render();
    }

    roots.forEach(setup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hume-band-daily-vital-check-rovina-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll("[data-hume-daily-check]");
    if (!roots.length) return;

    var steps = [
      {
        id: "age",
        label: "Question 1",
        type: "single",
        kicker: "Daily Vital Check",
        title: "How old are you?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "Under 35", score: { resilience: 1 } },
          { text: "35-44", score: { resilience: 1, load: 1 } },
          { text: "45-54", score: { load: 2 } },
          { text: "55-64", score: { load: 3 } },
          { text: "65 or older", score: { load: 4 } }
        ]
      },
      {
        id: "signals",
        label: "Question 2",
        type: "multi",
        kicker: "Choose all that apply",
        title: "Which hidden body signals have you noticed lately?",
        subtitle: "Choose all that apply.",
        options: [
          { text: "Waking up tired even after enough sleep", score: { sleep: 3, load: 1 }, concern: "unrefreshing sleep" },
          { text: "Afternoon energy crash or brain fog", score: { recovery: 2, load: 1 }, concern: "energy dips" },
          { text: "Stress feels like it stays in my body", score: { stress: 3, load: 1 }, concern: "stress load" },
          { text: "I do not know when to push or rest", score: { recovery: 3 }, concern: "recovery confusion" },
          { text: "Heart, HRV, or BP trends feel hard to read", score: { heart: 3 }, concern: "heart trend clarity" },
          { text: "My wearable gives numbers, not next steps", score: { data: 3 }, concern: "data without direction" }
        ]
      },
      {
        id: "wearable",
        label: "Question 3",
        type: "single",
        kicker: "Current tracking",
        title: "What are you using to track your health right now?",
        subtitle: "This helps us understand whether your gap is measurement, interpretation, or consistency.",
        options: [
          { text: "Apple Watch", score: { data: 3 }, wearable: "Apple Watch" },
          { text: "Oura Ring", score: { data: 3 }, wearable: "Oura Ring" },
          { text: "WHOOP", score: { data: 3 }, wearable: "WHOOP" },
          { text: "Garmin or Fitbit", score: { data: 2, consistency: 1 }, wearable: "Garmin or Fitbit" },
          { text: "Another wearable", score: { data: 2 }, wearable: "another wearable" },
          { text: "Nothing consistently", score: { consistency: 3 }, wearable: "no consistent tracker" }
        ]
      },
      {
        id: "duration",
        label: "Question 4",
        type: "single",
        kicker: "Pattern length",
        title: "How long have these signals felt unclear?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "Just started recently", score: { resilience: 1 } },
          { text: "A few months", score: { load: 1 } },
          { text: "Around a year", score: { load: 2 } },
          { text: "Several years", score: { load: 3 } },
          { text: "I cannot remember when it started", score: { load: 4 } }
        ]
      },
      {
        id: "reassurance",
        label: "Checkpoint",
        type: "info",
        kicker: "You are in the right place",
        title: "Thousands of people are tracking health data but still missing the pattern.",
        subtitle: "If your biggest issue is @mainConcern, the next step is not more random numbers. It is seeing how sleep, stress, heart trends, recovery, and habits connect."
      },
      {
        id: "sleep",
        label: "Question 5",
        type: "single",
        kicker: "Sleep signal",
        title: "What best describes your sleep lately?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "I sleep enough but still wake up tired", score: { sleep: 3, load: 1 } },
          { text: "My sleep varies a lot night to night", score: { sleep: 2, consistency: 1 } },
          { text: "Stress clearly affects my sleep", score: { stress: 2, sleep: 1 } },
          { text: "I mostly sleep fine", score: { resilience: 1 } },
          { text: "I do not know what my sleep data means", score: { data: 3 } }
        ]
      },
      {
        id: "conditions",
        label: "Question 6",
        type: "multi",
        kicker: "Choose all that apply",
        title: "Which wellness areas do you want more context around?",
        subtitle: "Choose all that apply.",
        options: [
          { text: "Blood pressure wellness trends", score: { heart: 3 } },
          { text: "HRV and resting heart rate", score: { heart: 2, recovery: 1 } },
          { text: "Stress and nervous system load", score: { stress: 3 } },
          { text: "Sleep quality and sleep stages", score: { sleep: 3 } },
          { text: "Recovery after workouts or long days", score: { recovery: 3 } },
          { text: "Long-term health direction", score: { longevity: 3 } }
        ]
      },
      {
        id: "noise",
        label: "Question 7",
        type: "single",
        kicker: "Data overload",
        title: "How does your current wearable usually leave you feeling?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "I see scores but do not know what to do", score: { data: 4 } },
          { text: "I only check it when something feels off", score: { consistency: 2, data: 1 } },
          { text: "I like the data, but it feels disconnected", score: { data: 3 } },
          { text: "It helps, but I want a clearer daily focus", score: { recovery: 1, data: 2 } },
          { text: "I mostly ignore the app", score: { consistency: 3 } }
        ]
      },
      {
        id: "profile",
        label: "Profile",
        type: "profile",
        kicker: "Your Daily Vital Profile",
        title: "Your disconnected signal assessment",
        subtitle: "Based on your answers, your body signals may be creating more noise than direction."
      },
      {
        id: "doctor",
        label: "Question 8",
        type: "multi",
        kicker: "Choose all that apply",
        title: "What have you already tried to make sense of your health data?",
        subtitle: "Choose all that apply.",
        options: [
          { text: "Checking wearable scores every morning", score: { data: 2 } },
          { text: "Changing sleep or bedtime habits", score: { sleep: 1, consistency: 1 } },
          { text: "Adjusting workouts based on recovery", score: { recovery: 2 } },
          { text: "Meditation, breathwork, or stress tools", score: { stress: 2 } },
          { text: "Reading articles or watching health content", score: { data: 1 } },
          { text: "Nothing consistently yet", score: { consistency: 3 } }
        ]
      },
      {
        id: "education",
        label: "Why it happens",
        type: "education",
        kicker: "",
        title: "Here's Why Your Wearable Numbers Still Feel Confusing...",
        subtitle: ""
      },
      {
        id: "routine",
        label: "Question 9",
        type: "single",
        kicker: "Daily routine",
        title: "How much time can you spare for a health check each day?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "Under 30 seconds", score: { consistency: 3 } },
          { text: "About 1 minute", score: { consistency: 2 } },
          { text: "2-5 minutes", score: { resilience: 1 } },
          { text: "10+ minutes", score: { resilience: 1 } },
          { text: "I do not have a routine", score: { consistency: 3, load: 1 } }
        ]
      },
      {
        id: "worry",
        label: "Question 10",
        type: "single",
        kicker: "Motivation",
        title: "How concerned are you about missing important health signals?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "Very concerned - I think about it often", score: { load: 3 } },
          { text: "Concerned when my numbers look off", score: { load: 2, data: 1 } },
          { text: "Somewhat concerned", score: { load: 1 } },
          { text: "Not worried yet, but I want better direction", score: { longevity: 2 } }
        ]
      },
      {
        id: "meaning",
        label: "Question 11",
        type: "single",
        kicker: "Goal",
        title: "If your daily signals finally made sense, what would it mean to you?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "Wake up knowing what my body needs today", score: { sleep: 1, recovery: 2 }, goal: "daily direction" },
          { text: "Stop guessing when to push or recover", score: { recovery: 3 }, goal: "recovery clarity" },
          { text: "Understand stress before it runs me down", score: { stress: 3 }, goal: "stress clarity" },
          { text: "Feel confident my long-term habits are working", score: { longevity: 3 }, goal: "long-term direction" },
          { text: "Spend less time decoding my app", score: { data: 3 }, goal: "less data overload" }
        ]
      },
      {
        id: "event",
        label: "Question 12",
        type: "single",
        kicker: "Timeline",
        title: "When would you most want clearer health direction?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "This week", score: { consistency: 2 }, event: "this week" },
          { text: "Before my next busy work stretch", score: { stress: 2 }, event: "your next high-stress week" },
          { text: "Before my next training block", score: { recovery: 2 }, event: "your next training block" },
          { text: "Over the next 30 days", score: { longevity: 1 }, event: "the next 30 days" },
          { text: "I just want to start now", score: { data: 1 }, event: "today" }
        ]
      }
    ];

    var resultProfiles = {
      sleep: {
        title: "You are just one connected sleep-recovery read away from clearer mornings.",
        copy: "Your answers point to sleep quality and next-day recovery as the signal that deserves the most attention first.",
        now: [["Sleep signal", "Unclear"], ["Recovery", "Hard to predict"], ["Morning direction", "Low"], ["Pattern confidence", "Spotty"]],
        goal: [["Sleep signal", "Connected"], ["Recovery", "Easier to read"], ["Morning direction", "Clearer"], ["Pattern confidence", "Building"]],
        timelineOne: "First 7 days: start seeing how sleep, HRV, and recovery move together.",
        timelineTwo: "By @event: use your daily read to know whether to push, rest, or adjust."
      },
      stress: {
        title: "You are just one stress-load pattern away from catching the signal earlier.",
        copy: "Your answers suggest stress may be showing up in sleep, HRV, recovery, and energy before it feels obvious.",
        now: [["Stress load", "Hard to see"], ["HRV context", "Disconnected"], ["Recovery", "Reactive"], ["Daily focus", "Unclear"]],
        goal: [["Stress load", "Visible"], ["HRV context", "Connected"], ["Recovery", "More proactive"], ["Daily focus", "Clearer"]],
        timelineOne: "First 7 days: watch how stressful days change sleep and recovery signals.",
        timelineTwo: "By @event: spot the days where your body may need a lighter plan."
      },
      recovery: {
        title: "You are just one push-or-rest signal away from less guessing.",
        copy: "Your answers point to recovery direction as the main gap. The problem is not effort. It is knowing when effort is helping.",
        now: [["Readiness", "Guesswork"], ["Activity", "Separate"], ["Sleep debt", "Easy to miss"], ["Training choices", "Reactive"]],
        goal: [["Readiness", "Contextual"], ["Activity", "Connected"], ["Sleep debt", "Visible"], ["Training choices", "More intentional"]],
        timelineOne: "First 7 days: connect activity, sleep, and HRV into a clearer recovery read.",
        timelineTwo: "By @event: make push-or-rest decisions with less second-guessing."
      },
      heart: {
        title: "You are just one heart-trend read away from clearer context.",
        copy: "Your answers suggest you want more than one-off numbers. You want to understand how heart-related wellness trends fit the bigger pattern.",
        now: [["Heart trends", "One-off"], ["BP wellness", "Hard to contextualize"], ["HRV", "Isolated"], ["Confidence", "Low"]],
        goal: [["Heart trends", "Tracked over time"], ["BP wellness", "In context"], ["HRV", "Connected"], ["Confidence", "Improving"]],
        timelineOne: "First 7 days: start connecting heart, HRV, sleep, and recovery trends.",
        timelineTwo: "By @event: have a clearer wellness trend picture to follow or discuss."
      },
      longevity: {
        title: "You are just one long-term signal away from knowing if your habits are working.",
        copy: "Your answers suggest daily scores are not enough. You want to know whether your routine is moving your bigger health direction.",
        now: [["Daily scores", "Short-term"], ["Health direction", "Fuzzy"], ["Habit feedback", "Delayed"], ["Momentum", "Unknown"]],
        goal: [["Daily scores", "Part of a trend"], ["Health direction", "Clearer"], ["Habit feedback", "Faster"], ["Momentum", "Visible"]],
        timelineOne: "First 7 days: create a baseline across sleep, recovery, activity, and heart trends.",
        timelineTwo: "By @event: start seeing whether your routine is moving in the right direction."
      },
      data: {
        title: "You are just one connected read away from escaping data overload.",
        copy: "Your answers suggest your biggest gap is interpretation. You may already have data, but not the daily direction it should create.",
        now: [["Health data", "Scattered"], ["Next step", "Unclear"], ["App fatigue", "High"], ["Confidence", "Low"]],
        goal: [["Health data", "Connected"], ["Next step", "Clearer"], ["App fatigue", "Lower"], ["Confidence", "Building"]],
        timelineOne: "First 7 days: see which signal deserves attention first instead of chasing every metric.",
        timelineTwo: "By @event: use a simpler daily read instead of decoding another dashboard."
      },
      consistency: {
        title: "You are just one consistent wearable routine away from a cleaner signal.",
        copy: "Your answers suggest the issue may be missing data gaps, charging friction, or not having a simple reason to check in daily.",
        now: [["Wear time", "Inconsistent"], ["Night data", "Easy to miss"], ["Daily habit", "Loose"], ["Signal quality", "Patchy"]],
        goal: [["Wear time", "More consistent"], ["Night data", "Captured"], ["Daily habit", "Simple"], ["Signal quality", "Cleaner"]],
        timelineOne: "First 7 days: build a steadier baseline with a wearable designed for longer, simpler use.",
        timelineTwo: "By @event: make daily tracking feel easier to maintain."
      }
    };

    function setup(root) {
      var state = {
        step: 0,
        scores: { sleep: 0, stress: 0, recovery: 0, heart: 0, longevity: 0, data: 0, consistency: 0, load: 0, resilience: 0 },
        answers: {},
        selected: [],
        mainConcern: "disconnected signals",
        wearable: "unknown",
        goal: "daily direction",
        event: "the next 30 days",
        startedAt: Date.now()
      };

      var card = root.querySelector("[data-hdc-card]");
      var kicker = root.querySelector("[data-hdc-kicker]");
      var title = root.querySelector("[data-hdc-title]");
      var subtitle = root.querySelector("[data-hdc-subtitle]");
      var options = root.querySelector("[data-hdc-options]");
      var continueButton = root.querySelector("[data-hdc-continue]");
      var backButton = root.querySelector("[data-hdc-back]");
      var progress = root.querySelector("[data-hdc-progress]");
      var progressBar = root.querySelector("[data-hdc-progress-bar]");
      var stepLabel = root.querySelector("[data-hdc-step-label]");
      var stepCount = root.querySelector("[data-hdc-step-count]");
      var profile = root.querySelector("[data-hdc-profile]");
      var education = root.querySelector("[data-hdc-education]");
      var result = root.querySelector("[data-hdc-result]");
      var actions = root.querySelector("[data-hdc-actions]");
      var infoVisual = root.querySelector("[data-hdc-info-visual]");

      function slug(value) {
        return String(value || "unknown").toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
      }

      function publish(eventName, detail) {
        var payload = Object.assign({
          quiz_id: "hume_daily_vital_check",
          quiz_version: root.getAttribute("data-quiz-version") || "unknown",
          page_path: window.location.pathname,
          step_id: steps[state.step] ? steps[state.step].id : "result"
        }, detail || {});
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: eventName, hume_daily_vital_check: payload });
        if (typeof window.gtag === "function") {
          window.gtag("event", eventName, payload);
        }
      }

      function resetScores() {
        state.scores = { sleep: 0, stress: 0, recovery: 0, heart: 0, longevity: 0, data: 0, consistency: 0, load: 0, resilience: 0 };
        state.mainConcern = "disconnected signals";
        state.wearable = "unknown";
        state.goal = "daily direction";
        state.event = "the next 30 days";
        steps.forEach(function (step) {
          var saved = state.answers[step.id] || [];
          saved.forEach(function (index) {
            var option = step.options && step.options[index];
            if (!option) return;
            Object.keys(option.score || {}).forEach(function (key) {
              state.scores[key] += option.score[key];
            });
            if (option.concern) state.mainConcern = option.concern;
            if (option.wearable) state.wearable = option.wearable;
            if (option.goal) state.goal = option.goal;
            if (option.event) state.event = option.event;
          });
        });
      }

      function topSignal() {
        var keys = ["sleep", "stress", "recovery", "heart", "longevity", "data", "consistency"];
        var winner = keys[0];
        keys.forEach(function (key) {
          if (state.scores[key] > state.scores[winner]) winner = key;
        });
        if (state.scores.data >= state.scores[winner] - 1 && state.wearable !== "no consistent tracker") {
          winner = "data";
        }
        return winner;
      }

      function level() {
        var net = Math.max(0, state.scores.load - state.scores.resilience);
        if (net <= 1) return { label: "Low", marker: "12%", disconnect: "Low", recovery: "Clearer", direction: "Available", potential: "High" };
        if (net <= 3) return { label: "Moderate", marker: "50%", disconnect: "Moderate", recovery: "Mixed", direction: "Needs focus", potential: "Very high" };
        if (net <= 5) return { label: "High", marker: "73%", disconnect: "High", recovery: "Hard to read", direction: "Low", potential: "High" };
        return { label: "Very high", marker: "91%", disconnect: "Very high", recovery: "Reactive", direction: "Very low", potential: "High" };
      }

      function replaceTokens(text) {
        return String(text || "").replace(/@mainConcern/g, state.mainConcern).replace(/@event/g, state.event).replace(/@goal/g, state.goal);
      }

      function clearSpecialViews() {
        infoVisual.hidden = true;
        profile.hidden = true;
        education.hidden = true;
        result.hidden = true;
      }

      function updateProgress() {
        var percent = Math.round((state.step / Math.max(1, steps.length)) * 100);
        progressBar.style.width = percent + "%";
        progress.setAttribute("aria-valuenow", String(percent));
        stepLabel.textContent = steps[state.step] ? steps[state.step].label : "Result";
        stepCount.textContent = Math.min(state.step + 1, steps.length) + " of " + steps.length;
        backButton.hidden = state.step === 0;
        actions.classList.toggle("has-back", !backButton.hidden);
      }

      function renderOptions(step) {
        options.innerHTML = "";
        if (!step.options) return;
        var selected = state.answers[step.id] || [];
        step.options.forEach(function (option, index) {
          var button = document.createElement("button");
          button.type = "button";
          button.className = "hdc-option";
          if (selected.indexOf(index) !== -1) button.classList.add("is-selected");
          button.setAttribute("aria-pressed", selected.indexOf(index) !== -1 ? "true" : "false");

          var number = document.createElement("span");
          number.className = "hdc-option-number";
          number.textContent = String(index + 1);
          var text = document.createElement("span");
          text.textContent = option.text;
          button.appendChild(number);
          button.appendChild(text);

          button.addEventListener("click", function () {
            if (step.type === "multi") {
              var current = state.answers[step.id] || [];
              var pos = current.indexOf(index);
              if (pos === -1) current.push(index);
              else current.splice(pos, 1);
              state.answers[step.id] = current;
              resetScores();
              renderOptions(step);
              continueButton.hidden = false;
              continueButton.disabled = current.length === 0;
              publish("daily_vital_answer_select", { question_id: step.id, answer: option.text, multi_select: true });
            } else {
              state.answers[step.id] = [index];
              resetScores();
              publish("daily_vital_answer_select", { question_id: step.id, answer: option.text, multi_select: false });
              window.setTimeout(next, 150);
            }
          });
          options.appendChild(button);
        });
      }

      function renderProfile() {
        var signalLevel = level();
        root.querySelector("[data-hdc-profile-level]").textContent = signalLevel.label;
        root.querySelector("[data-hdc-profile-disconnect]").textContent = signalLevel.disconnect;
        root.querySelector("[data-hdc-profile-recovery]").textContent = signalLevel.recovery;
        root.querySelector("[data-hdc-profile-direction]").textContent = signalLevel.direction;
        root.querySelector("[data-hdc-profile-potential]").textContent = signalLevel.potential;
        root.querySelector("[data-hdc-meter-marker]").style.setProperty("--marker", signalLevel.marker);
        profile.hidden = false;
      }

      function fillList(target, rows) {
        target.innerHTML = "";
        rows.forEach(function (row) {
          var li = document.createElement("li");
          var span = document.createElement("span");
          var strong = document.createElement("strong");
          span.textContent = row[0];
          strong.textContent = row[1];
          li.appendChild(span);
          li.appendChild(strong);
          target.appendChild(li);
        });
      }

      function ctaUrl(profileData) {
        var base = root.getAttribute("data-cta-url") || "https://humehealth.com/pages/hume-bandv2";
        var separator = base.indexOf("?") === -1 ? "?" : "&";
        var params = [
          ["utm_source", "thewearabletech"],
          ["utm_medium", "quiz"],
          ["utm_campaign", "daily_vital_check"],
          ["utm_content", slug(profileData.title)],
          ["utm_term", slug(topSignal())],
          ["quiz_result", slug(profileData.title)],
          ["quiz_signal", slug(topSignal())],
          ["quiz_wearable", slug(state.wearable)],
          ["quiz_goal", slug(state.goal)]
        ];
        return base + separator + params.map(function (pair) {
          return encodeURIComponent(pair[0]) + "=" + encodeURIComponent(pair[1]);
        }).join("&");
      }

      function renderResult() {
        var profileData = resultProfiles[topSignal()] || resultProfiles.data;
        root.querySelector("[data-hdc-result-title]").textContent = replaceTokens(profileData.title);
        root.querySelector("[data-hdc-result-copy]").textContent = replaceTokens(profileData.copy);
        root.querySelector("[data-hdc-timeline-one]").textContent = replaceTokens(profileData.timelineOne);
        root.querySelector("[data-hdc-timeline-two]").textContent = replaceTokens(profileData.timelineTwo);
        fillList(root.querySelector("[data-hdc-now-list]"), profileData.now);
        fillList(root.querySelector("[data-hdc-goal-list]"), profileData.goal);
        root.querySelector("[data-hdc-cta]").setAttribute("href", ctaUrl(profileData));
        result.hidden = false;
        publish("daily_vital_result_view", {
          result_type: topSignal(),
          cta_url: ctaUrl(profileData),
          completion_seconds: Math.round((Date.now() - state.startedAt) / 1000)
        });
      }

      function render() {
        var step = steps[state.step];
        root.setAttribute("data-step-type", step.type || "single");
        root.setAttribute("data-step-id", step.id || "");
        clearSpecialViews();
        options.innerHTML = "";
        continueButton.hidden = step.type === "single";
        continueButton.disabled = false;
        actions.hidden = false;
        kicker.textContent = step.kicker || "";
        title.textContent = replaceTokens(step.title);
        subtitle.textContent = replaceTokens(step.subtitle);
        card.scrollTop = 0;

        if (step.type === "single" || step.type === "multi") {
          renderOptions(step);
          if (step.type === "multi") {
            continueButton.hidden = false;
            continueButton.disabled = !(state.answers[step.id] || []).length;
          }
        }

        if (step.type === "info") {
          infoVisual.hidden = false;
          continueButton.hidden = false;
        }

        if (step.type === "profile") {
          renderProfile();
          continueButton.hidden = false;
        }

        if (step.type === "education") {
          education.hidden = false;
          continueButton.hidden = false;
        }

        updateProgress();
        publish("daily_vital_step_view", { step_id: step.id, step_type: step.type, step_number: state.step + 1 });
      }

      function showResult() {
        root.setAttribute("data-step-type", "result");
        root.setAttribute("data-step-id", "result");
        clearSpecialViews();
        options.innerHTML = "";
        actions.hidden = true;
        actions.classList.remove("has-back");
        title.textContent = "";
        subtitle.textContent = "";
        kicker.textContent = "";
        progressBar.style.width = "100%";
        progress.setAttribute("aria-valuenow", "100");
        stepLabel.textContent = "Result";
        stepCount.textContent = "Complete";
        renderResult();
      }

      function next() {
        if (state.step + 1 >= steps.length) {
          showResult();
          return;
        }
        state.step += 1;
        render();
      }

      function back() {
        if (state.step <= 0) return;
        state.step -= 1;
        render();
      }

      continueButton.addEventListener("click", function () {
        if (continueButton.disabled) return;
        publish("daily_vital_continue_click", { step_id: steps[state.step].id });
        next();
      });

      backButton.addEventListener("click", function () {
        publish("daily_vital_back_click", { from_step: steps[state.step].id });
        back();
      });

      root.querySelector("[data-hdc-cta]").addEventListener("click", function () {
        publish("daily_vital_offer_click", { result_type: topSignal(), funnel_step: "pdp_handoff" });
      });

      render();
    }

    roots.forEach(setup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hume-band-daily-vital-check-rovina-v3"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll("[data-hume-daily-check]");
    if (!roots.length) return;

    var steps = [
      {
        id: "age",
        label: "Question 1",
        type: "single",
        kicker: "Daily Vital Check",
        title: "How old are you?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "Under 35", score: { resilience: 1 } },
          { text: "35-44", score: { resilience: 1, load: 1 } },
          { text: "45-54", score: { load: 2 } },
          { text: "55-64", score: { load: 3 } },
          { text: "65 or older", score: { load: 4 } }
        ]
      },
      {
        id: "signals",
        label: "Question 2",
        type: "multi",
        kicker: "Choose all that apply",
        title: "Which hidden body signals have you noticed lately?",
        subtitle: "Choose all that apply.",
        options: [
          { text: "Waking up tired even after enough sleep", score: { sleep: 3, load: 1 }, concern: "unrefreshing sleep" },
          { text: "Afternoon energy crash or brain fog", score: { recovery: 2, load: 1 }, concern: "energy dips" },
          { text: "Stress feels like it stays in my body", score: { stress: 3, load: 1 }, concern: "stress load" },
          { text: "I do not know when to push or rest", score: { recovery: 3 }, concern: "recovery confusion" },
          { text: "Heart, HRV, or BP trends feel hard to read", score: { heart: 3 }, concern: "heart trend clarity" },
          { text: "My wearable gives numbers, not next steps", score: { data: 3 }, concern: "data without direction" }
        ]
      },
      {
        id: "wearable",
        label: "Question 3",
        type: "single",
        kicker: "Current tracking",
        title: "What are you using to track your health right now?",
        subtitle: "This helps us understand whether your gap is measurement, interpretation, or consistency.",
        options: [
          { text: "Apple Watch", score: { data: 3 }, wearable: "Apple Watch" },
          { text: "Oura Ring", score: { data: 3 }, wearable: "Oura Ring" },
          { text: "WHOOP", score: { data: 3 }, wearable: "WHOOP" },
          { text: "Garmin or Fitbit", score: { data: 2, consistency: 1 }, wearable: "Garmin or Fitbit" },
          { text: "Another wearable", score: { data: 2 }, wearable: "another wearable" },
          { text: "Nothing consistently", score: { consistency: 3 }, wearable: "no consistent tracker" }
        ]
      },
      {
        id: "duration",
        label: "Question 4",
        type: "single",
        kicker: "Pattern length",
        title: "How long have these signals felt unclear?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "Just started recently", score: { resilience: 1 } },
          { text: "A few months", score: { load: 1 } },
          { text: "Around a year", score: { load: 2 } },
          { text: "Several years", score: { load: 3 } },
          { text: "I cannot remember when it started", score: { load: 4 } }
        ]
      },
      {
        id: "reassurance",
        label: "Checkpoint",
        type: "info",
        kicker: "You are in the right place",
        title: "Thousands of people are tracking health data but still missing the pattern.",
        subtitle: "If your biggest issue is @mainConcern, the next step is not more random numbers. It is seeing how sleep, stress, heart trends, recovery, and habits connect."
      },
      {
        id: "sleep",
        label: "Question 5",
        type: "single",
        kicker: "Sleep signal",
        title: "What best describes your sleep lately?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "I sleep enough but still wake up tired", score: { sleep: 3, load: 1 } },
          { text: "My sleep varies a lot night to night", score: { sleep: 2, consistency: 1 } },
          { text: "Stress clearly affects my sleep", score: { stress: 2, sleep: 1 } },
          { text: "I mostly sleep fine", score: { resilience: 1 } },
          { text: "I do not know what my sleep data means", score: { data: 3 } }
        ]
      },
      {
        id: "conditions",
        label: "Question 6",
        type: "multi",
        kicker: "Choose all that apply",
        title: "Which wellness areas do you want more context around?",
        subtitle: "Choose all that apply.",
        options: [
          { text: "Blood pressure wellness trends", score: { heart: 3 } },
          { text: "HRV and resting heart rate", score: { heart: 2, recovery: 1 } },
          { text: "Stress and nervous system load", score: { stress: 3 } },
          { text: "Sleep quality and sleep stages", score: { sleep: 3 } },
          { text: "Recovery after workouts or long days", score: { recovery: 3 } },
          { text: "Long-term health direction", score: { longevity: 3 } }
        ]
      },
      {
        id: "noise",
        label: "Question 7",
        type: "single",
        kicker: "Data overload",
        title: "How does your current wearable usually leave you feeling?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "I see scores but do not know what to do", score: { data: 4 } },
          { text: "I only check it when something feels off", score: { consistency: 2, data: 1 } },
          { text: "I like the data, but it feels disconnected", score: { data: 3 } },
          { text: "It helps, but I want a clearer daily focus", score: { recovery: 1, data: 2 } },
          { text: "I mostly ignore the app", score: { consistency: 3 } }
        ]
      },
      {
        id: "profile",
        label: "Profile",
        type: "profile",
        kicker: "Your Daily Vital Profile",
        title: "Your disconnected signal assessment",
        subtitle: "Based on your answers, your body signals may be creating more noise than direction."
      },
      {
        id: "doctor",
        label: "Question 8",
        type: "multi",
        kicker: "Choose all that apply",
        title: "What have you already tried to make sense of your health data?",
        subtitle: "Choose all that apply.",
        options: [
          { text: "Checking wearable scores every morning", score: { data: 2 } },
          { text: "Changing sleep or bedtime habits", score: { sleep: 1, consistency: 1 } },
          { text: "Adjusting workouts based on recovery", score: { recovery: 2 } },
          { text: "Meditation, breathwork, or stress tools", score: { stress: 2 } },
          { text: "Reading articles or watching health content", score: { data: 1 } },
          { text: "Nothing consistently yet", score: { consistency: 3 } }
        ]
      },
      {
        id: "education",
        label: "Why it happens",
        type: "education",
        kicker: "",
        title: "Here's Why Your Wearable Numbers Still Feel Confusing...",
        subtitle: ""
      },
      {
        id: "routine",
        label: "Question 9",
        type: "single",
        kicker: "Daily routine",
        title: "How much time can you spare for a health check each day?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "Under 30 seconds", score: { consistency: 3 } },
          { text: "About 1 minute", score: { consistency: 2 } },
          { text: "2-5 minutes", score: { resilience: 1 } },
          { text: "10+ minutes", score: { resilience: 1 } },
          { text: "I do not have a routine", score: { consistency: 3, load: 1 } }
        ]
      },
      {
        id: "worry",
        label: "Question 10",
        type: "single",
        kicker: "Motivation",
        title: "How concerned are you about missing important health signals?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "Very concerned - I think about it often", score: { load: 3 } },
          { text: "Concerned when my numbers look off", score: { load: 2, data: 1 } },
          { text: "Somewhat concerned", score: { load: 1 } },
          { text: "Not worried yet, but I want better direction", score: { longevity: 2 } }
        ]
      },
      {
        id: "meaning",
        label: "Question 11",
        type: "single",
        kicker: "Goal",
        title: "If your daily signals finally made sense, what would it mean to you?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "Wake up knowing what my body needs today", score: { sleep: 1, recovery: 2 }, goal: "daily direction" },
          { text: "Stop guessing when to push or recover", score: { recovery: 3 }, goal: "recovery clarity" },
          { text: "Understand stress before it runs me down", score: { stress: 3 }, goal: "stress clarity" },
          { text: "Feel confident my long-term habits are working", score: { longevity: 3 }, goal: "long-term direction" },
          { text: "Spend less time decoding my app", score: { data: 3 }, goal: "less data overload" }
        ]
      },
      {
        id: "event",
        label: "Question 12",
        type: "single",
        kicker: "Timeline",
        title: "When would you most want clearer health direction?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "This week", score: { consistency: 2 }, event: "this week" },
          { text: "Before my next busy work stretch", score: { stress: 2 }, event: "your next high-stress week" },
          { text: "Before my next training block", score: { recovery: 2 }, event: "your next training block" },
          { text: "Over the next 30 days", score: { longevity: 1 }, event: "the next 30 days" },
          { text: "I just want to start now", score: { data: 1 }, event: "today" }
        ]
      }
    ];

    var resultProfiles = {
      sleep: {
        title: "You are just one connected sleep-recovery read away from clearer mornings.",
        copy: "Your answers point to sleep quality and next-day recovery as the signal that deserves the most attention first.",
        now: [["Sleep signal", "Unclear"], ["Recovery", "Hard to predict"], ["Morning direction", "Low"], ["Pattern confidence", "Spotty"]],
        goal: [["Sleep signal", "Connected"], ["Recovery", "Easier to read"], ["Morning direction", "Clearer"], ["Pattern confidence", "Building"]],
        timelineOne: "First 7 days: start seeing how sleep, HRV, and recovery move together.",
        timelineTwo: "By @event: use your daily read to know whether to push, rest, or adjust."
      },
      stress: {
        title: "You are just one stress-load pattern away from catching the signal earlier.",
        copy: "Your answers suggest stress may be showing up in sleep, HRV, recovery, and energy before it feels obvious.",
        now: [["Stress load", "Hard to see"], ["HRV context", "Disconnected"], ["Recovery", "Reactive"], ["Daily focus", "Unclear"]],
        goal: [["Stress load", "Visible"], ["HRV context", "Connected"], ["Recovery", "More proactive"], ["Daily focus", "Clearer"]],
        timelineOne: "First 7 days: watch how stressful days change sleep and recovery signals.",
        timelineTwo: "By @event: spot the days where your body may need a lighter plan."
      },
      recovery: {
        title: "You are just one push-or-rest signal away from less guessing.",
        copy: "Your answers point to recovery direction as the main gap. The problem is not effort. It is knowing when effort is helping.",
        now: [["Readiness", "Guesswork"], ["Activity", "Separate"], ["Sleep debt", "Easy to miss"], ["Training choices", "Reactive"]],
        goal: [["Readiness", "Contextual"], ["Activity", "Connected"], ["Sleep debt", "Visible"], ["Training choices", "More intentional"]],
        timelineOne: "First 7 days: connect activity, sleep, and HRV into a clearer recovery read.",
        timelineTwo: "By @event: make push-or-rest decisions with less second-guessing."
      },
      heart: {
        title: "You are just one heart-trend read away from clearer context.",
        copy: "Your answers suggest you want more than one-off numbers. You want to understand how heart-related wellness trends fit the bigger pattern.",
        now: [["Heart trends", "One-off"], ["BP wellness", "Hard to contextualize"], ["HRV", "Isolated"], ["Confidence", "Low"]],
        goal: [["Heart trends", "Tracked over time"], ["BP wellness", "In context"], ["HRV", "Connected"], ["Confidence", "Improving"]],
        timelineOne: "First 7 days: start connecting heart, HRV, sleep, and recovery trends.",
        timelineTwo: "By @event: have a clearer wellness trend picture to follow or discuss."
      },
      longevity: {
        title: "You are just one long-term signal away from knowing if your habits are working.",
        copy: "Your answers suggest daily scores are not enough. You want to know whether your routine is moving your bigger health direction.",
        now: [["Daily scores", "Short-term"], ["Health direction", "Fuzzy"], ["Habit feedback", "Delayed"], ["Momentum", "Unknown"]],
        goal: [["Daily scores", "Part of a trend"], ["Health direction", "Clearer"], ["Habit feedback", "Faster"], ["Momentum", "Visible"]],
        timelineOne: "First 7 days: create a baseline across sleep, recovery, activity, and heart trends.",
        timelineTwo: "By @event: start seeing whether your routine is moving in the right direction."
      },
      data: {
        title: "You are just one connected read away from escaping data overload.",
        copy: "Your answers suggest your biggest gap is interpretation. You may already have data, but not the daily direction it should create.",
        now: [["Health data", "Scattered"], ["Next step", "Unclear"], ["App fatigue", "High"], ["Confidence", "Low"]],
        goal: [["Health data", "Connected"], ["Next step", "Clearer"], ["App fatigue", "Lower"], ["Confidence", "Building"]],
        timelineOne: "First 7 days: see which signal deserves attention first instead of chasing every metric.",
        timelineTwo: "By @event: use a simpler daily read instead of decoding another dashboard."
      },
      consistency: {
        title: "You are just one consistent wearable routine away from a cleaner signal.",
        copy: "Your answers suggest the issue may be missing data gaps, charging friction, or not having a simple reason to check in daily.",
        now: [["Wear time", "Inconsistent"], ["Night data", "Easy to miss"], ["Daily habit", "Loose"], ["Signal quality", "Patchy"]],
        goal: [["Wear time", "More consistent"], ["Night data", "Captured"], ["Daily habit", "Simple"], ["Signal quality", "Cleaner"]],
        timelineOne: "First 7 days: build a steadier baseline with a wearable designed for longer, simpler use.",
        timelineTwo: "By @event: make daily tracking feel easier to maintain."
      }
    };

    function setup(root) {
      if (root.getAttribute("data-hdc-initialized") === "true") return;
      root.setAttribute("data-hdc-initialized", "true");
      var state = {
        step: 0,
        scores: { sleep: 0, stress: 0, recovery: 0, heart: 0, longevity: 0, data: 0, consistency: 0, load: 0, resilience: 0 },
        answers: {},
        selected: [],
        mainConcern: "disconnected signals",
        wearable: "unknown",
        goal: "daily direction",
        event: "the next 30 days",
        startedAt: Date.now(),
        transitioning: false,
        emailPending: false,
        emailAccepted: false,
        completedAt: null
      };

      var card = root.querySelector("[data-hdc-card]");
      var kicker = root.querySelector("[data-hdc-kicker]");
      var title = root.querySelector("[data-hdc-title]");
      var subtitle = root.querySelector("[data-hdc-subtitle]");
      var options = root.querySelector("[data-hdc-options]");
      var continueButton = root.querySelector("[data-hdc-continue]");
      var backButton = root.querySelector("[data-hdc-back]");
      var progress = root.querySelector("[data-hdc-progress]");
      var progressBar = root.querySelector("[data-hdc-progress-bar]");
      var stepLabel = root.querySelector("[data-hdc-step-label]");
      var stepCount = root.querySelector("[data-hdc-step-count]");
      var profile = root.querySelector("[data-hdc-profile]");
      var education = root.querySelector("[data-hdc-education]");
      var result = root.querySelector("[data-hdc-result]");
      var actions = root.querySelector("[data-hdc-actions]");
      var infoVisual = root.querySelector("[data-hdc-info-visual]");

      var emailForm = root.querySelector("[data-hdc-email-form]");
      var emailInput = root.querySelector("[data-hdc-email]");
      var emailConsent = root.querySelector("[data-hdc-email-consent]");
      var emailError = root.querySelector("[data-hdc-email-error]");
      var emailSubmit = root.querySelector("[data-hdc-email-submit]");
      var emailSkip = root.querySelector("[data-hdc-email-skip]");
      var emailStatus = root.querySelector("[data-hdc-email-status]");
      var listId = root.getAttribute("data-klaviyo-list-id");
      var companyId = root.getAttribute("data-klaviyo-company-id");
      var emailEnabled = !!(emailForm && listId && companyId);

      function slug(value) {
        return String(value || "unknown").toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
      }

      function publish(eventName, detail) {
        var payload = Object.assign({
          quiz_id: "hume_daily_vital_check",
          quiz_version: root.getAttribute("data-quiz-version") || "unknown",
          page_path: window.location.pathname,
          step_id: root.getAttribute("data-step-id") || "age"
        }, detail || {});
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: eventName, hume_daily_vital_check: payload });
        if (typeof window.gtag === "function") {
          window.gtag("event", eventName, payload);
        }
      }

      function resetScores() {
        state.scores = { sleep: 0, stress: 0, recovery: 0, heart: 0, longevity: 0, data: 0, consistency: 0, load: 0, resilience: 0 };
        state.mainConcern = "disconnected signals";
        state.wearable = "unknown";
        state.goal = "daily direction";
        state.event = "the next 30 days";
        steps.forEach(function (step) {
          var saved = state.answers[step.id] || [];
          saved.forEach(function (index) {
            var option = step.options && step.options[index];
            if (!option) return;
            Object.keys(option.score || {}).forEach(function (key) {
              state.scores[key] += option.score[key];
            });
            if (option.concern) state.mainConcern = option.concern;
            if (option.wearable) state.wearable = option.wearable;
            if (option.goal) state.goal = option.goal;
            if (option.event) state.event = option.event;
          });
        });
      }

      function topSignal() {
        var keys = ["sleep", "stress", "recovery", "heart", "longevity", "data", "consistency"];
        var winner = keys[0];
        keys.forEach(function (key) {
          if (state.scores[key] > state.scores[winner]) winner = key;
        });
        if (state.scores.data >= state.scores[winner] - 1 && state.wearable !== "no consistent tracker") {
          winner = "data";
        }
        return winner;
      }

      function level() {
        var net = Math.max(0, state.scores.load - state.scores.resilience);
        if (net <= 1) return { label: "Low", marker: "12%", disconnect: "Low", recovery: "Clearer", direction: "Available", potential: "High" };
        if (net <= 3) return { label: "Moderate", marker: "50%", disconnect: "Moderate", recovery: "Mixed", direction: "Needs focus", potential: "Very high" };
        if (net <= 5) return { label: "High", marker: "73%", disconnect: "High", recovery: "Hard to read", direction: "Low", potential: "High" };
        return { label: "Very high", marker: "91%", disconnect: "Very high", recovery: "Reactive", direction: "Very low", potential: "High" };
      }

      function replaceTokens(text) {
        return String(text || "").replace(/@mainConcern/g, state.mainConcern).replace(/@event/g, state.event).replace(/@goal/g, state.goal);
      }

      function clearSpecialViews() {
        if (emailForm) emailForm.hidden = true;
        infoVisual.hidden = true;
        profile.hidden = true;
        education.hidden = true;
        result.hidden = true;
      }

      function updateProgress() {
        var total = steps.length + (emailEnabled ? 1 : 0);
        var percent = Math.round((state.step / Math.max(1, total)) * 100);
        progressBar.style.width = percent + "%";
        progress.setAttribute("aria-valuenow", String(percent));
        stepLabel.textContent = steps[state.step] ? steps[state.step].label : "Result";
        stepCount.textContent = Math.min(state.step + 1, total) + " of " + total;
        backButton.hidden = state.step === 0;
        actions.classList.toggle("has-back", !backButton.hidden);
      }

      function renderOptions(step) {
        options.innerHTML = "";
        if (!step.options) return;
        var selected = state.answers[step.id] || [];
        step.options.forEach(function (option, index) {
          var button = document.createElement("button");
          button.type = "button";
          button.className = "hdc-option";
          if (selected.indexOf(index) !== -1) button.classList.add("is-selected");
          button.setAttribute("aria-pressed", selected.indexOf(index) !== -1 ? "true" : "false");

          var number = document.createElement("span");
          number.className = "hdc-option-number";
          number.textContent = String(index + 1);
          var text = document.createElement("span");
          text.textContent = option.text;
          button.appendChild(number);
          button.appendChild(text);

          button.addEventListener("click", function () {
            if (state.transitioning) return;
            if (step.type === "multi") {
              var current = state.answers[step.id] || [];
              var pos = current.indexOf(index);
              if (pos === -1) current.push(index);
              else current.splice(pos, 1);
              state.answers[step.id] = current;
              resetScores();
              renderOptions(step);
              continueButton.hidden = false;
              continueButton.disabled = current.length === 0;
              publish("daily_vital_answer_select", { question_id: step.id, answer: option.text, multi_select: true });
            } else {
              state.answers[step.id] = [index];
              resetScores();
              publish("daily_vital_answer_select", { question_id: step.id, answer: option.text, multi_select: false });
              state.transitioning = true;
              window.setTimeout(function () { state.transitioning = false; next(); }, 150);
            }
          });
          options.appendChild(button);
        });
      }

      function renderProfile() {
        var signalLevel = level();
        root.querySelector("[data-hdc-profile-level]").textContent = signalLevel.label;
        root.querySelector("[data-hdc-profile-disconnect]").textContent = signalLevel.disconnect;
        root.querySelector("[data-hdc-profile-recovery]").textContent = signalLevel.recovery;
        root.querySelector("[data-hdc-profile-direction]").textContent = signalLevel.direction;
        root.querySelector("[data-hdc-profile-potential]").textContent = signalLevel.potential;
        root.querySelector("[data-hdc-meter-marker]").style.setProperty("--marker", signalLevel.marker);
        profile.hidden = false;
      }

      function fillList(target, rows) {
        target.innerHTML = "";
        rows.forEach(function (row) {
          var li = document.createElement("li");
          var span = document.createElement("span");
          var strong = document.createElement("strong");
          span.textContent = row[0];
          strong.textContent = row[1];
          li.appendChild(span);
          li.appendChild(strong);
          target.appendChild(li);
        });
      }

      function ctaUrl(profileData) {
        var base = root.getAttribute("data-cta-url") || "https://humehealth.com/pages/hume-bandv2";
        var separator = base.indexOf("?") === -1 ? "?" : "&";
        var params = [
          ["utm_source", "thewearabletech"],
          ["utm_medium", "quiz"],
          ["utm_campaign", "daily_vital_check"],
          ["utm_content", slug(profileData.title)],
          ["utm_term", slug(topSignal())],
          ["quiz_result", slug(profileData.title)],
          ["quiz_signal", slug(topSignal())],
          ["quiz_wearable", slug(state.wearable)],
          ["quiz_goal", slug(state.goal)]
        ];
        return base + separator + params.map(function (pair) {
          return encodeURIComponent(pair[0]) + "=" + encodeURIComponent(pair[1]);
        }).join("&");
      }

      function answerValue(id) {
        var question = steps.find(function (step) { return step.id === id; });
        var values = (state.answers[id] || []).map(function (index) {
          return question && question.options[index] ? question.options[index].text : "";
        }).filter(Boolean);
        return question && question.type === "multi" ? values : (values[0] || "");
      }

      function quizProperties() {
        var properties = {
          dvq_completed: true,
          dvq_id: "daily_vital_quiz_v4",
          dvq_version: "2026-10-06-klaviyo-v1",
          dvq_source: "thewearabletech",
          dvq_page_url: window.location.origin + window.location.pathname,
          dvq_product: "Hume Band 2.0",
          dvq_age_range: answerValue("age"),
          dvq_signals: answerValue("signals"),
          dvq_current_wearable: answerValue("wearable"),
          dvq_pattern_duration: answerValue("duration"),
          dvq_sleep: answerValue("sleep"),
          dvq_wellness_interests: answerValue("conditions"),
          dvq_wearable_frustration: answerValue("noise"),
          dvq_previous_attempts: answerValue("doctor"),
          dvq_daily_time: answerValue("routine"),
          dvq_concern_level: answerValue("worry"),
          dvq_desired_outcome: answerValue("meaning"),
          dvq_timeline: answerValue("event"),
          dvq_result_signal: topSignal(),
          dvq_result_title: replaceTokens((resultProfiles[topSignal()] || resultProfiles.data).title),
          dvq_primary_concern: state.mainConcern,
          dvq_goal: state.goal,
          dvq_completed_at: state.completedAt,
          dvq_completion_seconds: Math.round((Date.parse(state.completedAt) - state.startedAt) / 1000),
          dvq_email_opt_in: true,
          dvq_consent_version: "2026-10-06-v1",
          dvq_consent_at: new Date().toISOString()
        };
        var params = new URLSearchParams(window.location.search);
        ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"].forEach(function (key) {
          var value = params.get(key);
          if (value) properties["dvq_" + key] = value.slice(0, 500);
        });
        return properties;
      }

      function renderEmail() {
        clearSpecialViews();
        root.setAttribute("data-step-type", "email");
        root.setAttribute("data-step-id", "email");
        options.innerHTML = "";
        actions.hidden = false;
        continueButton.hidden = true;
        backButton.disabled = false;
        updateProgress();
        stepLabel.textContent = "Your results";
        kicker.textContent = "Your Daily Vital Check";
        title.textContent = "Your Daily Vital results are ready";
        subtitle.textContent = "Get personalized guidance and Hume Health offers based on your answers.";
        emailForm.hidden = false;
        emailError.hidden = true;
        card.scrollTop = 0;
        state.completedAt = new Date().toISOString();
        publish("daily_vital_email_view", {});
      }

      function showEmailError(message) {
        emailError.textContent = message;
        emailError.hidden = false;
      }

      if (emailEnabled) {
        emailInput.addEventListener("input", function () {
          emailInput.removeAttribute("aria-invalid");
          emailError.hidden = true;
        });
        emailForm.addEventListener("submit", function (event) {
          event.preventDefault();
          if (state.emailPending || state.emailAccepted) return;
          var email = emailInput.value.trim();
          emailInput.value = email;
          if (!emailInput.checkValidity() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            emailInput.setAttribute("aria-invalid", "true");
            showEmailError("Enter a valid email address, or choose Skip for now.");
            emailInput.focus();
            return;
          }
          if (!emailConsent.checked) {
            publish("daily_vital_email_skipped", { reason: "no_consent" });
            showResult();
            return;
          }
          state.emailPending = true;
          emailError.hidden = true;
          emailSubmit.disabled = true;
          emailSkip.disabled = true;
          emailInput.disabled = true;
          emailConsent.disabled = true;
          backButton.disabled = true;
          emailSubmit.textContent = "Saving...";
          emailForm.setAttribute("aria-busy", "true");
          publish("daily_vital_email_submit", { consent: true });
          var controller = new AbortController();
          var timer = window.setTimeout(function () { controller.abort(); }, 12000);
          var payload = {
            data: {
              type: "subscription",
              attributes: {
                custom_source: "TheWearableTech | Daily Vital Quiz V4",
                profile: { data: { type: "profile", attributes: {
                  email: email,
                  properties: quizProperties(),
                  subscriptions: { email: { marketing: { consent: "SUBSCRIBED" } } }
                } } }
              },
              relationships: { list: { data: { type: "list", id: listId } } }
            }
          };
          fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + encodeURIComponent(companyId), {
            method: "POST",
            headers: { "Content-Type": "application/vnd.api+json", "Accept": "application/vnd.api+json", "revision": "2026-07-15" },
            body: JSON.stringify(payload),
            signal: controller.signal
          }).then(function (response) {
            if (!response.ok) throw new Error("Subscription request failed");
            state.emailAccepted = true;
            publish("daily_vital_email_accepted", { consent: true });
            emailStatus.textContent = "Thanks! Check your inbox for a confirmation email if you're not already subscribed. Your results are below.";
            emailStatus.hidden = false;
            showResult();
          }).catch(function () {
            publish("daily_vital_email_error", {});
            showEmailError("We couldn't confirm your signup. Please try again, or choose Skip for now to see your results.");
          }).finally(function () {
            window.clearTimeout(timer);
            state.emailPending = false;
            emailSubmit.disabled = false;
            emailSkip.disabled = false;
            emailInput.disabled = false;
            emailConsent.disabled = false;
            backButton.disabled = false;
            emailSubmit.textContent = "See my results";
            emailForm.removeAttribute("aria-busy");
          });
        });
        emailSkip.addEventListener("click", function () {
          if (state.emailPending) return;
          publish("daily_vital_email_skipped", { reason: "skip" });
          showResult();
        });
      }

      function renderResult() {
        var profileData = resultProfiles[topSignal()] || resultProfiles.data;
        root.querySelector("[data-hdc-result-title]").textContent = replaceTokens(profileData.title);
        root.querySelector("[data-hdc-result-copy]").textContent = replaceTokens(profileData.copy);
        root.querySelector("[data-hdc-timeline-one]").textContent = replaceTokens(profileData.timelineOne);
        root.querySelector("[data-hdc-timeline-two]").textContent = replaceTokens(profileData.timelineTwo);
        fillList(root.querySelector("[data-hdc-now-list]"), profileData.now);
        fillList(root.querySelector("[data-hdc-goal-list]"), profileData.goal);
        root.querySelector("[data-hdc-cta]").setAttribute("href", ctaUrl(profileData));
        result.hidden = false;
        publish("daily_vital_result_view", {
          result_type: topSignal(),
          cta_url: ctaUrl(profileData),
          completion_seconds: Math.round((Date.now() - state.startedAt) / 1000)
        });
      }

      function render() {
        if (emailEnabled && state.step === steps.length) { renderEmail(); return; }
        var step = steps[state.step];
        root.setAttribute("data-step-type", step.type || "single");
        root.setAttribute("data-step-id", step.id || "");
        clearSpecialViews();
        options.innerHTML = "";
        continueButton.hidden = step.type === "single";
        continueButton.disabled = false;
        actions.hidden = false;
        kicker.textContent = step.kicker || "";
        title.textContent = replaceTokens(step.title);
        subtitle.textContent = replaceTokens(step.subtitle);
        card.scrollTop = 0;

        if (step.type === "single" || step.type === "multi") {
          renderOptions(step);
          if (step.type === "multi") {
            continueButton.hidden = false;
            continueButton.disabled = !(state.answers[step.id] || []).length;
          }
        }

        if (step.type === "info") {
          infoVisual.hidden = false;
          continueButton.hidden = false;
        }

        if (step.type === "profile") {
          renderProfile();
          continueButton.hidden = false;
        }

        if (step.type === "education") {
          education.hidden = false;
          continueButton.hidden = false;
        }

        updateProgress();
        publish("daily_vital_step_view", { step_id: step.id, step_type: step.type, step_number: state.step + 1 });
      }

      function showResult() {
        root.setAttribute("data-step-type", "result");
        root.setAttribute("data-step-id", "result");
        clearSpecialViews();
        options.innerHTML = "";
        actions.hidden = true;
        actions.classList.remove("has-back");
        title.textContent = "";
        subtitle.textContent = "";
        kicker.textContent = "";
        progressBar.style.width = "100%";
        progress.setAttribute("aria-valuenow", "100");
        stepLabel.textContent = "Result";
        stepCount.textContent = "Complete";
        renderResult();
      }

      function next() {
        if (state.step + 1 >= steps.length) {
          if (emailEnabled) { state.step = steps.length; renderEmail(); } else { showResult(); }
          return;
        }
        state.step += 1;
        render();
      }

      function back() {
        if (state.step <= 0 || state.emailPending || state.transitioning) return;
        state.step -= 1;
        render();
      }

      continueButton.addEventListener("click", function () {
        if (continueButton.disabled || state.transitioning) return;
        publish("daily_vital_continue_click", { step_id: steps[state.step].id });
        next();
      });

      backButton.addEventListener("click", function () {
        publish("daily_vital_back_click", { from_step: root.getAttribute("data-step-id") });
        back();
      });

      root.querySelector("[data-hdc-cta]").addEventListener("click", function () {
        publish("daily_vital_offer_click", { result_type: topSignal(), funnel_step: "pdp_handoff" });
      });

      render();
    }

    roots.forEach(setup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hume-band-daily-vital-check-rovina-v5"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll("[data-hume-daily-check]");
    if (!roots.length) return;

    var steps = [
      {
        id: "age",
        label: "Question 1",
        type: "single",
        kicker: "Daily Vital Check",
        title: "Find which daily health signal may be making your data harder to act on.",
        subtitle: "Start with your age so we can calibrate your daily signal pattern. Takes about 2 minutes. No email required.",
        options: [
          { text: "Under 35", score: { resilience: 1 } },
          { text: "35-44", score: { resilience: 1, load: 1 } },
          { text: "45-54", score: { load: 2 } },
          { text: "55-64", score: { load: 3 } },
          { text: "65 or older", score: { load: 4 } }
        ]
      },
      {
        id: "signals",
        label: "Question 2",
        type: "multi",
        kicker: "Choose all that apply",
        title: "Which hidden body signals have you noticed lately?",
        subtitle: "Choose all that apply.",
        options: [
          { text: "Waking up tired even after enough sleep", score: { sleep: 3, load: 1 }, concern: "unrefreshing sleep" },
          { text: "Afternoon energy crash or brain fog", score: { recovery: 2, load: 1 }, concern: "energy dips" },
          { text: "Stress feels like it stays in my body", score: { stress: 3, load: 1 }, concern: "stress load" },
          { text: "I do not know when to push or rest", score: { recovery: 3 }, concern: "recovery confusion" },
          { text: "Heart, HRV, or BP trends feel hard to read", score: { heart: 3 }, concern: "heart trend clarity" },
          { text: "My wearable gives numbers, not next steps", score: { data: 3 }, concern: "data without direction" }
        ]
      },
      {
        id: "wearable",
        label: "Question 3",
        type: "single",
        kicker: "Current tracking",
        title: "What are you using to track your health right now?",
        subtitle: "This helps us understand whether your gap is measurement, interpretation, or consistency.",
        options: [
          { text: "Apple Watch", score: { data: 3 }, wearable: "Apple Watch" },
          { text: "Oura Ring", score: { data: 3 }, wearable: "Oura Ring" },
          { text: "WHOOP", score: { data: 3 }, wearable: "WHOOP" },
          { text: "Garmin or Fitbit", score: { data: 2, consistency: 1 }, wearable: "Garmin or Fitbit" },
          { text: "Another wearable", score: { data: 2 }, wearable: "another wearable" },
          { text: "Nothing consistently", score: { consistency: 3 }, wearable: "no consistent tracker" }
        ]
      },
      {
        id: "duration",
        label: "Question 4",
        type: "single",
        kicker: "Pattern length",
        title: "How long have these signals felt unclear?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "Just started recently", score: { resilience: 1 } },
          { text: "A few months", score: { load: 1 } },
          { text: "Around a year", score: { load: 2 } },
          { text: "Several years", score: { load: 3 } },
          { text: "I cannot remember when it started", score: { load: 4 } }
        ]
      },
      {
        id: "reassurance",
        label: "Checkpoint",
        type: "info",
        kicker: "You are in the right place",
        title: "Thousands of people are tracking health data but still missing the pattern.",
        subtitle: "If your biggest issue is @mainConcern, the next step is not more random numbers. It is seeing how sleep, stress, heart trends, recovery, and habits connect."
      },
      {
        id: "sleep",
        label: "Question 5",
        type: "single",
        kicker: "Sleep signal",
        title: "What best describes your sleep lately?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "I sleep enough but still wake up tired", score: { sleep: 3, load: 1 } },
          { text: "My sleep varies a lot night to night", score: { sleep: 2, consistency: 1 } },
          { text: "Stress clearly affects my sleep", score: { stress: 2, sleep: 1 } },
          { text: "I mostly sleep fine", score: { resilience: 1 } },
          { text: "I do not know what my sleep data means", score: { data: 3 } }
        ]
      },
      {
        id: "conditions",
        label: "Question 6",
        type: "multi",
        kicker: "Choose all that apply",
        title: "Which wellness areas do you want more context around?",
        subtitle: "Choose all that apply.",
        options: [
          { text: "Blood pressure wellness trends", score: { heart: 3 } },
          { text: "HRV and resting heart rate", score: { heart: 2, recovery: 1 } },
          { text: "Stress and nervous system load", score: { stress: 3 } },
          { text: "Sleep quality and sleep stages", score: { sleep: 3 } },
          { text: "Recovery after workouts or long days", score: { recovery: 3 } },
          { text: "Long-term health direction", score: { longevity: 3 } }
        ]
      },
      {
        id: "noise",
        label: "Question 7",
        type: "single",
        kicker: "Data overload",
        title: "How does your current wearable usually leave you feeling?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "I see scores but do not know what to do", score: { data: 4 } },
          { text: "I only check it when something feels off", score: { consistency: 2, data: 1 } },
          { text: "I like the data, but it feels disconnected", score: { data: 3 } },
          { text: "It helps, but I want a clearer daily focus", score: { recovery: 1, data: 2 } },
          { text: "I mostly ignore the app", score: { consistency: 3 } }
        ]
      },
      {
        id: "profile",
        label: "Profile",
        type: "profile",
        kicker: "Your Daily Vital Profile",
        title: "Your disconnected signal assessment",
        subtitle: "Based on your answers, your body signals may be creating more noise than direction."
      },
      {
        id: "doctor",
        label: "Question 8",
        type: "multi",
        kicker: "Choose all that apply",
        title: "What have you already tried to make sense of your health data?",
        subtitle: "Choose all that apply.",
        options: [
          { text: "Checking wearable scores every morning", score: { data: 2 } },
          { text: "Changing sleep or bedtime habits", score: { sleep: 1, consistency: 1 } },
          { text: "Adjusting workouts based on recovery", score: { recovery: 2 } },
          { text: "Meditation, breathwork, or stress tools", score: { stress: 2 } },
          { text: "Reading articles or watching health content", score: { data: 1 } },
          { text: "Nothing consistently yet", score: { consistency: 3 } }
        ]
      },
      {
        id: "education",
        label: "Why it happens",
        type: "education",
        kicker: "",
        title: "Here's Why Your Wearable Numbers Still Feel Confusing...",
        subtitle: ""
      },
      {
        id: "routine",
        label: "Question 9",
        type: "single",
        kicker: "Daily routine",
        title: "How much time can you spare for a health check each day?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "Under 30 seconds", score: { consistency: 3 } },
          { text: "About 1 minute", score: { consistency: 2 } },
          { text: "2-5 minutes", score: { resilience: 1 } },
          { text: "10+ minutes", score: { resilience: 1 } },
          { text: "I do not have a routine", score: { consistency: 3, load: 1 } }
        ]
      },
      {
        id: "worry",
        label: "Question 10",
        type: "single",
        kicker: "Motivation",
        title: "How concerned are you about missing important health signals?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "Very concerned - I think about it often", score: { load: 3 } },
          { text: "Concerned when my numbers look off", score: { load: 2, data: 1 } },
          { text: "Somewhat concerned", score: { load: 1 } },
          { text: "Not worried yet, but I want better direction", score: { longevity: 2 } }
        ]
      },
      {
        id: "meaning",
        label: "Question 11",
        type: "single",
        kicker: "Goal",
        title: "If your daily signals finally made sense, what would it mean to you?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "Wake up knowing what my body needs today", score: { sleep: 1, recovery: 2 }, goal: "daily direction" },
          { text: "Stop guessing when to push or recover", score: { recovery: 3 }, goal: "recovery clarity" },
          { text: "Understand stress before it runs me down", score: { stress: 3 }, goal: "stress clarity" },
          { text: "Feel confident my long-term habits are working", score: { longevity: 3 }, goal: "long-term direction" },
          { text: "Spend less time decoding my app", score: { data: 3 }, goal: "less data overload" }
        ]
      },
      {
        id: "event",
        label: "Question 12",
        type: "single",
        kicker: "Timeline",
        title: "When would you most want clearer health direction?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "This week", score: { consistency: 2 }, event: "this week" },
          { text: "Before my next busy work stretch", score: { stress: 2 }, event: "your next high-stress week" },
          { text: "Before my next training block", score: { recovery: 2 }, event: "your next training block" },
          { text: "Over the next 30 days", score: { longevity: 1 }, event: "the next 30 days" },
          { text: "I just want to start now", score: { data: 1 }, event: "today" }
        ]
      }
    ];

    var resultProfiles = {
      sleep: {
        title: "Your daily signal pattern: sleep-recovery clarity gap.",
        copy: "Your answers point to sleep quality and next-day recovery as the signal that deserves attention first.",
        recommendation: "Hume Band 2.0 is built to connect sleep, HRV, recovery, stress, and daily habits into a clearer morning read, so you can see what your body may be asking for next.",
        because: ["Sleep and recovery showed up as your strongest pattern.", "You want less guessing when your morning energy feels off.", "Your result is about connecting signals, not adding another isolated score."],
        now: [["Sleep signal", "Unclear"], ["Recovery", "Hard to predict"], ["Morning direction", "Low"], ["Pattern confidence", "Spotty"]],
        goal: [["Sleep signal", "Connected"], ["Recovery", "Easier to read"], ["Morning direction", "Clearer"], ["Pattern confidence", "Building"]],
        timelineOne: "First 7 days: start seeing how sleep, HRV, and recovery move together.",
        timelineTwo: "By @event: use your daily read to know whether to push, rest, or adjust."
      },
      stress: {
        title: "Your daily signal pattern: stress-load visibility gap.",
        copy: "Your answers suggest stress may be showing up in sleep, HRV, recovery, and energy before it feels obvious.",
        recommendation: "Hume Band 2.0 helps surface how stress, recovery, sleep, and heart trends move together, giving you a clearer daily read instead of scattered alerts.",
        because: ["Stress context was one of your strongest answer patterns.", "You want to notice the body-data pattern before the day feels derailed.", "The next step is a connected read across signals, not more one-off numbers."],
        now: [["Stress load", "Hard to see"], ["HRV context", "Disconnected"], ["Recovery", "Reactive"], ["Daily focus", "Unclear"]],
        goal: [["Stress load", "Visible"], ["HRV context", "Connected"], ["Recovery", "More proactive"], ["Daily focus", "Clearer"]],
        timelineOne: "First 7 days: watch how stressful days change sleep and recovery signals.",
        timelineTwo: "By @event: spot the days where your body may need a lighter plan."
      },
      recovery: {
        title: "Your daily signal pattern: push-or-rest uncertainty.",
        copy: "Your answers point to recovery direction as the main gap. The problem is not effort. It is knowing when effort is helping.",
        recommendation: "Hume Band 2.0 helps connect activity, sleep, HRV, stress, and recovery signals into a daily read you can use when deciding whether to push, rest, or adjust.",
        because: ["Recovery direction was your clearest signal gap.", "You want your effort matched to what your body data is showing.", "The useful output is daily context, not a pile of disconnected metrics."],
        now: [["Readiness", "Guesswork"], ["Activity", "Separate"], ["Sleep debt", "Easy to miss"], ["Training choices", "Reactive"]],
        goal: [["Readiness", "Contextual"], ["Activity", "Connected"], ["Sleep debt", "Visible"], ["Training choices", "More intentional"]],
        timelineOne: "First 7 days: connect activity, sleep, and HRV into a clearer recovery read.",
        timelineTwo: "By @event: make push-or-rest decisions with less second-guessing."
      },
      heart: {
        title: "Your daily signal pattern: heart-trend context gap.",
        copy: "Your answers suggest you want more than one-off numbers. You want to understand how heart-related wellness trends fit the bigger pattern.",
        recommendation: "Hume Band 2.0 helps track heart-related wellness trends in context with sleep, recovery, stress, and activity, so changes are easier to follow over time.",
        because: ["Heart-trend context showed up strongly in your answers.", "You want patterns you can follow, not isolated readings.", "A connected daily read gives your wearable data more practical context."],
        now: [["Heart trends", "One-off"], ["BP wellness", "Hard to contextualize"], ["HRV", "Isolated"], ["Confidence", "Low"]],
        goal: [["Heart trends", "Tracked over time"], ["BP wellness", "In context"], ["HRV", "Connected"], ["Confidence", "Improving"]],
        timelineOne: "First 7 days: start connecting heart, HRV, sleep, and recovery trends.",
        timelineTwo: "By @event: have a clearer wellness trend picture to follow or discuss."
      },
      longevity: {
        title: "Your daily signal pattern: long-term direction gap.",
        copy: "Your answers suggest daily scores are not enough. You want to know whether your routine is moving your bigger health direction.",
        recommendation: "Hume Band 2.0 helps turn recurring sleep, recovery, heart, stress, activity, and habit signals into trends you can actually follow over time.",
        because: ["Your answers point to long-term health direction, not just today's score.", "You want feedback that makes habits easier to judge.", "The recommendation is a signal system you can keep using daily."],
        now: [["Daily scores", "Short-term"], ["Health direction", "Fuzzy"], ["Habit feedback", "Delayed"], ["Momentum", "Unknown"]],
        goal: [["Daily scores", "Part of a trend"], ["Health direction", "Clearer"], ["Habit feedback", "Faster"], ["Momentum", "Visible"]],
        timelineOne: "First 7 days: create a baseline across sleep, recovery, activity, and heart trends.",
        timelineTwo: "By @event: start seeing whether your routine is moving in the right direction."
      },
      data: {
        title: "Your daily signal pattern: data overload.",
        copy: "Your answers suggest your biggest gap is interpretation. You may already have data, but not the daily direction it should create.",
        recommendation: "Hume Band 2.0 is built to connect the signals many wearables leave scattered, helping your body data become a clearer daily read instead of another dashboard to decode.",
        because: ["You already have or want data, but need it translated into direction.", "Your result points to interpretation as the bottleneck.", "The next step is a wearable that connects the pattern across signals."],
        now: [["Health data", "Scattered"], ["Next step", "Unclear"], ["App fatigue", "High"], ["Confidence", "Low"]],
        goal: [["Health data", "Connected"], ["Next step", "Clearer"], ["App fatigue", "Lower"], ["Confidence", "Building"]],
        timelineOne: "First 7 days: see which signal deserves attention first instead of chasing every metric.",
        timelineTwo: "By @event: use a simpler daily read instead of decoding another dashboard."
      },
      consistency: {
        title: "Your daily signal pattern: consistency gap.",
        copy: "Your answers suggest the issue may be missing data gaps, charging friction, or not having a simple reason to check in daily.",
        recommendation: "Hume Band 2.0 is designed for a simpler daily wearable routine, helping you build a steadier signal baseline across sleep, recovery, activity, and heart trends.",
        because: ["Your answers suggest consistency is blocking better signal quality.", "You need a routine that is easy to repeat, not another app you ignore.", "Better daily context starts with a cleaner wearable baseline."],
        now: [["Wear time", "Inconsistent"], ["Night data", "Easy to miss"], ["Daily habit", "Loose"], ["Signal quality", "Patchy"]],
        goal: [["Wear time", "More consistent"], ["Night data", "Captured"], ["Daily habit", "Simple"], ["Signal quality", "Cleaner"]],
        timelineOne: "First 7 days: build a steadier baseline with a wearable designed for longer, simpler use.",
        timelineTwo: "By @event: make daily tracking feel easier to maintain."
      }
    };

    function setup(root) {
      var state = {
        step: 0,
        scores: { sleep: 0, stress: 0, recovery: 0, heart: 0, longevity: 0, data: 0, consistency: 0, load: 0, resilience: 0 },
        answers: {},
        selected: [],
        mainConcern: "disconnected signals",
        wearable: "unknown",
        goal: "daily direction",
        event: "the next 30 days",
        startedAt: Date.now(),
        hasStarted: false,
        hasCompleted: false
      };

      var card = root.querySelector("[data-hdc-card]");
      var kicker = root.querySelector("[data-hdc-kicker]");
      var title = root.querySelector("[data-hdc-title]");
      var subtitle = root.querySelector("[data-hdc-subtitle]");
      var options = root.querySelector("[data-hdc-options]");
      var continueButton = root.querySelector("[data-hdc-continue]");
      var backButton = root.querySelector("[data-hdc-back]");
      var progress = root.querySelector("[data-hdc-progress]");
      var progressBar = root.querySelector("[data-hdc-progress-bar]");
      var stepLabel = root.querySelector("[data-hdc-step-label]");
      var stepCount = root.querySelector("[data-hdc-step-count]");
      var profile = root.querySelector("[data-hdc-profile]");
      var education = root.querySelector("[data-hdc-education]");
      var result = root.querySelector("[data-hdc-result]");
      var actions = root.querySelector("[data-hdc-actions]");
      var infoVisual = root.querySelector("[data-hdc-info-visual]");

      function slug(value) {
        return String(value || "unknown").toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
      }

      function publish(eventName, detail) {
        var payload = Object.assign({
          quiz_id: "hume_daily_vital_check",
          quiz_version: root.getAttribute("data-quiz-version") || "unknown",
          page_path: window.location.pathname,
          step_id: steps[state.step] ? steps[state.step].id : "result"
        }, detail || {});
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: eventName, hume_daily_vital_check: payload });
        document.dispatchEvent(new CustomEvent(eventName, { detail: payload }));
        if (typeof window.gtag === "function") {
          window.gtag("event", eventName, payload);
        }
      }

      function resetScores() {
        state.scores = { sleep: 0, stress: 0, recovery: 0, heart: 0, longevity: 0, data: 0, consistency: 0, load: 0, resilience: 0 };
        state.mainConcern = "disconnected signals";
        state.wearable = "unknown";
        state.goal = "daily direction";
        state.event = "the next 30 days";
        steps.forEach(function (step) {
          var saved = state.answers[step.id] || [];
          saved.forEach(function (index) {
            var option = step.options && step.options[index];
            if (!option) return;
            Object.keys(option.score || {}).forEach(function (key) {
              state.scores[key] += option.score[key];
            });
            if (option.concern) state.mainConcern = option.concern;
            if (option.wearable) state.wearable = option.wearable;
            if (option.goal) state.goal = option.goal;
            if (option.event) state.event = option.event;
          });
        });
      }

      function topSignal() {
        var keys = ["sleep", "stress", "recovery", "heart", "longevity", "data", "consistency"];
        var winner = keys[0];
        keys.forEach(function (key) {
          if (state.scores[key] > state.scores[winner]) winner = key;
        });
        if (state.scores.data >= state.scores[winner] - 1 && state.wearable !== "no consistent tracker") {
          winner = "data";
        }
        return winner;
      }

      function level() {
        var net = Math.max(0, state.scores.load - state.scores.resilience);
        if (net <= 1) return { label: "Low", marker: "12%", disconnect: "Low", recovery: "Clearer", direction: "Available", potential: "High" };
        if (net <= 3) return { label: "Moderate", marker: "50%", disconnect: "Moderate", recovery: "Mixed", direction: "Needs focus", potential: "Very high" };
        if (net <= 5) return { label: "High", marker: "73%", disconnect: "High", recovery: "Hard to read", direction: "Low", potential: "High" };
        return { label: "Very high", marker: "91%", disconnect: "Very high", recovery: "Reactive", direction: "Very low", potential: "High" };
      }

      function replaceTokens(text) {
        return String(text || "").replace(/@mainConcern/g, state.mainConcern).replace(/@event/g, state.event).replace(/@goal/g, state.goal);
      }

      function clearSpecialViews() {
        infoVisual.hidden = true;
        profile.hidden = true;
        education.hidden = true;
        result.hidden = true;
      }

      function updateProgress() {
        var percent = Math.round((state.step / Math.max(1, steps.length)) * 100);
        var questionTotal = steps.filter(function (item) {
          return item.type === "single" || item.type === "multi";
        }).length;
        var questionNumber = 0;
        steps.slice(0, state.step + 1).forEach(function (item) {
          if (item.type === "single" || item.type === "multi") questionNumber += 1;
        });
        progressBar.style.width = percent + "%";
        progress.setAttribute("aria-valuenow", String(percent));
        stepLabel.textContent = steps[state.step] ? steps[state.step].label : "Result";
        stepCount.textContent = questionNumber ? "Question " + questionNumber + " of " + questionTotal : "Step " + (state.step + 1) + " of " + steps.length;
        backButton.hidden = state.step === 0;
        actions.classList.toggle("has-back", !backButton.hidden);
      }

      function renderOptions(step) {
        options.innerHTML = "";
        if (!step.options) return;
        var selected = state.answers[step.id] || [];
        step.options.forEach(function (option, index) {
          var button = document.createElement("button");
          button.type = "button";
          button.className = "hdc-option";
          if (selected.indexOf(index) !== -1) button.classList.add("is-selected");
          button.setAttribute("aria-pressed", selected.indexOf(index) !== -1 ? "true" : "false");

          var number = document.createElement("span");
          number.className = "hdc-option-number";
          number.textContent = String(index + 1);
          var text = document.createElement("span");
          text.textContent = option.text;
          button.appendChild(number);
          button.appendChild(text);

          button.addEventListener("click", function () {
            if (step.type === "multi") {
              var current = state.answers[step.id] || [];
              var pos = current.indexOf(index);
              if (pos === -1) current.push(index);
              else current.splice(pos, 1);
              state.answers[step.id] = current;
              resetScores();
              renderOptions(step);
              continueButton.hidden = false;
              continueButton.disabled = current.length === 0;
              publish("question_answered", { question_id: step.id, answer: option.text, multi_select: true, step_number: state.step + 1 });
            } else {
              state.answers[step.id] = [index];
              resetScores();
              publish("question_answered", { question_id: step.id, answer: option.text, multi_select: false, step_number: state.step + 1 });
              window.setTimeout(next, 150);
            }
          });
          options.appendChild(button);
        });
      }

      function renderProfile() {
        var signalLevel = level();
        root.querySelector("[data-hdc-profile-level]").textContent = signalLevel.label;
        root.querySelector("[data-hdc-profile-disconnect]").textContent = signalLevel.disconnect;
        root.querySelector("[data-hdc-profile-recovery]").textContent = signalLevel.recovery;
        root.querySelector("[data-hdc-profile-direction]").textContent = signalLevel.direction;
        root.querySelector("[data-hdc-profile-potential]").textContent = signalLevel.potential;
        root.querySelector("[data-hdc-meter-marker]").style.setProperty("--marker", signalLevel.marker);
        profile.hidden = false;
      }

      function fillList(target, rows) {
        target.innerHTML = "";
        rows.forEach(function (row) {
          var li = document.createElement("li");
          var span = document.createElement("span");
          var strong = document.createElement("strong");
          span.textContent = row[0];
          strong.textContent = row[1];
          li.appendChild(span);
          li.appendChild(strong);
          target.appendChild(li);
        });
      }

      function fillBecause(profileData) {
        var list = root.querySelector("[data-hdc-because-list]");
        list.innerHTML = "";
        (profileData.because || []).forEach(function (item) {
          var li = document.createElement("li");
          li.textContent = replaceTokens(item);
          list.appendChild(li);
        });
      }

      function ctaUrl(profileData) {
        var base = root.getAttribute("data-cta-url") || "https://humehealth.com/pages/hume-bandv2";
        var separator = base.indexOf("?") === -1 ? "?" : "&";
        var params = [
          ["utm_source", "thewearabletech"],
          ["utm_medium", "quiz"],
          ["utm_campaign", "daily_vital_check"],
          ["utm_content", slug(profileData.title)],
          ["utm_term", slug(topSignal())],
          ["quiz_result", slug(profileData.title)],
          ["quiz_signal", slug(topSignal())],
          ["quiz_wearable", slug(state.wearable)],
          ["quiz_goal", slug(state.goal)]
        ];
        return base + separator + params.map(function (pair) {
          return encodeURIComponent(pair[0]) + "=" + encodeURIComponent(pair[1]);
        }).join("&");
      }

      function renderResult() {
        var profileData = resultProfiles[topSignal()] || resultProfiles.data;
        root.querySelector("[data-hdc-result-title]").textContent = replaceTokens(profileData.title);
        root.querySelector("[data-hdc-result-copy]").textContent = replaceTokens(profileData.copy);
        root.querySelector("[data-hdc-result-recommendation]").textContent = replaceTokens(profileData.recommendation);
        root.querySelector("[data-hdc-timeline-one]").textContent = replaceTokens(profileData.timelineOne);
        root.querySelector("[data-hdc-timeline-two]").textContent = replaceTokens(profileData.timelineTwo);
        fillBecause(profileData);
        fillList(root.querySelector("[data-hdc-now-list]"), profileData.now);
        fillList(root.querySelector("[data-hdc-goal-list]"), profileData.goal);
        root.querySelector("[data-hdc-cta]").setAttribute("href", ctaUrl(profileData));
        result.hidden = false;
        if (!state.hasCompleted) {
          state.hasCompleted = true;
          publish("quiz_completed", {
            result_type: topSignal(),
            completion_seconds: Math.round((Date.now() - state.startedAt) / 1000)
          });
        }
        publish("result_viewed", {
          result_type: topSignal(),
          cta_url: ctaUrl(profileData),
          completion_seconds: Math.round((Date.now() - state.startedAt) / 1000)
        });
      }

      function render() {
        var step = steps[state.step];
        root.setAttribute("data-step-type", step.type || "single");
        root.setAttribute("data-step-id", step.id || "");
        clearSpecialViews();
        options.innerHTML = "";
        continueButton.hidden = step.type === "single";
        continueButton.disabled = false;
        continueButton.textContent = step.cta || "Continue";
        actions.hidden = false;
        kicker.textContent = step.kicker || "";
        title.textContent = replaceTokens(step.title);
        subtitle.textContent = replaceTokens(step.subtitle);
        card.scrollTop = 0;

        if (step.type === "intro") {
          continueButton.hidden = false;
        }

        if (step.type === "single" || step.type === "multi") {
          renderOptions(step);
          if (step.type === "multi") {
            continueButton.hidden = false;
            continueButton.disabled = !(state.answers[step.id] || []).length;
          }
        }

        if (step.type === "info") {
          infoVisual.hidden = false;
          continueButton.hidden = false;
        }

        if (step.type === "profile") {
          renderProfile();
          continueButton.hidden = false;
        }

        if (step.type === "education") {
          education.hidden = false;
          continueButton.hidden = false;
        }

        updateProgress();
        if (!state.hasStarted) {
          state.hasStarted = true;
          publish("quiz_started", { step_id: step.id, step_type: step.type, step_number: state.step + 1 });
        }
        publish("question_viewed", { step_id: step.id, step_type: step.type, step_number: state.step + 1 });
      }

      function showResult() {
        root.setAttribute("data-step-type", "result");
        root.setAttribute("data-step-id", "result");
        clearSpecialViews();
        options.innerHTML = "";
        actions.hidden = true;
        actions.classList.remove("has-back");
        title.textContent = "";
        subtitle.textContent = "";
        kicker.textContent = "";
        progressBar.style.width = "100%";
        progress.setAttribute("aria-valuenow", "100");
        stepLabel.textContent = "Result";
        stepCount.textContent = "Complete";
        renderResult();
      }

      function next() {
        if (state.step + 1 >= steps.length) {
          showResult();
          return;
        }
        state.step += 1;
        render();
      }

      function back() {
        if (state.step <= 0) return;
        state.step -= 1;
        render();
      }

      continueButton.addEventListener("click", function () {
        if (continueButton.disabled) return;
        publish("quiz_continue_clicked", { step_id: steps[state.step].id, step_number: state.step + 1 });
        next();
      });

      backButton.addEventListener("click", function () {
        publish("quiz_back_clicked", { from_step: steps[state.step].id, step_number: state.step + 1 });
        back();
      });

      root.querySelector("[data-hdc-cta]").addEventListener("click", function () {
        publish("quiz_cta_clicked", { result_type: topSignal(), funnel_step: "pdp_handoff" });
      });

      render();
    }

    roots.forEach(setup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hume-band-daily-vital-check-rovina-v5b"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll("[data-hume-daily-check]");
    if (!roots.length) return;

    var steps = [
      {
        id: "age",
        label: "Question 1",
        type: "single",
        kicker: "Daily Vital Check",
        title: "Find which daily health signal may be making your data harder to act on.",
        subtitle: "Start with your age so we can calibrate your daily signal pattern. Takes about 2 minutes. No email required.",
        options: [
          { text: "Under 35", score: { resilience: 1 } },
          { text: "35-44", score: { resilience: 1, load: 1 } },
          { text: "45-54", score: { load: 2 } },
          { text: "55-64", score: { load: 3 } },
          { text: "65 or older", score: { load: 4 } }
        ]
      },
      {
        id: "signals",
        label: "Question 2",
        type: "multi",
        kicker: "Choose all that apply",
        title: "Which hidden body signals have you noticed lately?",
        subtitle: "Choose all that apply.",
        options: [
          { text: "Waking up tired even after enough sleep", score: { sleep: 3, load: 1 }, concern: "unrefreshing sleep" },
          { text: "Afternoon energy crash or brain fog", score: { recovery: 2, load: 1 }, concern: "energy dips" },
          { text: "Stress feels like it stays in my body", score: { stress: 3, load: 1 }, concern: "stress load" },
          { text: "I do not know when to push or rest", score: { recovery: 3 }, concern: "recovery confusion" },
          { text: "Heart, HRV, or BP trends feel hard to read", score: { heart: 3 }, concern: "heart trend clarity" },
          { text: "My wearable gives numbers, not next steps", score: { data: 3 }, concern: "data without direction" }
        ]
      },
      {
        id: "wearable",
        label: "Question 3",
        type: "single",
        kicker: "Current tracking",
        title: "What are you using to track your health right now?",
        subtitle: "This helps us understand whether your gap is measurement, interpretation, or consistency.",
        options: [
          { text: "Apple Watch", score: { data: 3 }, wearable: "Apple Watch" },
          { text: "Oura Ring", score: { data: 3 }, wearable: "Oura Ring" },
          { text: "WHOOP", score: { data: 3 }, wearable: "WHOOP" },
          { text: "Garmin or Fitbit", score: { data: 2, consistency: 1 }, wearable: "Garmin or Fitbit" },
          { text: "Another wearable", score: { data: 2 }, wearable: "another wearable" },
          { text: "Nothing consistently", score: { consistency: 3 }, wearable: "no consistent tracker" }
        ]
      },
      {
        id: "duration",
        label: "Question 4",
        type: "single",
        kicker: "Pattern length",
        title: "How long have these signals felt unclear?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "Just started recently", score: { resilience: 1 } },
          { text: "A few months", score: { load: 1 } },
          { text: "Around a year", score: { load: 2 } },
          { text: "Several years", score: { load: 3 } },
          { text: "I cannot remember when it started", score: { load: 4 } }
        ]
      },
      {
        id: "reassurance",
        label: "Checkpoint",
        type: "info",
        kicker: "You are in the right place",
        title: "Thousands of people are tracking health data but still missing the pattern.",
        subtitle: "If your biggest issue is @mainConcern, the next step is not more random numbers. It is seeing how sleep, stress, heart trends, recovery, and habits connect."
      },
      {
        id: "sleep",
        label: "Question 5",
        type: "single",
        kicker: "Sleep signal",
        title: "What best describes your sleep lately?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "I sleep enough but still wake up tired", score: { sleep: 3, load: 1 } },
          { text: "My sleep varies a lot night to night", score: { sleep: 2, consistency: 1 } },
          { text: "Stress clearly affects my sleep", score: { stress: 2, sleep: 1 } },
          { text: "I mostly sleep fine", score: { resilience: 1 } },
          { text: "I do not know what my sleep data means", score: { data: 3 } }
        ]
      },
      {
        id: "conditions",
        label: "Question 6",
        type: "multi",
        kicker: "Choose all that apply",
        title: "Which wellness areas do you want more context around?",
        subtitle: "Choose all that apply.",
        options: [
          { text: "Blood pressure wellness trends", score: { heart: 3 } },
          { text: "HRV and resting heart rate", score: { heart: 2, recovery: 1 } },
          { text: "Stress and nervous system load", score: { stress: 3 } },
          { text: "Sleep quality and sleep stages", score: { sleep: 3 } },
          { text: "Recovery after workouts or long days", score: { recovery: 3 } },
          { text: "Long-term health direction", score: { longevity: 3 } }
        ]
      },
      {
        id: "noise",
        label: "Question 7",
        type: "single",
        kicker: "Data overload",
        title: "How does your current wearable usually leave you feeling?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "I see scores but do not know what to do", score: { data: 4 } },
          { text: "I only check it when something feels off", score: { consistency: 2, data: 1 } },
          { text: "I like the data, but it feels disconnected", score: { data: 3 } },
          { text: "It helps, but I want a clearer daily focus", score: { recovery: 1, data: 2 } },
          { text: "I mostly ignore the app", score: { consistency: 3 } }
        ]
      },
      {
        id: "profile",
        label: "Profile",
        type: "profile",
        kicker: "Your Daily Vital Profile",
        title: "Your disconnected signal assessment",
        subtitle: "Based on your answers, your body signals may be creating more noise than direction."
      },
      {
        id: "doctor",
        label: "Question 8",
        type: "multi",
        kicker: "Choose all that apply",
        title: "What have you already tried to make sense of your health data?",
        subtitle: "Choose all that apply.",
        options: [
          { text: "Checking wearable scores every morning", score: { data: 2 } },
          { text: "Changing sleep or bedtime habits", score: { sleep: 1, consistency: 1 } },
          { text: "Adjusting workouts based on recovery", score: { recovery: 2 } },
          { text: "Meditation, breathwork, or stress tools", score: { stress: 2 } },
          { text: "Reading articles or watching health content", score: { data: 1 } },
          { text: "Nothing consistently yet", score: { consistency: 3 } }
        ]
      },
      {
        id: "education",
        label: "Why it happens",
        type: "education",
        kicker: "",
        title: "Here's Why Your Wearable Numbers Still Feel Confusing...",
        subtitle: ""
      },
      {
        id: "routine",
        label: "Question 9",
        type: "single",
        kicker: "Daily routine",
        title: "How much time can you spare for a health check each day?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "Under 30 seconds", score: { consistency: 3 } },
          { text: "About 1 minute", score: { consistency: 2 } },
          { text: "2-5 minutes", score: { resilience: 1 } },
          { text: "10+ minutes", score: { resilience: 1 } },
          { text: "I do not have a routine", score: { consistency: 3, load: 1 } }
        ]
      },
      {
        id: "worry",
        label: "Question 10",
        type: "single",
        kicker: "Motivation",
        title: "How concerned are you about missing important health signals?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "Very concerned - I think about it often", score: { load: 3 } },
          { text: "Concerned when my numbers look off", score: { load: 2, data: 1 } },
          { text: "Somewhat concerned", score: { load: 1 } },
          { text: "Not worried yet, but I want better direction", score: { longevity: 2 } }
        ]
      },
      {
        id: "meaning",
        label: "Question 11",
        type: "single",
        kicker: "Goal",
        title: "If your daily signals finally made sense, what would it mean to you?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "Wake up knowing what my body needs today", score: { sleep: 1, recovery: 2 }, goal: "daily direction" },
          { text: "Stop guessing when to push or recover", score: { recovery: 3 }, goal: "recovery clarity" },
          { text: "Understand stress before it runs me down", score: { stress: 3 }, goal: "stress clarity" },
          { text: "Feel confident my long-term habits are working", score: { longevity: 3 }, goal: "long-term direction" },
          { text: "Spend less time decoding my app", score: { data: 3 }, goal: "less data overload" }
        ]
      },
      {
        id: "event",
        label: "Question 12",
        type: "single",
        kicker: "Timeline",
        title: "When would you most want clearer health direction?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "This week", score: { consistency: 2 }, event: "this week" },
          { text: "Before my next busy work stretch", score: { stress: 2 }, event: "your next high-stress week" },
          { text: "Before my next training block", score: { recovery: 2 }, event: "your next training block" },
          { text: "Over the next 30 days", score: { longevity: 1 }, event: "the next 30 days" },
          { text: "I just want to start now", score: { data: 1 }, event: "today" }
        ]
      }
    ];

    var resultProfiles = {
      sleep: {
        title: "Your daily signal pattern: sleep-recovery clarity gap.",
        copy: "Your answers point to sleep quality and next-day recovery as the signal that deserves attention first.",
        recommendation: "Hume Band 2.0 is built to connect sleep, HRV, recovery, stress, and daily habits into a clearer morning read, so you can see what your body may be asking for next.",
        because: ["Sleep and recovery showed up as your strongest pattern.", "You want less guessing when your morning energy feels off.", "Your result is about connecting signals, not adding another isolated score."],
        now: [["Sleep signal", "Unclear"], ["Recovery", "Hard to predict"], ["Morning direction", "Low"], ["Pattern confidence", "Spotty"]],
        goal: [["Sleep signal", "Connected"], ["Recovery", "Easier to read"], ["Morning direction", "Clearer"], ["Pattern confidence", "Building"]],
        timelineOne: "First 7 days: start seeing how sleep, HRV, and recovery move together.",
        timelineTwo: "By @event: use your daily read to know whether to push, rest, or adjust."
      },
      stress: {
        title: "Your daily signal pattern: stress-load visibility gap.",
        copy: "Your answers suggest stress may be showing up in sleep, HRV, recovery, and energy before it feels obvious.",
        recommendation: "Hume Band 2.0 helps surface how stress, recovery, sleep, and heart trends move together, giving you a clearer daily read instead of scattered alerts.",
        because: ["Stress context was one of your strongest answer patterns.", "You want to notice the body-data pattern before the day feels derailed.", "The next step is a connected read across signals, not more one-off numbers."],
        now: [["Stress load", "Hard to see"], ["HRV context", "Disconnected"], ["Recovery", "Reactive"], ["Daily focus", "Unclear"]],
        goal: [["Stress load", "Visible"], ["HRV context", "Connected"], ["Recovery", "More proactive"], ["Daily focus", "Clearer"]],
        timelineOne: "First 7 days: watch how stressful days change sleep and recovery signals.",
        timelineTwo: "By @event: spot the days where your body may need a lighter plan."
      },
      recovery: {
        title: "Your daily signal pattern: push-or-rest uncertainty.",
        copy: "Your answers point to recovery direction as the main gap. The problem is not effort. It is knowing when effort is helping.",
        recommendation: "Hume Band 2.0 helps connect activity, sleep, HRV, stress, and recovery signals into a daily read you can use when deciding whether to push, rest, or adjust.",
        because: ["Recovery direction was your clearest signal gap.", "You want your effort matched to what your body data is showing.", "The useful output is daily context, not a pile of disconnected metrics."],
        now: [["Readiness", "Guesswork"], ["Activity", "Separate"], ["Sleep debt", "Easy to miss"], ["Training choices", "Reactive"]],
        goal: [["Readiness", "Contextual"], ["Activity", "Connected"], ["Sleep debt", "Visible"], ["Training choices", "More intentional"]],
        timelineOne: "First 7 days: connect activity, sleep, and HRV into a clearer recovery read.",
        timelineTwo: "By @event: make push-or-rest decisions with less second-guessing."
      },
      heart: {
        title: "Your daily signal pattern: heart-trend context gap.",
        copy: "Your answers suggest you want more than one-off numbers. You want to understand how heart-related wellness trends fit the bigger pattern.",
        recommendation: "Hume Band 2.0 helps track heart-related wellness trends in context with sleep, recovery, stress, and activity, so changes are easier to follow over time.",
        because: ["Heart-trend context showed up strongly in your answers.", "You want patterns you can follow, not isolated readings.", "A connected daily read gives your wearable data more practical context."],
        now: [["Heart trends", "One-off"], ["BP wellness", "Hard to contextualize"], ["HRV", "Isolated"], ["Confidence", "Low"]],
        goal: [["Heart trends", "Tracked over time"], ["BP wellness", "In context"], ["HRV", "Connected"], ["Confidence", "Improving"]],
        timelineOne: "First 7 days: start connecting heart, HRV, sleep, and recovery trends.",
        timelineTwo: "By @event: have a clearer wellness trend picture to follow or discuss."
      },
      longevity: {
        title: "Your daily signal pattern: long-term direction gap.",
        copy: "Your answers suggest daily scores are not enough. You want to know whether your routine is moving your bigger health direction.",
        recommendation: "Hume Band 2.0 helps turn recurring sleep, recovery, heart, stress, activity, and habit signals into trends you can actually follow over time.",
        because: ["Your answers point to long-term health direction, not just today's score.", "You want feedback that makes habits easier to judge.", "The recommendation is a signal system you can keep using daily."],
        now: [["Daily scores", "Short-term"], ["Health direction", "Fuzzy"], ["Habit feedback", "Delayed"], ["Momentum", "Unknown"]],
        goal: [["Daily scores", "Part of a trend"], ["Health direction", "Clearer"], ["Habit feedback", "Faster"], ["Momentum", "Visible"]],
        timelineOne: "First 7 days: create a baseline across sleep, recovery, activity, and heart trends.",
        timelineTwo: "By @event: start seeing whether your routine is moving in the right direction."
      },
      data: {
        title: "Your daily signal pattern: data overload.",
        copy: "Your answers suggest your biggest gap is interpretation. You may already have data, but not the daily direction it should create.",
        recommendation: "Hume Band 2.0 is built to connect the signals many wearables leave scattered, helping your body data become a clearer daily read instead of another dashboard to decode.",
        because: ["You already have or want data, but need it translated into direction.", "Your result points to interpretation as the bottleneck.", "The next step is a wearable that connects the pattern across signals."],
        now: [["Health data", "Scattered"], ["Next step", "Unclear"], ["App fatigue", "High"], ["Confidence", "Low"]],
        goal: [["Health data", "Connected"], ["Next step", "Clearer"], ["App fatigue", "Lower"], ["Confidence", "Building"]],
        timelineOne: "First 7 days: see which signal deserves attention first instead of chasing every metric.",
        timelineTwo: "By @event: use a simpler daily read instead of decoding another dashboard."
      },
      consistency: {
        title: "Your daily signal pattern: consistency gap.",
        copy: "Your answers suggest the issue may be missing data gaps, charging friction, or not having a simple reason to check in daily.",
        recommendation: "Hume Band 2.0 is designed for a simpler daily wearable routine, helping you build a steadier signal baseline across sleep, recovery, activity, and heart trends.",
        because: ["Your answers suggest consistency is blocking better signal quality.", "You need a routine that is easy to repeat, not another app you ignore.", "Better daily context starts with a cleaner wearable baseline."],
        now: [["Wear time", "Inconsistent"], ["Night data", "Easy to miss"], ["Daily habit", "Loose"], ["Signal quality", "Patchy"]],
        goal: [["Wear time", "More consistent"], ["Night data", "Captured"], ["Daily habit", "Simple"], ["Signal quality", "Cleaner"]],
        timelineOne: "First 7 days: build a steadier baseline with a wearable designed for longer, simpler use.",
        timelineTwo: "By @event: make daily tracking feel easier to maintain."
      }
    };

    function setup(root) {
      var state = {
        step: 0,
        scores: { sleep: 0, stress: 0, recovery: 0, heart: 0, longevity: 0, data: 0, consistency: 0, load: 0, resilience: 0 },
        answers: {},
        selected: [],
        mainConcern: "disconnected signals",
        wearable: "unknown",
        goal: "daily direction",
        event: "the next 30 days",
        startedAt: Date.now(),
        hasStarted: false,
        hasCompleted: false
      };

      var card = root.querySelector("[data-hdc-card]");
      var kicker = root.querySelector("[data-hdc-kicker]");
      var title = root.querySelector("[data-hdc-title]");
      var subtitle = root.querySelector("[data-hdc-subtitle]");
      var options = root.querySelector("[data-hdc-options]");
      var continueButton = root.querySelector("[data-hdc-continue]");
      var backButton = root.querySelector("[data-hdc-back]");
      var progress = root.querySelector("[data-hdc-progress]");
      var progressBar = root.querySelector("[data-hdc-progress-bar]");
      var stepLabel = root.querySelector("[data-hdc-step-label]");
      var stepCount = root.querySelector("[data-hdc-step-count]");
      var profile = root.querySelector("[data-hdc-profile]");
      var education = root.querySelector("[data-hdc-education]");
      var result = root.querySelector("[data-hdc-result]");
      var actions = root.querySelector("[data-hdc-actions]");
      var infoVisual = root.querySelector("[data-hdc-info-visual]");

      function slug(value) {
        return String(value || "unknown").toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
      }

      function publish(eventName, detail) {
        var payload = Object.assign({
          quiz_id: "hume_daily_vital_check",
          quiz_version: root.getAttribute("data-quiz-version") || "unknown",
          page_path: window.location.pathname,
          step_id: steps[state.step] ? steps[state.step].id : "result"
        }, detail || {});
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: eventName, hume_daily_vital_check: payload });
        document.dispatchEvent(new CustomEvent(eventName, { detail: payload }));
        if (typeof window.gtag === "function") {
          window.gtag("event", eventName, payload);
        }
      }

      function resetScores() {
        state.scores = { sleep: 0, stress: 0, recovery: 0, heart: 0, longevity: 0, data: 0, consistency: 0, load: 0, resilience: 0 };
        state.mainConcern = "disconnected signals";
        state.wearable = "unknown";
        state.goal = "daily direction";
        state.event = "the next 30 days";
        steps.forEach(function (step) {
          var saved = state.answers[step.id] || [];
          saved.forEach(function (index) {
            var option = step.options && step.options[index];
            if (!option) return;
            Object.keys(option.score || {}).forEach(function (key) {
              state.scores[key] += option.score[key];
            });
            if (option.concern) state.mainConcern = option.concern;
            if (option.wearable) state.wearable = option.wearable;
            if (option.goal) state.goal = option.goal;
            if (option.event) state.event = option.event;
          });
        });
      }

      function topSignal() {
        var keys = ["sleep", "stress", "recovery", "heart", "longevity", "data", "consistency"];
        var winner = keys[0];
        keys.forEach(function (key) {
          if (state.scores[key] > state.scores[winner]) winner = key;
        });
        if (state.scores.data >= state.scores[winner] - 1 && state.wearable !== "no consistent tracker") {
          winner = "data";
        }
        return winner;
      }

      function level() {
        var net = Math.max(0, state.scores.load - state.scores.resilience);
        if (net <= 1) return { label: "Low", marker: "12%", disconnect: "Low", recovery: "Clearer", direction: "Available", potential: "High" };
        if (net <= 3) return { label: "Moderate", marker: "50%", disconnect: "Moderate", recovery: "Mixed", direction: "Needs focus", potential: "Very high" };
        if (net <= 5) return { label: "High", marker: "73%", disconnect: "High", recovery: "Hard to read", direction: "Low", potential: "High" };
        return { label: "Very high", marker: "91%", disconnect: "Very high", recovery: "Reactive", direction: "Very low", potential: "High" };
      }

      function replaceTokens(text) {
        return String(text || "").replace(/@mainConcern/g, state.mainConcern).replace(/@event/g, state.event).replace(/@goal/g, state.goal);
      }

      function clearSpecialViews() {
        infoVisual.hidden = true;
        profile.hidden = true;
        education.hidden = true;
        result.hidden = true;
      }

      function updateProgress() {
        var percent = Math.round((state.step / Math.max(1, steps.length)) * 100);
        var questionTotal = steps.filter(function (item) {
          return item.type === "single" || item.type === "multi";
        }).length;
        var questionNumber = 0;
        steps.slice(0, state.step + 1).forEach(function (item) {
          if (item.type === "single" || item.type === "multi") questionNumber += 1;
        });
        progressBar.style.width = percent + "%";
        progress.setAttribute("aria-valuenow", String(percent));
        stepLabel.textContent = steps[state.step] ? steps[state.step].label : "Result";
        stepCount.textContent = questionNumber ? "Question " + questionNumber + " of " + questionTotal : "Step " + (state.step + 1) + " of " + steps.length;
        backButton.hidden = state.step === 0;
        actions.classList.toggle("has-back", !backButton.hidden);
      }

      function renderOptions(step) {
        options.innerHTML = "";
        if (!step.options) return;
        var selected = state.answers[step.id] || [];
        step.options.forEach(function (option, index) {
          var button = document.createElement("button");
          button.type = "button";
          button.className = "hdc-option";
          if (selected.indexOf(index) !== -1) button.classList.add("is-selected");
          button.setAttribute("aria-pressed", selected.indexOf(index) !== -1 ? "true" : "false");

          var number = document.createElement("span");
          number.className = "hdc-option-number";
          number.textContent = String(index + 1);
          var text = document.createElement("span");
          text.textContent = option.text;
          button.appendChild(number);
          button.appendChild(text);

          button.addEventListener("click", function () {
            if (step.type === "multi") {
              var current = state.answers[step.id] || [];
              var pos = current.indexOf(index);
              if (pos === -1) current.push(index);
              else current.splice(pos, 1);
              state.answers[step.id] = current;
              resetScores();
              renderOptions(step);
              continueButton.hidden = false;
              continueButton.disabled = current.length === 0;
              publish("question_answered", { question_id: step.id, answer: option.text, multi_select: true, step_number: state.step + 1 });
            } else {
              state.answers[step.id] = [index];
              resetScores();
              publish("question_answered", { question_id: step.id, answer: option.text, multi_select: false, step_number: state.step + 1 });
              window.setTimeout(next, 150);
            }
          });
          options.appendChild(button);
        });
      }

      function renderProfile() {
        var signalLevel = level();
        root.querySelector("[data-hdc-profile-level]").textContent = signalLevel.label;
        root.querySelector("[data-hdc-profile-disconnect]").textContent = signalLevel.disconnect;
        root.querySelector("[data-hdc-profile-recovery]").textContent = signalLevel.recovery;
        root.querySelector("[data-hdc-profile-direction]").textContent = signalLevel.direction;
        root.querySelector("[data-hdc-profile-potential]").textContent = signalLevel.potential;
        root.querySelector("[data-hdc-meter-marker]").style.setProperty("--marker", signalLevel.marker);
        profile.hidden = false;
      }

      function fillList(target, rows) {
        target.innerHTML = "";
        rows.forEach(function (row) {
          var li = document.createElement("li");
          var span = document.createElement("span");
          var strong = document.createElement("strong");
          span.textContent = row[0];
          strong.textContent = row[1];
          li.appendChild(span);
          li.appendChild(strong);
          target.appendChild(li);
        });
      }

      function fillBecause(profileData) {
        var list = root.querySelector("[data-hdc-because-list]");
        list.innerHTML = "";
        (profileData.because || []).forEach(function (item) {
          var li = document.createElement("li");
          li.textContent = replaceTokens(item);
          list.appendChild(li);
        });
      }

      function ctaUrl(profileData) {
        var base = root.getAttribute("data-cta-url") || "https://humehealth.com/pages/hume-bandv2";
        var separator = base.indexOf("?") === -1 ? "?" : "&";
        var params = [
          ["utm_source", "thewearabletech"],
          ["utm_medium", "quiz"],
          ["utm_campaign", "daily_vital_check"],
          ["utm_content", slug(profileData.title)],
          ["utm_term", slug(topSignal())],
          ["quiz_result", slug(profileData.title)],
          ["quiz_signal", slug(topSignal())],
          ["quiz_wearable", slug(state.wearable)],
          ["quiz_goal", slug(state.goal)]
        ];
        return base + separator + params.map(function (pair) {
          return encodeURIComponent(pair[0]) + "=" + encodeURIComponent(pair[1]);
        }).join("&");
      }

      function renderResult() {
        var profileData = resultProfiles[topSignal()] || resultProfiles.data;
        root.querySelector("[data-hdc-result-title]").textContent = replaceTokens(profileData.title);
        root.querySelector("[data-hdc-result-copy]").textContent = replaceTokens(profileData.copy);
        root.querySelector("[data-hdc-result-recommendation]").textContent = replaceTokens(profileData.recommendation);
        root.querySelector("[data-hdc-timeline-one]").textContent = replaceTokens(profileData.timelineOne);
        root.querySelector("[data-hdc-timeline-two]").textContent = replaceTokens(profileData.timelineTwo);
        fillBecause(profileData);
        fillList(root.querySelector("[data-hdc-now-list]"), profileData.now);
        fillList(root.querySelector("[data-hdc-goal-list]"), profileData.goal);
        root.querySelector("[data-hdc-cta]").setAttribute("href", ctaUrl(profileData));
        result.hidden = false;
        if (!state.hasCompleted) {
          state.hasCompleted = true;
          publish("quiz_completed", {
            result_type: topSignal(),
            completion_seconds: Math.round((Date.now() - state.startedAt) / 1000)
          });
        }
        publish("result_viewed", {
          result_type: topSignal(),
          cta_url: ctaUrl(profileData),
          completion_seconds: Math.round((Date.now() - state.startedAt) / 1000)
        });
      }

      function render() {
        var step = steps[state.step];
        root.setAttribute("data-step-type", step.type || "single");
        root.setAttribute("data-step-id", step.id || "");
        clearSpecialViews();
        options.innerHTML = "";
        continueButton.hidden = step.type === "single";
        continueButton.disabled = false;
        continueButton.textContent = step.cta || "Continue";
        actions.hidden = false;
        kicker.textContent = step.kicker || "";
        title.textContent = replaceTokens(step.title);
        subtitle.textContent = replaceTokens(step.subtitle);
        card.scrollTop = 0;

        if (step.type === "intro") {
          continueButton.hidden = false;
        }

        if (step.type === "single" || step.type === "multi") {
          renderOptions(step);
          if (step.type === "multi") {
            continueButton.hidden = false;
            continueButton.disabled = !(state.answers[step.id] || []).length;
          }
        }

        if (step.type === "info") {
          infoVisual.hidden = false;
          continueButton.hidden = false;
        }

        if (step.type === "profile") {
          renderProfile();
          continueButton.hidden = false;
        }

        if (step.type === "education") {
          education.hidden = false;
          continueButton.hidden = false;
        }

        updateProgress();
        if (!state.hasStarted) {
          state.hasStarted = true;
          publish("quiz_started", { step_id: step.id, step_type: step.type, step_number: state.step + 1 });
        }
        publish("question_viewed", { step_id: step.id, step_type: step.type, step_number: state.step + 1 });
      }

      function showResult() {
        root.setAttribute("data-step-type", "result");
        root.setAttribute("data-step-id", "result");
        clearSpecialViews();
        options.innerHTML = "";
        actions.hidden = true;
        actions.classList.remove("has-back");
        title.textContent = "";
        subtitle.textContent = "";
        kicker.textContent = "";
        progressBar.style.width = "100%";
        progress.setAttribute("aria-valuenow", "100");
        stepLabel.textContent = "Result";
        stepCount.textContent = "Complete";
        renderResult();
      }

      function next() {
        if (state.step + 1 >= steps.length) {
          showResult();
          return;
        }
        state.step += 1;
        render();
      }

      function back() {
        if (state.step <= 0) return;
        state.step -= 1;
        render();
      }

      continueButton.addEventListener("click", function () {
        if (continueButton.disabled) return;
        publish("quiz_continue_clicked", { step_id: steps[state.step].id, step_number: state.step + 1 });
        next();
      });

      backButton.addEventListener("click", function () {
        publish("quiz_back_clicked", { from_step: steps[state.step].id, step_number: state.step + 1 });
        back();
      });

      root.querySelector("[data-hdc-cta]").addEventListener("click", function () {
        publish("quiz_cta_clicked", { result_type: topSignal(), funnel_step: "pdp_handoff" });
      });

      render();
    }

    roots.forEach(setup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hume-band-daily-vital-check-rovina"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll("[data-hume-daily-check]");
    if (!roots.length) return;

    var steps = [
      {
        id: "age",
        label: "Question 1",
        type: "single",
        kicker: "Daily Vital Check",
        title: "How old are you?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "Under 35", score: { resilience: 1 } },
          { text: "35-44", score: { resilience: 1, load: 1 } },
          { text: "45-54", score: { load: 2 } },
          { text: "55-64", score: { load: 3 } },
          { text: "65 or older", score: { load: 4 } }
        ]
      },
      {
        id: "signals",
        label: "Question 2",
        type: "multi",
        kicker: "Choose all that apply",
        title: "Which hidden body signals have you noticed lately?",
        subtitle: "Choose all that apply.",
        options: [
          { text: "Waking up tired even after enough sleep", score: { sleep: 3, load: 1 }, concern: "unrefreshing sleep" },
          { text: "Afternoon energy crash or brain fog", score: { recovery: 2, load: 1 }, concern: "energy dips" },
          { text: "Stress feels like it stays in my body", score: { stress: 3, load: 1 }, concern: "stress load" },
          { text: "I do not know when to push or rest", score: { recovery: 3 }, concern: "recovery confusion" },
          { text: "Heart, HRV, or BP trends feel hard to read", score: { heart: 3 }, concern: "heart trend clarity" },
          { text: "My wearable gives numbers, not next steps", score: { data: 3 }, concern: "data without direction" }
        ]
      },
      {
        id: "wearable",
        label: "Question 3",
        type: "single",
        kicker: "Current tracking",
        title: "What are you using to track your health right now?",
        subtitle: "This helps us understand whether your gap is measurement, interpretation, or consistency.",
        options: [
          { text: "Apple Watch", score: { data: 3 }, wearable: "Apple Watch" },
          { text: "Oura Ring", score: { data: 3 }, wearable: "Oura Ring" },
          { text: "WHOOP", score: { data: 3 }, wearable: "WHOOP" },
          { text: "Garmin or Fitbit", score: { data: 2, consistency: 1 }, wearable: "Garmin or Fitbit" },
          { text: "Another wearable", score: { data: 2 }, wearable: "another wearable" },
          { text: "Nothing consistently", score: { consistency: 3 }, wearable: "no consistent tracker" }
        ]
      },
      {
        id: "duration",
        label: "Question 4",
        type: "single",
        kicker: "Pattern length",
        title: "How long have these signals felt unclear?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "Just started recently", score: { resilience: 1 } },
          { text: "A few months", score: { load: 1 } },
          { text: "Around a year", score: { load: 2 } },
          { text: "Several years", score: { load: 3 } },
          { text: "I cannot remember when it started", score: { load: 4 } }
        ]
      },
      {
        id: "reassurance",
        label: "Checkpoint",
        type: "info",
        kicker: "You are in the right place",
        title: "Thousands of people are tracking health data but still missing the pattern.",
        subtitle: "If your biggest issue is @mainConcern, the next step is not more random numbers. It is seeing how sleep, stress, heart trends, recovery, and habits connect."
      },
      {
        id: "sleep",
        label: "Question 5",
        type: "single",
        kicker: "Sleep signal",
        title: "What best describes your sleep lately?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "I sleep enough but still wake up tired", score: { sleep: 3, load: 1 } },
          { text: "My sleep varies a lot night to night", score: { sleep: 2, consistency: 1 } },
          { text: "Stress clearly affects my sleep", score: { stress: 2, sleep: 1 } },
          { text: "I mostly sleep fine", score: { resilience: 1 } },
          { text: "I do not know what my sleep data means", score: { data: 3 } }
        ]
      },
      {
        id: "conditions",
        label: "Question 6",
        type: "multi",
        kicker: "Choose all that apply",
        title: "Which wellness areas do you want more context around?",
        subtitle: "Choose all that apply.",
        options: [
          { text: "Blood pressure wellness trends", score: { heart: 3 } },
          { text: "HRV and resting heart rate", score: { heart: 2, recovery: 1 } },
          { text: "Stress and nervous system load", score: { stress: 3 } },
          { text: "Sleep quality and sleep stages", score: { sleep: 3 } },
          { text: "Recovery after workouts or long days", score: { recovery: 3 } },
          { text: "Long-term health direction", score: { longevity: 3 } }
        ]
      },
      {
        id: "noise",
        label: "Question 7",
        type: "single",
        kicker: "Data overload",
        title: "How does your current wearable usually leave you feeling?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "I see scores but do not know what to do", score: { data: 4 } },
          { text: "I only check it when something feels off", score: { consistency: 2, data: 1 } },
          { text: "I like the data, but it feels disconnected", score: { data: 3 } },
          { text: "It helps, but I want a clearer daily focus", score: { recovery: 1, data: 2 } },
          { text: "I mostly ignore the app", score: { consistency: 3 } }
        ]
      },
      {
        id: "profile",
        label: "Profile",
        type: "profile",
        kicker: "Your Daily Vital Profile",
        title: "Your disconnected signal assessment",
        subtitle: "Based on your answers, your body signals may be creating more noise than direction."
      },
      {
        id: "doctor",
        label: "Question 8",
        type: "multi",
        kicker: "Choose all that apply",
        title: "What have you already tried to make sense of your health data?",
        subtitle: "Choose all that apply.",
        options: [
          { text: "Checking wearable scores every morning", score: { data: 2 } },
          { text: "Changing sleep or bedtime habits", score: { sleep: 1, consistency: 1 } },
          { text: "Adjusting workouts based on recovery", score: { recovery: 2 } },
          { text: "Meditation, breathwork, or stress tools", score: { stress: 2 } },
          { text: "Reading articles or watching health content", score: { data: 1 } },
          { text: "Nothing consistently yet", score: { consistency: 3 } }
        ]
      },
      {
        id: "education",
        label: "Why it happens",
        type: "education",
        kicker: "",
        title: "Here's Why Your Wearable Numbers Still Feel Confusing...",
        subtitle: ""
      },
      {
        id: "routine",
        label: "Question 9",
        type: "single",
        kicker: "Daily routine",
        title: "How much time can you spare for a health check each day?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "Under 30 seconds", score: { consistency: 3 } },
          { text: "About 1 minute", score: { consistency: 2 } },
          { text: "2-5 minutes", score: { resilience: 1 } },
          { text: "10+ minutes", score: { resilience: 1 } },
          { text: "I do not have a routine", score: { consistency: 3, load: 1 } }
        ]
      },
      {
        id: "worry",
        label: "Question 10",
        type: "single",
        kicker: "Motivation",
        title: "How concerned are you about missing important health signals?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "Very concerned - I think about it often", score: { load: 3 } },
          { text: "Concerned when my numbers look off", score: { load: 2, data: 1 } },
          { text: "Somewhat concerned", score: { load: 1 } },
          { text: "Not worried yet, but I want better direction", score: { longevity: 2 } }
        ]
      },
      {
        id: "meaning",
        label: "Question 11",
        type: "single",
        kicker: "Goal",
        title: "If your daily signals finally made sense, what would it mean to you?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "Wake up knowing what my body needs today", score: { sleep: 1, recovery: 2 }, goal: "daily direction" },
          { text: "Stop guessing when to push or recover", score: { recovery: 3 }, goal: "recovery clarity" },
          { text: "Understand stress before it runs me down", score: { stress: 3 }, goal: "stress clarity" },
          { text: "Feel confident my long-term habits are working", score: { longevity: 3 }, goal: "long-term direction" },
          { text: "Spend less time decoding my app", score: { data: 3 }, goal: "less data overload" }
        ]
      },
      {
        id: "event",
        label: "Question 12",
        type: "single",
        kicker: "Timeline",
        title: "When would you most want clearer health direction?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "This week", score: { consistency: 2 }, event: "this week" },
          { text: "Before my next busy work stretch", score: { stress: 2 }, event: "your next high-stress week" },
          { text: "Before my next training block", score: { recovery: 2 }, event: "your next training block" },
          { text: "Over the next 30 days", score: { longevity: 1 }, event: "the next 30 days" },
          { text: "I just want to start now", score: { data: 1 }, event: "today" }
        ]
      }
    ];

    var resultProfiles = {
      sleep: {
        title: "You are just one connected sleep-recovery read away from clearer mornings.",
        copy: "Your answers point to sleep quality and next-day recovery as the signal that deserves the most attention first.",
        now: [["Sleep signal", "Unclear"], ["Recovery", "Hard to predict"], ["Morning direction", "Low"], ["Pattern confidence", "Spotty"]],
        goal: [["Sleep signal", "Connected"], ["Recovery", "Easier to read"], ["Morning direction", "Clearer"], ["Pattern confidence", "Building"]],
        timelineOne: "First 7 days: start seeing how sleep, HRV, and recovery move together.",
        timelineTwo: "By @event: use your daily read to know whether to push, rest, or adjust."
      },
      stress: {
        title: "You are just one stress-load pattern away from catching the signal earlier.",
        copy: "Your answers suggest stress may be showing up in sleep, HRV, recovery, and energy before it feels obvious.",
        now: [["Stress load", "Hard to see"], ["HRV context", "Disconnected"], ["Recovery", "Reactive"], ["Daily focus", "Unclear"]],
        goal: [["Stress load", "Visible"], ["HRV context", "Connected"], ["Recovery", "More proactive"], ["Daily focus", "Clearer"]],
        timelineOne: "First 7 days: watch how stressful days change sleep and recovery signals.",
        timelineTwo: "By @event: spot the days where your body may need a lighter plan."
      },
      recovery: {
        title: "You are just one push-or-rest signal away from less guessing.",
        copy: "Your answers point to recovery direction as the main gap. The problem is not effort. It is knowing when effort is helping.",
        now: [["Readiness", "Guesswork"], ["Activity", "Separate"], ["Sleep debt", "Easy to miss"], ["Training choices", "Reactive"]],
        goal: [["Readiness", "Contextual"], ["Activity", "Connected"], ["Sleep debt", "Visible"], ["Training choices", "More intentional"]],
        timelineOne: "First 7 days: connect activity, sleep, and HRV into a clearer recovery read.",
        timelineTwo: "By @event: make push-or-rest decisions with less second-guessing."
      },
      heart: {
        title: "You are just one heart-trend read away from clearer context.",
        copy: "Your answers suggest you want more than one-off numbers. You want to understand how heart-related wellness trends fit the bigger pattern.",
        now: [["Heart trends", "One-off"], ["BP wellness", "Hard to contextualize"], ["HRV", "Isolated"], ["Confidence", "Low"]],
        goal: [["Heart trends", "Tracked over time"], ["BP wellness", "In context"], ["HRV", "Connected"], ["Confidence", "Improving"]],
        timelineOne: "First 7 days: start connecting heart, HRV, sleep, and recovery trends.",
        timelineTwo: "By @event: have a clearer wellness trend picture to follow or discuss."
      },
      longevity: {
        title: "You are just one long-term signal away from knowing if your habits are working.",
        copy: "Your answers suggest daily scores are not enough. You want to know whether your routine is moving your bigger health direction.",
        now: [["Daily scores", "Short-term"], ["Health direction", "Fuzzy"], ["Habit feedback", "Delayed"], ["Momentum", "Unknown"]],
        goal: [["Daily scores", "Part of a trend"], ["Health direction", "Clearer"], ["Habit feedback", "Faster"], ["Momentum", "Visible"]],
        timelineOne: "First 7 days: create a baseline across sleep, recovery, activity, and heart trends.",
        timelineTwo: "By @event: start seeing whether your routine is moving in the right direction."
      },
      data: {
        title: "You are just one connected read away from escaping data overload.",
        copy: "Your answers suggest your biggest gap is interpretation. You may already have data, but not the daily direction it should create.",
        now: [["Health data", "Scattered"], ["Next step", "Unclear"], ["App fatigue", "High"], ["Confidence", "Low"]],
        goal: [["Health data", "Connected"], ["Next step", "Clearer"], ["App fatigue", "Lower"], ["Confidence", "Building"]],
        timelineOne: "First 7 days: see which signal deserves attention first instead of chasing every metric.",
        timelineTwo: "By @event: use a simpler daily read instead of decoding another dashboard."
      },
      consistency: {
        title: "You are just one consistent wearable routine away from a cleaner signal.",
        copy: "Your answers suggest the issue may be missing data gaps, charging friction, or not having a simple reason to check in daily.",
        now: [["Wear time", "Inconsistent"], ["Night data", "Easy to miss"], ["Daily habit", "Loose"], ["Signal quality", "Patchy"]],
        goal: [["Wear time", "More consistent"], ["Night data", "Captured"], ["Daily habit", "Simple"], ["Signal quality", "Cleaner"]],
        timelineOne: "First 7 days: build a steadier baseline with a wearable designed for longer, simpler use.",
        timelineTwo: "By @event: make daily tracking feel easier to maintain."
      }
    };

    function setup(root) {
      var state = {
        step: 0,
        scores: { sleep: 0, stress: 0, recovery: 0, heart: 0, longevity: 0, data: 0, consistency: 0, load: 0, resilience: 0 },
        answers: {},
        selected: [],
        mainConcern: "disconnected signals",
        wearable: "unknown",
        goal: "daily direction",
        event: "the next 30 days",
        startedAt: Date.now()
      };

      var card = root.querySelector("[data-hdc-card]");
      var kicker = root.querySelector("[data-hdc-kicker]");
      var title = root.querySelector("[data-hdc-title]");
      var subtitle = root.querySelector("[data-hdc-subtitle]");
      var options = root.querySelector("[data-hdc-options]");
      var continueButton = root.querySelector("[data-hdc-continue]");
      var backButton = root.querySelector("[data-hdc-back]");
      var progress = root.querySelector("[data-hdc-progress]");
      var progressBar = root.querySelector("[data-hdc-progress-bar]");
      var stepLabel = root.querySelector("[data-hdc-step-label]");
      var stepCount = root.querySelector("[data-hdc-step-count]");
      var profile = root.querySelector("[data-hdc-profile]");
      var education = root.querySelector("[data-hdc-education]");
      var result = root.querySelector("[data-hdc-result]");
      var actions = root.querySelector("[data-hdc-actions]");
      var infoVisual = root.querySelector("[data-hdc-info-visual]");

      function slug(value) {
        return String(value || "unknown").toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
      }

      function publish(eventName, detail) {
        var payload = Object.assign({
          quiz_id: "hume_daily_vital_check",
          quiz_version: root.getAttribute("data-quiz-version") || "unknown",
          page_path: window.location.pathname,
          step_id: steps[state.step] ? steps[state.step].id : "result"
        }, detail || {});
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: eventName, hume_daily_vital_check: payload });
        if (typeof window.gtag === "function") {
          window.gtag("event", eventName, payload);
        }
      }

      function resetScores() {
        state.scores = { sleep: 0, stress: 0, recovery: 0, heart: 0, longevity: 0, data: 0, consistency: 0, load: 0, resilience: 0 };
        state.mainConcern = "disconnected signals";
        state.wearable = "unknown";
        state.goal = "daily direction";
        state.event = "the next 30 days";
        steps.forEach(function (step) {
          var saved = state.answers[step.id] || [];
          saved.forEach(function (index) {
            var option = step.options && step.options[index];
            if (!option) return;
            Object.keys(option.score || {}).forEach(function (key) {
              state.scores[key] += option.score[key];
            });
            if (option.concern) state.mainConcern = option.concern;
            if (option.wearable) state.wearable = option.wearable;
            if (option.goal) state.goal = option.goal;
            if (option.event) state.event = option.event;
          });
        });
      }

      function topSignal() {
        var keys = ["sleep", "stress", "recovery", "heart", "longevity", "data", "consistency"];
        var winner = keys[0];
        keys.forEach(function (key) {
          if (state.scores[key] > state.scores[winner]) winner = key;
        });
        if (state.scores.data >= state.scores[winner] - 1 && state.wearable !== "no consistent tracker") {
          winner = "data";
        }
        return winner;
      }

      function level() {
        var net = Math.max(0, state.scores.load - state.scores.resilience);
        if (net <= 1) return { label: "Low", marker: "12%", disconnect: "Low", recovery: "Clearer", direction: "Available", potential: "High" };
        if (net <= 3) return { label: "Moderate", marker: "50%", disconnect: "Moderate", recovery: "Mixed", direction: "Needs focus", potential: "Very high" };
        if (net <= 5) return { label: "High", marker: "73%", disconnect: "High", recovery: "Hard to read", direction: "Low", potential: "High" };
        return { label: "Very high", marker: "91%", disconnect: "Very high", recovery: "Reactive", direction: "Very low", potential: "High" };
      }

      function replaceTokens(text) {
        return String(text || "").replace(/@mainConcern/g, state.mainConcern).replace(/@event/g, state.event).replace(/@goal/g, state.goal);
      }

      function clearSpecialViews() {
        infoVisual.hidden = true;
        profile.hidden = true;
        education.hidden = true;
        result.hidden = true;
      }

      function updateProgress() {
        var percent = Math.round((state.step / Math.max(1, steps.length)) * 100);
        progressBar.style.width = percent + "%";
        progress.setAttribute("aria-valuenow", String(percent));
        stepLabel.textContent = steps[state.step] ? steps[state.step].label : "Result";
        stepCount.textContent = Math.min(state.step + 1, steps.length) + " of " + steps.length;
        backButton.hidden = state.step === 0;
        actions.classList.toggle("has-back", !backButton.hidden);
      }

      function renderOptions(step) {
        options.innerHTML = "";
        if (!step.options) return;
        var selected = state.answers[step.id] || [];
        step.options.forEach(function (option, index) {
          var button = document.createElement("button");
          button.type = "button";
          button.className = "hdc-option";
          if (selected.indexOf(index) !== -1) button.classList.add("is-selected");
          button.setAttribute("aria-pressed", selected.indexOf(index) !== -1 ? "true" : "false");

          var number = document.createElement("span");
          number.className = "hdc-option-number";
          number.textContent = String(index + 1);
          var text = document.createElement("span");
          text.textContent = option.text;
          button.appendChild(number);
          button.appendChild(text);

          button.addEventListener("click", function () {
            if (step.type === "multi") {
              var current = state.answers[step.id] || [];
              var pos = current.indexOf(index);
              if (pos === -1) current.push(index);
              else current.splice(pos, 1);
              state.answers[step.id] = current;
              resetScores();
              renderOptions(step);
              continueButton.hidden = current.length === 0;
              publish("daily_vital_answer_select", { question_id: step.id, answer: option.text, multi_select: true });
            } else {
              state.answers[step.id] = [index];
              resetScores();
              publish("daily_vital_answer_select", { question_id: step.id, answer: option.text, multi_select: false });
              window.setTimeout(next, 150);
            }
          });
          options.appendChild(button);
        });
      }

      function renderProfile() {
        var signalLevel = level();
        root.querySelector("[data-hdc-profile-level]").textContent = signalLevel.label;
        root.querySelector("[data-hdc-profile-disconnect]").textContent = signalLevel.disconnect;
        root.querySelector("[data-hdc-profile-recovery]").textContent = signalLevel.recovery;
        root.querySelector("[data-hdc-profile-direction]").textContent = signalLevel.direction;
        root.querySelector("[data-hdc-profile-potential]").textContent = signalLevel.potential;
        root.querySelector("[data-hdc-meter-marker]").style.setProperty("--marker", signalLevel.marker);
        profile.hidden = false;
      }

      function fillList(target, rows) {
        target.innerHTML = "";
        rows.forEach(function (row) {
          var li = document.createElement("li");
          var span = document.createElement("span");
          var strong = document.createElement("strong");
          span.textContent = row[0];
          strong.textContent = row[1];
          li.appendChild(span);
          li.appendChild(strong);
          target.appendChild(li);
        });
      }

      function ctaUrl(profileData) {
        var base = root.getAttribute("data-cta-url") || "https://humehealth.com/pages/hume-bandv2";
        var separator = base.indexOf("?") === -1 ? "?" : "&";
        var params = [
          ["utm_source", "thewearabletech"],
          ["utm_medium", "quiz"],
          ["utm_campaign", "daily_vital_check"],
          ["utm_content", slug(profileData.title)],
          ["utm_term", slug(topSignal())],
          ["quiz_result", slug(profileData.title)],
          ["quiz_signal", slug(topSignal())],
          ["quiz_wearable", slug(state.wearable)],
          ["quiz_goal", slug(state.goal)]
        ];
        return base + separator + params.map(function (pair) {
          return encodeURIComponent(pair[0]) + "=" + encodeURIComponent(pair[1]);
        }).join("&");
      }

      function renderResult() {
        var profileData = resultProfiles[topSignal()] || resultProfiles.data;
        root.querySelector("[data-hdc-result-title]").textContent = replaceTokens(profileData.title);
        root.querySelector("[data-hdc-result-copy]").textContent = replaceTokens(profileData.copy);
        root.querySelector("[data-hdc-timeline-one]").textContent = replaceTokens(profileData.timelineOne);
        root.querySelector("[data-hdc-timeline-two]").textContent = replaceTokens(profileData.timelineTwo);
        fillList(root.querySelector("[data-hdc-now-list]"), profileData.now);
        fillList(root.querySelector("[data-hdc-goal-list]"), profileData.goal);
        root.querySelector("[data-hdc-cta]").setAttribute("href", ctaUrl(profileData));
        result.hidden = false;
        publish("daily_vital_result_view", {
          result_type: topSignal(),
          cta_url: ctaUrl(profileData),
          completion_seconds: Math.round((Date.now() - state.startedAt) / 1000)
        });
      }

      function render() {
        var step = steps[state.step];
        root.setAttribute("data-step-type", step.type || "single");
        clearSpecialViews();
        options.innerHTML = "";
        continueButton.hidden = step.type === "single";
        actions.hidden = false;
        kicker.textContent = step.kicker || "";
        title.textContent = replaceTokens(step.title);
        subtitle.textContent = replaceTokens(step.subtitle);
        card.scrollTop = 0;

        if (step.type === "single" || step.type === "multi") {
          renderOptions(step);
          if (step.type === "multi") continueButton.hidden = !(state.answers[step.id] || []).length;
        }

        if (step.type === "info") {
          infoVisual.hidden = false;
          continueButton.hidden = false;
        }

        if (step.type === "profile") {
          renderProfile();
          continueButton.hidden = false;
        }

        if (step.type === "education") {
          education.hidden = false;
          continueButton.hidden = false;
        }

        updateProgress();
        publish("daily_vital_step_view", { step_id: step.id, step_type: step.type, step_number: state.step + 1 });
      }

      function showResult() {
        root.setAttribute("data-step-type", "result");
        clearSpecialViews();
        options.innerHTML = "";
        actions.hidden = true;
        actions.classList.remove("has-back");
        title.textContent = "";
        subtitle.textContent = "";
        kicker.textContent = "";
        progressBar.style.width = "100%";
        progress.setAttribute("aria-valuenow", "100");
        stepLabel.textContent = "Result";
        stepCount.textContent = "Complete";
        renderResult();
      }

      function next() {
        if (state.step + 1 >= steps.length) {
          showResult();
          return;
        }
        state.step += 1;
        render();
      }

      function back() {
        if (state.step <= 0) return;
        state.step -= 1;
        render();
      }

      continueButton.addEventListener("click", function () {
        publish("daily_vital_continue_click", { step_id: steps[state.step].id });
        next();
      });

      backButton.addEventListener("click", function () {
        publish("daily_vital_back_click", { from_step: steps[state.step].id });
        back();
      });

      root.querySelector("[data-hdc-cta]").addEventListener("click", function () {
        publish("daily_vital_offer_click", { result_type: topSignal(), funnel_step: "pdp_handoff" });
      });

      render();
    }

    roots.forEach(setup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hume-band-daily-vital-check-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll("[data-hume-daily-check]");
    if (!roots.length) return;

    var steps = [
      {
        id: "age",
        label: "Question 1",
        type: "single",
        kicker: "Daily Vital Check",
        title: "How old are you?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "Under 35", score: { resilience: 1 } },
          { text: "35-44", score: { resilience: 1, load: 1 } },
          { text: "45-54", score: { load: 2 } },
          { text: "55-64", score: { load: 3 } },
          { text: "65 or older", score: { load: 4 } }
        ]
      },
      {
        id: "signals",
        label: "Question 2",
        type: "multi",
        kicker: "Choose all that apply",
        title: "Which hidden body signals have you noticed lately?",
        subtitle: "Choose all that apply.",
        options: [
          { text: "Waking up tired even after enough sleep", score: { sleep: 3, load: 1 }, concern: "unrefreshing sleep" },
          { text: "Afternoon energy crash or brain fog", score: { recovery: 2, load: 1 }, concern: "energy dips" },
          { text: "Stress feels like it stays in my body", score: { stress: 3, load: 1 }, concern: "stress load" },
          { text: "I do not know when to push or rest", score: { recovery: 3 }, concern: "recovery confusion" },
          { text: "Heart, HRV, or BP trends feel hard to read", score: { heart: 3 }, concern: "heart trend clarity" },
          { text: "My wearable gives numbers, not next steps", score: { data: 3 }, concern: "data without direction" }
        ]
      },
      {
        id: "wearable",
        label: "Question 3",
        type: "single",
        kicker: "Current tracking",
        title: "What are you using to track your health right now?",
        subtitle: "This helps us understand whether your gap is measurement, interpretation, or consistency.",
        options: [
          { text: "Apple Watch", score: { data: 3 }, wearable: "Apple Watch" },
          { text: "Oura Ring", score: { data: 3 }, wearable: "Oura Ring" },
          { text: "WHOOP", score: { data: 3 }, wearable: "WHOOP" },
          { text: "Garmin or Fitbit", score: { data: 2, consistency: 1 }, wearable: "Garmin or Fitbit" },
          { text: "Another wearable", score: { data: 2 }, wearable: "another wearable" },
          { text: "Nothing consistently", score: { consistency: 3 }, wearable: "no consistent tracker" }
        ]
      },
      {
        id: "duration",
        label: "Question 4",
        type: "single",
        kicker: "Pattern length",
        title: "How long have these signals felt unclear?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "Just started recently", score: { resilience: 1 } },
          { text: "A few months", score: { load: 1 } },
          { text: "Around a year", score: { load: 2 } },
          { text: "Several years", score: { load: 3 } },
          { text: "I cannot remember when it started", score: { load: 4 } }
        ]
      },
      {
        id: "reassurance",
        label: "Checkpoint",
        type: "info",
        kicker: "You are in the right place",
        title: "Thousands of people are tracking health data but still missing the pattern.",
        subtitle: "If your biggest issue is @mainConcern, the next step is not more random numbers. It is seeing how sleep, stress, heart trends, recovery, and habits connect."
      },
      {
        id: "sleep",
        label: "Question 5",
        type: "single",
        kicker: "Sleep signal",
        title: "What best describes your sleep lately?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "I sleep enough but still wake up tired", score: { sleep: 3, load: 1 } },
          { text: "My sleep varies a lot night to night", score: { sleep: 2, consistency: 1 } },
          { text: "Stress clearly affects my sleep", score: { stress: 2, sleep: 1 } },
          { text: "I mostly sleep fine", score: { resilience: 1 } },
          { text: "I do not know what my sleep data means", score: { data: 3 } }
        ]
      },
      {
        id: "conditions",
        label: "Question 6",
        type: "multi",
        kicker: "Choose all that apply",
        title: "Which wellness areas do you want more context around?",
        subtitle: "Choose all that apply.",
        options: [
          { text: "Blood pressure wellness trends", score: { heart: 3 } },
          { text: "HRV and resting heart rate", score: { heart: 2, recovery: 1 } },
          { text: "Stress and nervous system load", score: { stress: 3 } },
          { text: "Sleep quality and sleep stages", score: { sleep: 3 } },
          { text: "Recovery after workouts or long days", score: { recovery: 3 } },
          { text: "Long-term health direction", score: { longevity: 3 } }
        ]
      },
      {
        id: "noise",
        label: "Question 7",
        type: "single",
        kicker: "Data overload",
        title: "How does your current wearable usually leave you feeling?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "I see scores but do not know what to do", score: { data: 4 } },
          { text: "I only check it when something feels off", score: { consistency: 2, data: 1 } },
          { text: "I like the data, but it feels disconnected", score: { data: 3 } },
          { text: "It helps, but I want a clearer daily focus", score: { recovery: 1, data: 2 } },
          { text: "I mostly ignore the app", score: { consistency: 3 } }
        ]
      },
      {
        id: "profile",
        label: "Profile",
        type: "profile",
        kicker: "Your Daily Vital Profile",
        title: "Your disconnected signal assessment",
        subtitle: "Based on your answers, your body signals may be creating more noise than direction."
      },
      {
        id: "doctor",
        label: "Question 8",
        type: "multi",
        kicker: "Choose all that apply",
        title: "What have you already tried to make sense of your health data?",
        subtitle: "Choose all that apply.",
        options: [
          { text: "Checking wearable scores every morning", score: { data: 2 } },
          { text: "Changing sleep or bedtime habits", score: { sleep: 1, consistency: 1 } },
          { text: "Adjusting workouts based on recovery", score: { recovery: 2 } },
          { text: "Meditation, breathwork, or stress tools", score: { stress: 2 } },
          { text: "Reading articles or watching health content", score: { data: 1 } },
          { text: "Nothing consistently yet", score: { consistency: 3 } }
        ]
      },
      {
        id: "education",
        label: "Why it happens",
        type: "education",
        kicker: "Here is why your numbers can still feel confusing",
        title: "Most wearables manage the symptom: more tracking. They do not solve the real gap: connected direction.",
        subtitle: ""
      },
      {
        id: "routine",
        label: "Question 9",
        type: "single",
        kicker: "Daily routine",
        title: "How much time can you spare for a health check each day?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "Under 30 seconds", score: { consistency: 3 } },
          { text: "About 1 minute", score: { consistency: 2 } },
          { text: "2-5 minutes", score: { resilience: 1 } },
          { text: "10+ minutes", score: { resilience: 1 } },
          { text: "I do not have a routine", score: { consistency: 3, load: 1 } }
        ]
      },
      {
        id: "worry",
        label: "Question 10",
        type: "single",
        kicker: "Motivation",
        title: "How concerned are you about missing important health signals?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "Very concerned - I think about it often", score: { load: 3 } },
          { text: "Concerned when my numbers look off", score: { load: 2, data: 1 } },
          { text: "Somewhat concerned", score: { load: 1 } },
          { text: "Not worried yet, but I want better direction", score: { longevity: 2 } }
        ]
      },
      {
        id: "meaning",
        label: "Question 11",
        type: "single",
        kicker: "Goal",
        title: "If your daily signals finally made sense, what would it mean to you?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "Wake up knowing what my body needs today", score: { sleep: 1, recovery: 2 }, goal: "daily direction" },
          { text: "Stop guessing when to push or recover", score: { recovery: 3 }, goal: "recovery clarity" },
          { text: "Understand stress before it runs me down", score: { stress: 3 }, goal: "stress clarity" },
          { text: "Feel confident my long-term habits are working", score: { longevity: 3 }, goal: "long-term direction" },
          { text: "Spend less time decoding my app", score: { data: 3 }, goal: "less data overload" }
        ]
      },
      {
        id: "event",
        label: "Question 12",
        type: "single",
        kicker: "Timeline",
        title: "When would you most want clearer health direction?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "This week", score: { consistency: 2 }, event: "this week" },
          { text: "Before my next busy work stretch", score: { stress: 2 }, event: "your next high-stress week" },
          { text: "Before my next training block", score: { recovery: 2 }, event: "your next training block" },
          { text: "Over the next 30 days", score: { longevity: 1 }, event: "the next 30 days" },
          { text: "I just want to start now", score: { data: 1 }, event: "today" }
        ]
      }
    ];

    var resultProfiles = {
      sleep: {
        title: "You are just one connected sleep-recovery read away from clearer mornings.",
        copy: "Your answers point to sleep quality and next-day recovery as the signal that deserves the most attention first.",
        now: [["Sleep signal", "Unclear"], ["Recovery", "Hard to predict"], ["Morning direction", "Low"], ["Pattern confidence", "Spotty"]],
        goal: [["Sleep signal", "Connected"], ["Recovery", "Easier to read"], ["Morning direction", "Clearer"], ["Pattern confidence", "Building"]],
        timelineOne: "First 7 days: start seeing how sleep, HRV, and recovery move together.",
        timelineTwo: "By @event: use your daily read to know whether to push, rest, or adjust."
      },
      stress: {
        title: "You are just one stress-load pattern away from catching the signal earlier.",
        copy: "Your answers suggest stress may be showing up in sleep, HRV, recovery, and energy before it feels obvious.",
        now: [["Stress load", "Hard to see"], ["HRV context", "Disconnected"], ["Recovery", "Reactive"], ["Daily focus", "Unclear"]],
        goal: [["Stress load", "Visible"], ["HRV context", "Connected"], ["Recovery", "More proactive"], ["Daily focus", "Clearer"]],
        timelineOne: "First 7 days: watch how stressful days change sleep and recovery signals.",
        timelineTwo: "By @event: spot the days where your body may need a lighter plan."
      },
      recovery: {
        title: "You are just one push-or-rest signal away from less guessing.",
        copy: "Your answers point to recovery direction as the main gap. The problem is not effort. It is knowing when effort is helping.",
        now: [["Readiness", "Guesswork"], ["Activity", "Separate"], ["Sleep debt", "Easy to miss"], ["Training choices", "Reactive"]],
        goal: [["Readiness", "Contextual"], ["Activity", "Connected"], ["Sleep debt", "Visible"], ["Training choices", "More intentional"]],
        timelineOne: "First 7 days: connect activity, sleep, and HRV into a clearer recovery read.",
        timelineTwo: "By @event: make push-or-rest decisions with less second-guessing."
      },
      heart: {
        title: "You are just one heart-trend read away from clearer context.",
        copy: "Your answers suggest you want more than one-off numbers. You want to understand how heart-related wellness trends fit the bigger pattern.",
        now: [["Heart trends", "One-off"], ["BP wellness", "Hard to contextualize"], ["HRV", "Isolated"], ["Confidence", "Low"]],
        goal: [["Heart trends", "Tracked over time"], ["BP wellness", "In context"], ["HRV", "Connected"], ["Confidence", "Improving"]],
        timelineOne: "First 7 days: start connecting heart, HRV, sleep, and recovery trends.",
        timelineTwo: "By @event: have a clearer wellness trend picture to follow or discuss."
      },
      longevity: {
        title: "You are just one long-term signal away from knowing if your habits are working.",
        copy: "Your answers suggest daily scores are not enough. You want to know whether your routine is moving your bigger health direction.",
        now: [["Daily scores", "Short-term"], ["Health direction", "Fuzzy"], ["Habit feedback", "Delayed"], ["Momentum", "Unknown"]],
        goal: [["Daily scores", "Part of a trend"], ["Health direction", "Clearer"], ["Habit feedback", "Faster"], ["Momentum", "Visible"]],
        timelineOne: "First 7 days: create a baseline across sleep, recovery, activity, and heart trends.",
        timelineTwo: "By @event: start seeing whether your routine is moving in the right direction."
      },
      data: {
        title: "You are just one connected read away from escaping data overload.",
        copy: "Your answers suggest your biggest gap is interpretation. You may already have data, but not the daily direction it should create.",
        now: [["Health data", "Scattered"], ["Next step", "Unclear"], ["App fatigue", "High"], ["Confidence", "Low"]],
        goal: [["Health data", "Connected"], ["Next step", "Clearer"], ["App fatigue", "Lower"], ["Confidence", "Building"]],
        timelineOne: "First 7 days: see which signal deserves attention first instead of chasing every metric.",
        timelineTwo: "By @event: use a simpler daily read instead of decoding another dashboard."
      },
      consistency: {
        title: "You are just one consistent wearable routine away from a cleaner signal.",
        copy: "Your answers suggest the issue may be missing data gaps, charging friction, or not having a simple reason to check in daily.",
        now: [["Wear time", "Inconsistent"], ["Night data", "Easy to miss"], ["Daily habit", "Loose"], ["Signal quality", "Patchy"]],
        goal: [["Wear time", "More consistent"], ["Night data", "Captured"], ["Daily habit", "Simple"], ["Signal quality", "Cleaner"]],
        timelineOne: "First 7 days: build a steadier baseline with a wearable designed for longer, simpler use.",
        timelineTwo: "By @event: make daily tracking feel easier to maintain."
      }
    };

    function setup(root) {
      var state = {
        step: 0,
        scores: { sleep: 0, stress: 0, recovery: 0, heart: 0, longevity: 0, data: 0, consistency: 0, load: 0, resilience: 0 },
        answers: {},
        selected: [],
        mainConcern: "disconnected signals",
        wearable: "unknown",
        goal: "daily direction",
        event: "the next 30 days",
        startedAt: Date.now()
      };

      var card = root.querySelector("[data-hdc-card]");
      var kicker = root.querySelector("[data-hdc-kicker]");
      var title = root.querySelector("[data-hdc-title]");
      var subtitle = root.querySelector("[data-hdc-subtitle]");
      var options = root.querySelector("[data-hdc-options]");
      var continueButton = root.querySelector("[data-hdc-continue]");
      var backButton = root.querySelector("[data-hdc-back]");
      var progress = root.querySelector("[data-hdc-progress]");
      var progressBar = root.querySelector("[data-hdc-progress-bar]");
      var stepLabel = root.querySelector("[data-hdc-step-label]");
      var stepCount = root.querySelector("[data-hdc-step-count]");
      var profile = root.querySelector("[data-hdc-profile]");
      var education = root.querySelector("[data-hdc-education]");
      var result = root.querySelector("[data-hdc-result]");
      var actions = root.querySelector("[data-hdc-actions]");

      function slug(value) {
        return String(value || "unknown").toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
      }

      function publish(eventName, detail) {
        var payload = Object.assign({
          quiz_id: "hume_daily_vital_check",
          quiz_version: root.getAttribute("data-quiz-version") || "unknown",
          page_path: window.location.pathname,
          step_id: steps[state.step] ? steps[state.step].id : "result"
        }, detail || {});
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: eventName, hume_daily_vital_check: payload });
        if (typeof window.gtag === "function") {
          window.gtag("event", eventName, payload);
        }
      }

      function resetScores() {
        state.scores = { sleep: 0, stress: 0, recovery: 0, heart: 0, longevity: 0, data: 0, consistency: 0, load: 0, resilience: 0 };
        state.mainConcern = "disconnected signals";
        state.wearable = "unknown";
        state.goal = "daily direction";
        state.event = "the next 30 days";
        steps.forEach(function (step) {
          var saved = state.answers[step.id] || [];
          saved.forEach(function (index) {
            var option = step.options && step.options[index];
            if (!option) return;
            Object.keys(option.score || {}).forEach(function (key) {
              state.scores[key] += option.score[key];
            });
            if (option.concern) state.mainConcern = option.concern;
            if (option.wearable) state.wearable = option.wearable;
            if (option.goal) state.goal = option.goal;
            if (option.event) state.event = option.event;
          });
        });
      }

      function topSignal() {
        var keys = ["sleep", "stress", "recovery", "heart", "longevity", "data", "consistency"];
        var winner = keys[0];
        keys.forEach(function (key) {
          if (state.scores[key] > state.scores[winner]) winner = key;
        });
        if (state.scores.data >= state.scores[winner] - 1 && state.wearable !== "no consistent tracker") {
          winner = "data";
        }
        return winner;
      }

      function level() {
        var net = Math.max(0, state.scores.load - state.scores.resilience);
        if (net <= 1) return { label: "Low", marker: "12%", disconnect: "Low", recovery: "Clearer", direction: "Available", potential: "High" };
        if (net <= 3) return { label: "Moderate", marker: "50%", disconnect: "Moderate", recovery: "Mixed", direction: "Needs focus", potential: "Very high" };
        if (net <= 5) return { label: "High", marker: "73%", disconnect: "High", recovery: "Hard to read", direction: "Low", potential: "High" };
        return { label: "Very high", marker: "91%", disconnect: "Very high", recovery: "Reactive", direction: "Very low", potential: "High" };
      }

      function replaceTokens(text) {
        return String(text || "").replace(/@mainConcern/g, state.mainConcern).replace(/@event/g, state.event).replace(/@goal/g, state.goal);
      }

      function clearSpecialViews() {
        profile.hidden = true;
        education.hidden = true;
        result.hidden = true;
      }

      function updateProgress() {
        var percent = Math.round((state.step / Math.max(1, steps.length)) * 100);
        progressBar.style.width = percent + "%";
        progress.setAttribute("aria-valuenow", String(percent));
        stepLabel.textContent = steps[state.step] ? steps[state.step].label : "Result";
        stepCount.textContent = Math.min(state.step + 1, steps.length) + " of " + steps.length;
        backButton.hidden = state.step === 0;
      }

      function renderOptions(step) {
        options.innerHTML = "";
        if (!step.options) return;
        var selected = state.answers[step.id] || [];
        step.options.forEach(function (option, index) {
          var button = document.createElement("button");
          button.type = "button";
          button.className = "hdc-option";
          if (selected.indexOf(index) !== -1) button.classList.add("is-selected");
          button.setAttribute("aria-pressed", selected.indexOf(index) !== -1 ? "true" : "false");

          var number = document.createElement("span");
          number.className = "hdc-option-number";
          number.textContent = String(index + 1);
          var text = document.createElement("span");
          text.textContent = option.text;
          button.appendChild(number);
          button.appendChild(text);

          button.addEventListener("click", function () {
            if (step.type === "multi") {
              var current = state.answers[step.id] || [];
              var pos = current.indexOf(index);
              if (pos === -1) current.push(index);
              else current.splice(pos, 1);
              state.answers[step.id] = current;
              resetScores();
              renderOptions(step);
              continueButton.hidden = current.length === 0;
              publish("daily_vital_answer_select", { question_id: step.id, answer: option.text, multi_select: true });
            } else {
              state.answers[step.id] = [index];
              resetScores();
              publish("daily_vital_answer_select", { question_id: step.id, answer: option.text, multi_select: false });
              window.setTimeout(next, 150);
            }
          });
          options.appendChild(button);
        });
      }

      function renderProfile() {
        var signalLevel = level();
        root.querySelector("[data-hdc-profile-level]").textContent = signalLevel.label;
        root.querySelector("[data-hdc-profile-disconnect]").textContent = signalLevel.disconnect;
        root.querySelector("[data-hdc-profile-recovery]").textContent = signalLevel.recovery;
        root.querySelector("[data-hdc-profile-direction]").textContent = signalLevel.direction;
        root.querySelector("[data-hdc-profile-potential]").textContent = signalLevel.potential;
        root.querySelector("[data-hdc-meter-marker]").style.setProperty("--marker", signalLevel.marker);
        profile.hidden = false;
      }

      function fillList(target, rows) {
        target.innerHTML = "";
        rows.forEach(function (row) {
          var li = document.createElement("li");
          var span = document.createElement("span");
          var strong = document.createElement("strong");
          span.textContent = row[0];
          strong.textContent = row[1];
          li.appendChild(span);
          li.appendChild(strong);
          target.appendChild(li);
        });
      }

      function ctaUrl(profileData) {
        var base = root.getAttribute("data-cta-url") || "https://humehealth.com/pages/hume-bandv2";
        var separator = base.indexOf("?") === -1 ? "?" : "&";
        var params = [
          ["utm_source", "thewearabletech"],
          ["utm_medium", "quiz"],
          ["utm_campaign", "daily_vital_check"],
          ["utm_content", slug(profileData.title)],
          ["utm_term", slug(topSignal())],
          ["quiz_result", slug(profileData.title)],
          ["quiz_signal", slug(topSignal())],
          ["quiz_wearable", slug(state.wearable)],
          ["quiz_goal", slug(state.goal)]
        ];
        return base + separator + params.map(function (pair) {
          return encodeURIComponent(pair[0]) + "=" + encodeURIComponent(pair[1]);
        }).join("&");
      }

      function renderResult() {
        var profileData = resultProfiles[topSignal()] || resultProfiles.data;
        root.querySelector("[data-hdc-result-title]").textContent = replaceTokens(profileData.title);
        root.querySelector("[data-hdc-result-copy]").textContent = replaceTokens(profileData.copy);
        root.querySelector("[data-hdc-timeline-one]").textContent = replaceTokens(profileData.timelineOne);
        root.querySelector("[data-hdc-timeline-two]").textContent = replaceTokens(profileData.timelineTwo);
        fillList(root.querySelector("[data-hdc-now-list]"), profileData.now);
        fillList(root.querySelector("[data-hdc-goal-list]"), profileData.goal);
        root.querySelector("[data-hdc-cta]").setAttribute("href", ctaUrl(profileData));
        result.hidden = false;
        publish("daily_vital_result_view", {
          result_type: topSignal(),
          cta_url: ctaUrl(profileData),
          completion_seconds: Math.round((Date.now() - state.startedAt) / 1000)
        });
      }

      function render() {
        var step = steps[state.step];
        clearSpecialViews();
        options.innerHTML = "";
        continueButton.hidden = step.type === "single";
        actions.hidden = false;
        kicker.textContent = step.kicker || "";
        title.textContent = replaceTokens(step.title);
        subtitle.textContent = replaceTokens(step.subtitle);
        card.scrollTop = 0;

        if (step.type === "single" || step.type === "multi") {
          renderOptions(step);
          if (step.type === "multi") continueButton.hidden = !(state.answers[step.id] || []).length;
        }

        if (step.type === "info") {
          continueButton.hidden = false;
        }

        if (step.type === "profile") {
          renderProfile();
          continueButton.hidden = false;
        }

        if (step.type === "education") {
          education.hidden = false;
          continueButton.hidden = false;
        }

        updateProgress();
        publish("daily_vital_step_view", { step_id: step.id, step_type: step.type, step_number: state.step + 1 });
      }

      function showResult() {
        clearSpecialViews();
        options.innerHTML = "";
        actions.hidden = true;
        title.textContent = "";
        subtitle.textContent = "";
        kicker.textContent = "";
        progressBar.style.width = "100%";
        progress.setAttribute("aria-valuenow", "100");
        stepLabel.textContent = "Result";
        stepCount.textContent = "Complete";
        renderResult();
      }

      function next() {
        if (state.step + 1 >= steps.length) {
          showResult();
          return;
        }
        state.step += 1;
        render();
      }

      function back() {
        if (state.step <= 0) return;
        state.step -= 1;
        render();
      }

      continueButton.addEventListener("click", function () {
        publish("daily_vital_continue_click", { step_id: steps[state.step].id });
        next();
      });

      backButton.addEventListener("click", function () {
        publish("daily_vital_back_click", { from_step: steps[state.step].id });
        back();
      });

      root.querySelector("[data-hdc-cta]").addEventListener("click", function () {
        publish("daily_vital_offer_click", { result_type: topSignal(), funnel_step: "pdp_handoff" });
      });

      render();
    }

    roots.forEach(setup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hume-band-daily-vital-check"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll("[data-hume-daily-check]");
    if (!roots.length) return;

    var steps = [
      {
        id: "age",
        label: "Question 1",
        type: "single",
        kicker: "Daily Vital Check",
        title: "How old are you?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "Under 35", score: { resilience: 1 } },
          { text: "35-44", score: { resilience: 1, load: 1 } },
          { text: "45-54", score: { load: 2 } },
          { text: "55-64", score: { load: 3 } },
          { text: "65 or older", score: { load: 4 } }
        ]
      },
      {
        id: "signals",
        label: "Question 2",
        type: "multi",
        kicker: "Choose all that apply",
        title: "Which hidden body signals have you noticed lately?",
        subtitle: "Choose all that apply.",
        options: [
          { text: "Waking up tired even after enough sleep", score: { sleep: 3, load: 1 }, concern: "unrefreshing sleep" },
          { text: "Afternoon energy crash or brain fog", score: { recovery: 2, load: 1 }, concern: "energy dips" },
          { text: "Stress feels like it stays in my body", score: { stress: 3, load: 1 }, concern: "stress load" },
          { text: "I do not know when to push or rest", score: { recovery: 3 }, concern: "recovery confusion" },
          { text: "Heart, HRV, or BP trends feel hard to read", score: { heart: 3 }, concern: "heart trend clarity" },
          { text: "My wearable gives numbers, not next steps", score: { data: 3 }, concern: "data without direction" }
        ]
      },
      {
        id: "wearable",
        label: "Question 3",
        type: "single",
        kicker: "Current tracking",
        title: "What are you using to track your health right now?",
        subtitle: "This helps us understand whether your gap is measurement, interpretation, or consistency.",
        options: [
          { text: "Apple Watch", score: { data: 3 }, wearable: "Apple Watch" },
          { text: "Oura Ring", score: { data: 3 }, wearable: "Oura Ring" },
          { text: "WHOOP", score: { data: 3 }, wearable: "WHOOP" },
          { text: "Garmin or Fitbit", score: { data: 2, consistency: 1 }, wearable: "Garmin or Fitbit" },
          { text: "Another wearable", score: { data: 2 }, wearable: "another wearable" },
          { text: "Nothing consistently", score: { consistency: 3 }, wearable: "no consistent tracker" }
        ]
      },
      {
        id: "duration",
        label: "Question 4",
        type: "single",
        kicker: "Pattern length",
        title: "How long have these signals felt unclear?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "Just started recently", score: { resilience: 1 } },
          { text: "A few months", score: { load: 1 } },
          { text: "Around a year", score: { load: 2 } },
          { text: "Several years", score: { load: 3 } },
          { text: "I cannot remember when it started", score: { load: 4 } }
        ]
      },
      {
        id: "reassurance",
        label: "Checkpoint",
        type: "info",
        kicker: "You are in the right place",
        title: "Thousands of people are tracking health data but still missing the pattern.",
        subtitle: "If your biggest issue is @mainConcern, the next step is not more random numbers. It is seeing how sleep, stress, heart trends, recovery, and habits connect."
      },
      {
        id: "sleep",
        label: "Question 5",
        type: "single",
        kicker: "Sleep signal",
        title: "What best describes your sleep lately?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "I sleep enough but still wake up tired", score: { sleep: 3, load: 1 } },
          { text: "My sleep varies a lot night to night", score: { sleep: 2, consistency: 1 } },
          { text: "Stress clearly affects my sleep", score: { stress: 2, sleep: 1 } },
          { text: "I mostly sleep fine", score: { resilience: 1 } },
          { text: "I do not know what my sleep data means", score: { data: 3 } }
        ]
      },
      {
        id: "conditions",
        label: "Question 6",
        type: "multi",
        kicker: "Choose all that apply",
        title: "Which wellness areas do you want more context around?",
        subtitle: "Choose all that apply.",
        options: [
          { text: "Blood pressure wellness trends", score: { heart: 3 } },
          { text: "HRV and resting heart rate", score: { heart: 2, recovery: 1 } },
          { text: "Stress and nervous system load", score: { stress: 3 } },
          { text: "Sleep quality and sleep stages", score: { sleep: 3 } },
          { text: "Recovery after workouts or long days", score: { recovery: 3 } },
          { text: "Long-term health direction", score: { longevity: 3 } }
        ]
      },
      {
        id: "noise",
        label: "Question 7",
        type: "single",
        kicker: "Data overload",
        title: "How does your current wearable usually leave you feeling?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "I see scores but do not know what to do", score: { data: 4 } },
          { text: "I only check it when something feels off", score: { consistency: 2, data: 1 } },
          { text: "I like the data, but it feels disconnected", score: { data: 3 } },
          { text: "It helps, but I want a clearer daily focus", score: { recovery: 1, data: 2 } },
          { text: "I mostly ignore the app", score: { consistency: 3 } }
        ]
      },
      {
        id: "profile",
        label: "Profile",
        type: "profile",
        kicker: "Your Daily Vital Profile",
        title: "Your disconnected signal assessment",
        subtitle: "Based on your answers, your body signals may be creating more noise than direction."
      },
      {
        id: "doctor",
        label: "Question 8",
        type: "multi",
        kicker: "Choose all that apply",
        title: "What have you already tried to make sense of your health data?",
        subtitle: "Choose all that apply.",
        options: [
          { text: "Checking wearable scores every morning", score: { data: 2 } },
          { text: "Changing sleep or bedtime habits", score: { sleep: 1, consistency: 1 } },
          { text: "Adjusting workouts based on recovery", score: { recovery: 2 } },
          { text: "Meditation, breathwork, or stress tools", score: { stress: 2 } },
          { text: "Reading articles or watching health content", score: { data: 1 } },
          { text: "Nothing consistently yet", score: { consistency: 3 } }
        ]
      },
      {
        id: "education",
        label: "Why it happens",
        type: "education",
        kicker: "Here is why your numbers can still feel confusing",
        title: "Most wearables manage the symptom: more tracking. They do not solve the real gap: connected direction.",
        subtitle: ""
      },
      {
        id: "routine",
        label: "Question 9",
        type: "single",
        kicker: "Daily routine",
        title: "How much time can you spare for a health check each day?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "Under 30 seconds", score: { consistency: 3 } },
          { text: "About 1 minute", score: { consistency: 2 } },
          { text: "2-5 minutes", score: { resilience: 1 } },
          { text: "10+ minutes", score: { resilience: 1 } },
          { text: "I do not have a routine", score: { consistency: 3, load: 1 } }
        ]
      },
      {
        id: "worry",
        label: "Question 10",
        type: "single",
        kicker: "Motivation",
        title: "How concerned are you about missing important health signals?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "Very concerned - I think about it often", score: { load: 3 } },
          { text: "Concerned when my numbers look off", score: { load: 2, data: 1 } },
          { text: "Somewhat concerned", score: { load: 1 } },
          { text: "Not worried yet, but I want better direction", score: { longevity: 2 } }
        ]
      },
      {
        id: "meaning",
        label: "Question 11",
        type: "single",
        kicker: "Goal",
        title: "If your daily signals finally made sense, what would it mean to you?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "Wake up knowing what my body needs today", score: { sleep: 1, recovery: 2 }, goal: "daily direction" },
          { text: "Stop guessing when to push or recover", score: { recovery: 3 }, goal: "recovery clarity" },
          { text: "Understand stress before it runs me down", score: { stress: 3 }, goal: "stress clarity" },
          { text: "Feel confident my long-term habits are working", score: { longevity: 3 }, goal: "long-term direction" },
          { text: "Spend less time decoding my app", score: { data: 3 }, goal: "less data overload" }
        ]
      },
      {
        id: "event",
        label: "Question 12",
        type: "single",
        kicker: "Timeline",
        title: "When would you most want clearer health direction?",
        subtitle: "Selecting an option will navigate to the next step.",
        options: [
          { text: "This week", score: { consistency: 2 }, event: "this week" },
          { text: "Before my next busy work stretch", score: { stress: 2 }, event: "your next high-stress week" },
          { text: "Before my next training block", score: { recovery: 2 }, event: "your next training block" },
          { text: "Over the next 30 days", score: { longevity: 1 }, event: "the next 30 days" },
          { text: "I just want to start now", score: { data: 1 }, event: "today" }
        ]
      }
    ];

    var resultProfiles = {
      sleep: {
        title: "You are just one connected sleep-recovery read away from clearer mornings.",
        copy: "Your answers point to sleep quality and next-day recovery as the signal that deserves the most attention first.",
        now: [["Sleep signal", "Unclear"], ["Recovery", "Hard to predict"], ["Morning direction", "Low"], ["Pattern confidence", "Spotty"]],
        goal: [["Sleep signal", "Connected"], ["Recovery", "Easier to read"], ["Morning direction", "Clearer"], ["Pattern confidence", "Building"]],
        timelineOne: "First 7 days: start seeing how sleep, HRV, and recovery move together.",
        timelineTwo: "By @event: use your daily read to know whether to push, rest, or adjust."
      },
      stress: {
        title: "You are just one stress-load pattern away from catching the signal earlier.",
        copy: "Your answers suggest stress may be showing up in sleep, HRV, recovery, and energy before it feels obvious.",
        now: [["Stress load", "Hard to see"], ["HRV context", "Disconnected"], ["Recovery", "Reactive"], ["Daily focus", "Unclear"]],
        goal: [["Stress load", "Visible"], ["HRV context", "Connected"], ["Recovery", "More proactive"], ["Daily focus", "Clearer"]],
        timelineOne: "First 7 days: watch how stressful days change sleep and recovery signals.",
        timelineTwo: "By @event: spot the days where your body may need a lighter plan."
      },
      recovery: {
        title: "You are just one push-or-rest signal away from less guessing.",
        copy: "Your answers point to recovery direction as the main gap. The problem is not effort. It is knowing when effort is helping.",
        now: [["Readiness", "Guesswork"], ["Activity", "Separate"], ["Sleep debt", "Easy to miss"], ["Training choices", "Reactive"]],
        goal: [["Readiness", "Contextual"], ["Activity", "Connected"], ["Sleep debt", "Visible"], ["Training choices", "More intentional"]],
        timelineOne: "First 7 days: connect activity, sleep, and HRV into a clearer recovery read.",
        timelineTwo: "By @event: make push-or-rest decisions with less second-guessing."
      },
      heart: {
        title: "You are just one heart-trend read away from clearer context.",
        copy: "Your answers suggest you want more than one-off numbers. You want to understand how heart-related wellness trends fit the bigger pattern.",
        now: [["Heart trends", "One-off"], ["BP wellness", "Hard to contextualize"], ["HRV", "Isolated"], ["Confidence", "Low"]],
        goal: [["Heart trends", "Tracked over time"], ["BP wellness", "In context"], ["HRV", "Connected"], ["Confidence", "Improving"]],
        timelineOne: "First 7 days: start connecting heart, HRV, sleep, and recovery trends.",
        timelineTwo: "By @event: have a clearer wellness trend picture to follow or discuss."
      },
      longevity: {
        title: "You are just one long-term signal away from knowing if your habits are working.",
        copy: "Your answers suggest daily scores are not enough. You want to know whether your routine is moving your bigger health direction.",
        now: [["Daily scores", "Short-term"], ["Health direction", "Fuzzy"], ["Habit feedback", "Delayed"], ["Momentum", "Unknown"]],
        goal: [["Daily scores", "Part of a trend"], ["Health direction", "Clearer"], ["Habit feedback", "Faster"], ["Momentum", "Visible"]],
        timelineOne: "First 7 days: create a baseline across sleep, recovery, activity, and heart trends.",
        timelineTwo: "By @event: start seeing whether your routine is moving in the right direction."
      },
      data: {
        title: "You are just one connected read away from escaping data overload.",
        copy: "Your answers suggest your biggest gap is interpretation. You may already have data, but not the daily direction it should create.",
        now: [["Health data", "Scattered"], ["Next step", "Unclear"], ["App fatigue", "High"], ["Confidence", "Low"]],
        goal: [["Health data", "Connected"], ["Next step", "Clearer"], ["App fatigue", "Lower"], ["Confidence", "Building"]],
        timelineOne: "First 7 days: see which signal deserves attention first instead of chasing every metric.",
        timelineTwo: "By @event: use a simpler daily read instead of decoding another dashboard."
      },
      consistency: {
        title: "You are just one consistent wearable routine away from a cleaner signal.",
        copy: "Your answers suggest the issue may be missing data gaps, charging friction, or not having a simple reason to check in daily.",
        now: [["Wear time", "Inconsistent"], ["Night data", "Easy to miss"], ["Daily habit", "Loose"], ["Signal quality", "Patchy"]],
        goal: [["Wear time", "More consistent"], ["Night data", "Captured"], ["Daily habit", "Simple"], ["Signal quality", "Cleaner"]],
        timelineOne: "First 7 days: build a steadier baseline with a wearable designed for longer, simpler use.",
        timelineTwo: "By @event: make daily tracking feel easier to maintain."
      }
    };

    function setup(root) {
      var state = {
        step: 0,
        scores: { sleep: 0, stress: 0, recovery: 0, heart: 0, longevity: 0, data: 0, consistency: 0, load: 0, resilience: 0 },
        answers: {},
        selected: [],
        mainConcern: "disconnected signals",
        wearable: "unknown",
        goal: "daily direction",
        event: "the next 30 days",
        startedAt: Date.now()
      };

      var card = root.querySelector("[data-hdc-card]");
      var kicker = root.querySelector("[data-hdc-kicker]");
      var title = root.querySelector("[data-hdc-title]");
      var subtitle = root.querySelector("[data-hdc-subtitle]");
      var options = root.querySelector("[data-hdc-options]");
      var continueButton = root.querySelector("[data-hdc-continue]");
      var backButton = root.querySelector("[data-hdc-back]");
      var progress = root.querySelector("[data-hdc-progress]");
      var progressBar = root.querySelector("[data-hdc-progress-bar]");
      var stepLabel = root.querySelector("[data-hdc-step-label]");
      var stepCount = root.querySelector("[data-hdc-step-count]");
      var profile = root.querySelector("[data-hdc-profile]");
      var education = root.querySelector("[data-hdc-education]");
      var result = root.querySelector("[data-hdc-result]");
      var actions = root.querySelector("[data-hdc-actions]");

      function slug(value) {
        return String(value || "unknown").toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
      }

      function publish(eventName, detail) {
        var payload = Object.assign({
          quiz_id: "hume_daily_vital_check",
          quiz_version: root.getAttribute("data-quiz-version") || "unknown",
          page_path: window.location.pathname,
          step_id: steps[state.step] ? steps[state.step].id : "result"
        }, detail || {});
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: eventName, hume_daily_vital_check: payload });
        if (typeof window.gtag === "function") {
          window.gtag("event", eventName, payload);
        }
      }

      function resetScores() {
        state.scores = { sleep: 0, stress: 0, recovery: 0, heart: 0, longevity: 0, data: 0, consistency: 0, load: 0, resilience: 0 };
        state.mainConcern = "disconnected signals";
        state.wearable = "unknown";
        state.goal = "daily direction";
        state.event = "the next 30 days";
        steps.forEach(function (step) {
          var saved = state.answers[step.id] || [];
          saved.forEach(function (index) {
            var option = step.options && step.options[index];
            if (!option) return;
            Object.keys(option.score || {}).forEach(function (key) {
              state.scores[key] += option.score[key];
            });
            if (option.concern) state.mainConcern = option.concern;
            if (option.wearable) state.wearable = option.wearable;
            if (option.goal) state.goal = option.goal;
            if (option.event) state.event = option.event;
          });
        });
      }

      function topSignal() {
        var keys = ["sleep", "stress", "recovery", "heart", "longevity", "data", "consistency"];
        var winner = keys[0];
        keys.forEach(function (key) {
          if (state.scores[key] > state.scores[winner]) winner = key;
        });
        if (state.scores.data >= state.scores[winner] - 1 && state.wearable !== "no consistent tracker") {
          winner = "data";
        }
        return winner;
      }

      function level() {
        var net = Math.max(0, state.scores.load - state.scores.resilience);
        if (net <= 1) return { label: "Low", marker: "12%", disconnect: "Low", recovery: "Clearer", direction: "Available", potential: "High" };
        if (net <= 3) return { label: "Moderate", marker: "50%", disconnect: "Moderate", recovery: "Mixed", direction: "Needs focus", potential: "Very high" };
        if (net <= 5) return { label: "High", marker: "73%", disconnect: "High", recovery: "Hard to read", direction: "Low", potential: "High" };
        return { label: "Very high", marker: "91%", disconnect: "Very high", recovery: "Reactive", direction: "Very low", potential: "High" };
      }

      function replaceTokens(text) {
        return String(text || "").replace(/@mainConcern/g, state.mainConcern).replace(/@event/g, state.event).replace(/@goal/g, state.goal);
      }

      function clearSpecialViews() {
        profile.hidden = true;
        education.hidden = true;
        result.hidden = true;
      }

      function updateProgress() {
        var percent = Math.round((state.step / Math.max(1, steps.length)) * 100);
        progressBar.style.width = percent + "%";
        progress.setAttribute("aria-valuenow", String(percent));
        stepLabel.textContent = steps[state.step] ? steps[state.step].label : "Result";
        stepCount.textContent = Math.min(state.step + 1, steps.length) + " of " + steps.length;
        backButton.hidden = state.step === 0;
      }

      function renderOptions(step) {
        options.innerHTML = "";
        if (!step.options) return;
        var selected = state.answers[step.id] || [];
        step.options.forEach(function (option, index) {
          var button = document.createElement("button");
          button.type = "button";
          button.className = "hdc-option";
          if (selected.indexOf(index) !== -1) button.classList.add("is-selected");
          button.setAttribute("aria-pressed", selected.indexOf(index) !== -1 ? "true" : "false");

          var number = document.createElement("span");
          number.className = "hdc-option-number";
          number.textContent = String(index + 1);
          var text = document.createElement("span");
          text.textContent = option.text;
          button.appendChild(number);
          button.appendChild(text);

          button.addEventListener("click", function () {
            if (step.type === "multi") {
              var current = state.answers[step.id] || [];
              var pos = current.indexOf(index);
              if (pos === -1) current.push(index);
              else current.splice(pos, 1);
              state.answers[step.id] = current;
              resetScores();
              renderOptions(step);
              continueButton.hidden = current.length === 0;
              publish("daily_vital_answer_select", { question_id: step.id, answer: option.text, multi_select: true });
            } else {
              state.answers[step.id] = [index];
              resetScores();
              publish("daily_vital_answer_select", { question_id: step.id, answer: option.text, multi_select: false });
              window.setTimeout(next, 150);
            }
          });
          options.appendChild(button);
        });
      }

      function renderProfile() {
        var signalLevel = level();
        root.querySelector("[data-hdc-profile-level]").textContent = signalLevel.label;
        root.querySelector("[data-hdc-profile-disconnect]").textContent = signalLevel.disconnect;
        root.querySelector("[data-hdc-profile-recovery]").textContent = signalLevel.recovery;
        root.querySelector("[data-hdc-profile-direction]").textContent = signalLevel.direction;
        root.querySelector("[data-hdc-profile-potential]").textContent = signalLevel.potential;
        root.querySelector("[data-hdc-meter-marker]").style.setProperty("--marker", signalLevel.marker);
        profile.hidden = false;
      }

      function fillList(target, rows) {
        target.innerHTML = "";
        rows.forEach(function (row) {
          var li = document.createElement("li");
          var span = document.createElement("span");
          var strong = document.createElement("strong");
          span.textContent = row[0];
          strong.textContent = row[1];
          li.appendChild(span);
          li.appendChild(strong);
          target.appendChild(li);
        });
      }

      function ctaUrl(profileData) {
        var base = root.getAttribute("data-cta-url") || "https://humehealth.com/pages/hume-bandv2";
        var separator = base.indexOf("?") === -1 ? "?" : "&";
        var params = [
          ["utm_source", "thewearabletech"],
          ["utm_medium", "quiz"],
          ["utm_campaign", "daily_vital_check"],
          ["utm_content", slug(profileData.title)],
          ["utm_term", slug(topSignal())],
          ["quiz_result", slug(profileData.title)],
          ["quiz_signal", slug(topSignal())],
          ["quiz_wearable", slug(state.wearable)],
          ["quiz_goal", slug(state.goal)]
        ];
        return base + separator + params.map(function (pair) {
          return encodeURIComponent(pair[0]) + "=" + encodeURIComponent(pair[1]);
        }).join("&");
      }

      function renderResult() {
        var profileData = resultProfiles[topSignal()] || resultProfiles.data;
        root.querySelector("[data-hdc-result-title]").textContent = replaceTokens(profileData.title);
        root.querySelector("[data-hdc-result-copy]").textContent = replaceTokens(profileData.copy);
        root.querySelector("[data-hdc-timeline-one]").textContent = replaceTokens(profileData.timelineOne);
        root.querySelector("[data-hdc-timeline-two]").textContent = replaceTokens(profileData.timelineTwo);
        fillList(root.querySelector("[data-hdc-now-list]"), profileData.now);
        fillList(root.querySelector("[data-hdc-goal-list]"), profileData.goal);
        root.querySelector("[data-hdc-cta]").setAttribute("href", ctaUrl(profileData));
        result.hidden = false;
        publish("daily_vital_result_view", {
          result_type: topSignal(),
          cta_url: ctaUrl(profileData),
          completion_seconds: Math.round((Date.now() - state.startedAt) / 1000)
        });
      }

      function render() {
        var step = steps[state.step];
        clearSpecialViews();
        options.innerHTML = "";
        continueButton.hidden = step.type === "single";
        actions.hidden = false;
        kicker.textContent = step.kicker || "";
        title.textContent = replaceTokens(step.title);
        subtitle.textContent = replaceTokens(step.subtitle);
        card.scrollTop = 0;

        if (step.type === "single" || step.type === "multi") {
          renderOptions(step);
          if (step.type === "multi") continueButton.hidden = !(state.answers[step.id] || []).length;
        }

        if (step.type === "info") {
          continueButton.hidden = false;
        }

        if (step.type === "profile") {
          renderProfile();
          continueButton.hidden = false;
        }

        if (step.type === "education") {
          education.hidden = false;
          continueButton.hidden = false;
        }

        updateProgress();
        publish("daily_vital_step_view", { step_id: step.id, step_type: step.type, step_number: state.step + 1 });
      }

      function showResult() {
        clearSpecialViews();
        options.innerHTML = "";
        actions.hidden = true;
        title.textContent = "";
        subtitle.textContent = "";
        kicker.textContent = "";
        progressBar.style.width = "100%";
        progress.setAttribute("aria-valuenow", "100");
        stepLabel.textContent = "Result";
        stepCount.textContent = "Complete";
        renderResult();
      }

      function next() {
        if (state.step + 1 >= steps.length) {
          showResult();
          return;
        }
        state.step += 1;
        render();
      }

      function back() {
        if (state.step <= 0) return;
        state.step -= 1;
        render();
      }

      continueButton.addEventListener("click", function () {
        publish("daily_vital_continue_click", { step_id: steps[state.step].id });
        next();
      });

      backButton.addEventListener("click", function () {
        publish("daily_vital_back_click", { from_step: steps[state.step].id });
        back();
      });

      root.querySelector("[data-hdc-cta]").addEventListener("click", function () {
        publish("daily_vital_offer_click", { result_type: topSignal(), funnel_step: "pdp_handoff" });
      });

      render();
    }

    roots.forEach(setup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hume-band-sleep-calculator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll("[data-hbs-calculator]");
    roots.forEach((root) => {
      let mode = "wake";
      const timeLabel = root.querySelector("[data-hbs-time-label]");
      const targetTime = root.querySelector("[data-hbs-time]");
      const fallAsleep = root.querySelector("[data-hbs-fall-asleep]");
      const cycles = root.querySelector("[data-hbs-cycles]");
      const modeButtons = root.querySelectorAll("[data-hbs-mode]");
      const reset = root.querySelector("[data-hbs-reset]");
      const resultLabel = root.querySelector("[data-hbs-result-label]");
      const primaryResult = root.querySelector("[data-hbs-primary-result]");
      const resultDetail = root.querySelector("[data-hbs-result-detail]");
      const cycleResult = root.querySelector("[data-hbs-cycle-result]");
      const sleepResult = root.querySelector("[data-hbs-sleep-result]");
      const windowResult = root.querySelector("[data-hbs-window-result]");

      const parseTime = (value) => {
        const parts = (value || "06:30").split(":").map(Number);
        return parts[0] * 60 + parts[1];
      };
      const wrap = (minutes) => ((minutes % 1440) + 1440) % 1440;
      const time = (minutes) => {
        const wrapped = wrap(minutes);
        const hours24 = Math.floor(wrapped / 60);
        const mins = wrapped % 60;
        const period = hours24 >= 12 ? "PM" : "AM";
        const hours12 = hours24 % 12 || 12;
        return `${hours12}:${String(mins).padStart(2, "0")} ${period}`;
      };
      const duration = (minutes) => `${Math.floor(minutes / 60)}h ${minutes % 60}m`;
      const compactWindow = (center) => `${time(center - 30).replace(" AM", "").replace(" PM", "")}-${time(center + 30).replace(" AM", "").replace(" PM", "")}`;

      const calculate = () => {
        const base = parseTime(targetTime.value);
        const sleepMinutes = Number(cycles.value) * 90;
        const totalMinutes = sleepMinutes + Number(fallAsleep.value);
        const resultMinutes = mode === "wake" ? base - totalMinutes : base + totalMinutes;
        const baseLabel = mode === "wake" ? "wake-up" : "bedtime";
        resultLabel.textContent = mode === "wake" ? "Suggested bedtime" : "Suggested wake-up";
        primaryResult.textContent = time(resultMinutes);
        resultDetail.textContent = `That gives you ${cycles.value} full cycles, or about ${duration(sleepMinutes)} asleep, from a ${time(base)} ${baseLabel}.`;
        cycleResult.textContent = cycles.value;
        sleepResult.textContent = duration(sleepMinutes);
        windowResult.textContent = compactWindow(resultMinutes);
      };

      const setMode = (nextMode) => {
        mode = nextMode;
        modeButtons.forEach((button) => button.setAttribute("aria-pressed", String(button.dataset.hbsMode === mode)));
        timeLabel.textContent = mode === "wake" ? "Wake-up time" : "Bedtime";
        targetTime.value = mode === "wake" ? "06:30" : "22:30";
        calculate();
      };

      modeButtons.forEach((button) => button.addEventListener("click", () => setMode(button.dataset.hbsMode)));
      [targetTime, fallAsleep, cycles].forEach((field) => field.addEventListener("input", calculate));
      [fallAsleep, cycles].forEach((field) => field.addEventListener("change", calculate));
      reset.addEventListener("click", () => {
        fallAsleep.value = "15";
        cycles.value = "5";
        setMode("wake");
      });
      calculate();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
